import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useBarnsWithHorses } from "components/Location/useBarnsWithHorses";
import { mapPropsAreEqual } from "components/MapComponents/mapPropsAreEqual";

import useStyles from "./styles";

interface Props {
  containerSize: {
    width: number;
    height: number;
  };
  horses: racehorse360.IHorse[];
  mapRootRef: React.RefObject<SVGGElement>;
  clipPathRef: React.RefObject<SVGRectElement>;
  svgContainerRef: React.RefObject<HTMLDivElement>;
  handleGroupClick?: (e: React.MouseEvent) => void;
  isPreview?: boolean;
}

const LaurelParkMap = (props: Props) => {
  const {
    mapRootRef,
    containerSize,
    svgContainerRef,
    clipPathRef,
    handleGroupClick,
    horses,
    isPreview
  } = props;

  const stylesProps = { isPreview };
  const classes = useStyles(stylesProps);

  const barnsWithHorses = useBarnsWithHorses(horses);

  return (
    <div ref={svgContainerRef}>
      <svg
        width={containerSize.width}
        height={containerSize.height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1848 1063"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              ref={clipPathRef}
              className={classes.cls1}
              width="1852"
              height="1060"
            />
          </clipPath>
        </defs>
        <g ref={mapRootRef}>
          <g id="stables-off">
            <g>
              <g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M2.8,633.4c-0.1,2.5-0.2,5-0.3,7.4c0.6-0.4,1.3-0.7,1.9-1.1C3.3,637.9,2.8,635.6,2.8,633.4z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M133.2,573.9C133.8,574.6,133.9,574.1,133.2,573.9L133.2,573.9z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M2.9,629c0,0.9-0.1,1.8-0.1,2.7c0.1-0.9,0.3-1.8,0.6-2.6C3.3,629.1,3.1,629,2.9,629z"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls0}
                    points="755.2,596 782.2,592.8 755.1,595.9 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls0}
                    points="705.9,601.6 697.1,602.8 705.9,601.8 			"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M547,1208.4c-18.5-0.6-37.1-1.6-55.6-0.8c-13.4,0.6-26.1,3.1-38.9,6.1h216.8c-21.9-1.1-43.7-2.1-65.6-3
				C584.8,1209.8,565.9,1209,547,1208.4z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M2045.8-80.8H364.4c13.2,6.8,31.1,15.6,53.8,25.4c49.7,21.6,133.1,53,247.9,80.3
				c129,30.6,270.7,49.8,420.9,57c185.3,8.9,384.4-0.6,591.9-28.1c-41.3-78.3-41.3-119.4-41.3-121.2l6,0.1l6,0
				c0,0.4,0.3,42.9,43.8,122.8c25.6,47,60.9,97.6,105,150.2c21.9,26.2,46,53,72.2,80.2l64.6-38.9l6.2,10.3l-62.2,37.5
				c37.4,38.4,78.9,77.6,124.2,117.3l-7.9,9c-46.3-40.6-88.6-80.7-126.8-120l-383.3,231.2c0.3,0,0.7,0,1.1,0
				c14.4,0.9,26.6,7.7,35.2,19.2c3.4,4.6-1.2,11.5-6.5,11.3c-6.8-0.3-11.8,4.6-14.3,10.6c-3.1,7.6-1.1,16,1.7,23.4
				c3.5,9.3,8.7,18,13.3,26.8c4.9,9.3,9.7,18.6,14.6,28c4,7.6,7.5,16.7,13.7,22.9c6,6.1,14.9,7.2,23.1,7.9
				c20.9,1.7,41.9,2.4,62.8,2.4c10.5,0,21.1-0.2,31.6-0.5c9.3-0.3,19-0.2,28-3.1c7.8-2.5,13.4-8.2,17.9-14.8
				c5.3-7.8,10-16.1,14.6-24.3c9.6-17.1,19.8-35.1,25.9-53.8c3-9,3.1-17.3-1.6-25.7c-4.6-8.1-11-15.2-16.9-22.4
				c-6.5-8.1-13-16.2-19.6-24.3c-5.7-7.1-11.6-14.1-15.2-22.5c-3.6-8.5-4.1-17.8,0.2-26.2c3.9-7.6,10.8-13.2,17.3-18.4
				c13.9-11,28.8-20.9,44.7-28.8c31.1-15.6,66.3-24.7,101.2-20.4c17.4,2.2,35.3,6.9,49.2,18.1c14.1,11.4,20.6,29.6,26.7,46
				c13.5,36.3,21.5,74.5,25.9,112.9c9.3,79.7,2.5,159.9-4,239.4c-3.4,41.8-6.8,83.6-7.7,125.6c-0.8,35.1,2.8,70.7-2.1,105.6
				c-2.2,15.4-6.4,30.7-14.4,44.2c-7,11.7-23.7,34.1-37.2,17.2c-5.2-6.5-9.5-13.7-14.2-20.5c-5-7.2-10.1-14.3-15.2-21.4
				c-10.2-14.1-20.7-28-31.5-41.7c-43.3-55.1-90.6-107.1-141.4-155.4c-50.3-47.9-104-92.2-160.6-132.5
				c-57.2-40.6-117.3-77-179.7-108.9c-4.3-2.2-4.8-8.4-1.6-11.7c-0.2-0.8-0.2-1.7-0.1-2.6L920.9,872.7c2.1-0.6,4.3-0.6,6.4-0.1
				c1.1-2.4,2.9-4.5,5.5-5.6c0.1,0,0.1-0.1,0.2-0.1c6.3-3.7,13.1-1,17.1,4.5c5.5,7.5,11,14.9,16.4,22.4
				c10.9,14.9,21.8,29.9,32.9,44.8c9.7,13,20.1,25.2,32.7,35.5c6.5,5.3,12.7,10.6,17.4,17.6c5.1,7.5,7.9,16.4,11.1,24.8
				c6.7,17.8,13.4,35.5,20.1,53.3s13.4,35.5,20.1,53.3c6.4,17.1,13.4,34.1,18.1,51.8c3.2,12,6.9,27.8,0.2,38.8h926.9V-80.8z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M25.7,656.5c-2.2,1.1-4.5,2.3-6.7,3.5c2.8-0.6,5.7-1,8.5-1.4C26.9,658,26.2,657.3,25.7,656.5z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M1480.2,535.4l-9.2,5.6c2.8-1.3,5.7-2.6,8.5-3.9C1479.6,536.4,1479.9,535.9,1480.2,535.4z"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls0}
                    points="1775.6,259.5 1775.6,259.5 1793,253.8 			"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M127,572.7c0.1,0.1,0.1,0.3,0.2,0.4c0.1-0.1,0.1-0.2,0.2-0.3C127.2,572.8,127.1,572.8,127,572.7z"
                  />
                </g>
                <g>
                  <rect
                    x="1533.7"
                    y="361.6"
                    transform="matrix(0.4662 -0.8847 0.8847 0.4662 507.3219 1563.9556)"
                    className={classes.cls0}
                    width="31.9"
                    height="0"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls0}
                    d="M372.4,1209.4c-2.8-4.8-1.9-11.9,2.4-15.7c1.7-2.2,4.1-4,6.8-5.1c7.4-2.9,14.7-6,21.9-9.1
				c1.4-5.2,6.3-9.2,12.1-9.3c3-0.1,6.1-0.1,9.1-0.2c11.7-5.5,23.2-11.1,34.7-17c12.2-10.7,25.3-20.3,38.9-29.2l-4.5-7.5l1366.2-824
				c-26-27.1-50-53.8-71.8-80c-42.9-51.5-77.6-101-103.2-147.3c-159.3,21.3-313.8,32.1-461,32.1c-46.8,0-92.8-1.1-138.1-3.3
				c-151.1-7.2-293.5-26.6-423.3-57.4C547,8.9,463-22.9,412.9-44.6c-37.4-16.2-61.7-29.3-73.6-36.2h-468.5V91.7
				c6.6-0.1,13.1-0.1,19.7-0.2l33.8-113.5L816.9,96.4c11.2,0.9,126.6,11.6,186,91.8c33.4,45.1,42.3,102.6,26.4,170.8
				c-0.8,3.5-14.9,62-66.9,116.2c-30.8,32.1-68.5,56.1-112.2,71.3c-37.5,13.1-79.3,19.6-125,19.6c-19.7,0-40.2-1.2-61.3-3.7
				l-0.6-0.1l-672-99c0,0,0,0,0,0c-7.4,9.9-13.9,20.4-19.2,31.6c-2.4,5-4.4,10.1-6.2,15.3c-1,2.9-1.9,5.9-2.8,8.8
				c1.2,0.3,2.3,0.6,3.5,0.9c4.3,1.1,8.6,2.2,12.9,3.2c8,1.9,16.1,3.5,24.2,5.1c16.8,3.2,33.8,5.8,50.8,8.3
				c15.1,2.2,30.2,4.3,45.3,6.5c8.2,1.2,16.3,2.5,24.5,3.9c6.8,1.1,14.5,1.5,20.6,4.8c8.7,4.6,11.8,14.3,9.2,23.5
				c-1.7,6.3-6.1,11.6-9.9,16.8c-8.7,11.9-17.9,23.5-27.7,34.6c-9.4,10.7-19.3,21.1-29.7,30.9c-6.7,6.4-13.5,12.7-21.3,17.2
				c1,0.5,2.1,1.2,3.1,2c1.5,1.2,2.3,3.1,2.5,5c2.6,3.2,3.3,7.9-0.6,11.6c-5,4.8-10.7,8.8-17,11.6c-20.5,18.9-45,33.3-71.5,42.2
				c-8.1,2.7-16.4,4.9-24.8,6.4c-7.9,1.5-17,3.7-24.9,1.5c-9.3-2.5-14.1-11.7-10.9-20.9c2.7-7.8,9.7-14.1,17.8-15.8
				c5.7-4.5,11.5-8.7,17.5-12.7c-2.1-2.9-3-6.6-2-10.3c12.8-45.8,18.5-93.1,17-140.7c-0.1-2.5,0.9-5.1,2.5-7.3
				c-0.5-0.1-0.9-0.2-1.4-0.3c-8-1.8-16.5-3.4-24.1-6.3c-5.6-2.1-10.2-6-11.8-12c-1.1-4.3-0.1-8.9,1-13c2-7.5,4.5-14.8,7.4-22
				c5-12.2,11-23.8,18.2-34.7l-93-13.7v768h505.7C374.9,1212.6,373.5,1211.2,372.4,1209.4z M627.5,977.6l-5.8,17.6l-19.7-5.5
				l-1.4-7.5l6.2-16.5l20.7,5.1V977.6z M749.2,906.4l-9.6,39l-132.4-29.2l-2-9.8l12.2-36.7l131.8,29.1V906.4z M908.9,821.3
				L896.8,851l-151.5-49.8V794l14.3-30.2l76.8,24.4l2.2-3.7l16.1,5.1v5.2l54.2,16.4V821.3z M971.6,784.5l-9.9,24.7L771,747.1v-7.9
				l11.9-24l188.7,61.7V784.5z M1108.1,697.2l-7.3,21.7l-234.5-70v-8.4l13.2-25.8l229.9,70L1108.1,697.2z M1221,587.1l-5.9,14.3
				l-64.7-19.2l-1.2-6.3l8.4-13.6l63.5,17.4V587.1z M1263.5,568.9l-5.9,14.3l-124-37.8l-1.2-6.3l8.4-13.6l122.8,36.1V568.9z
				 M1336.3,552.3l-9,20.8L1119,513.8l-2-7.1l14.1-21.7l206.3,57.5L1336.3,552.3z M1153.5,237.2l0.9-13.5l80.5,1.2l10.6,88.2
				l-1.5,11l-84.9-1.4L1153.5,237.2z M1398.8,508.6l-9.6,20.5L1163,456.3l-1.8-7.1l14.7-21.2l224.2,71L1398.8,508.6z M1417.8,450.5
				l-9.6,20.5l-40.6-13.1c-0.6,1.1-3.6,5.2-10.2,3.7c0,0-10.3-2.1-9.8-10.1l-109-35.1l0,0c0,0-2.8,5.7-10.5,3.9
				c0,0-10.5-2.1-10-10.2l-0.1-0.3l-36.1-11.6l-1.8-7.1l14.7-21.2l224.2,71L1417.8,450.5z M1426.5,431.2l-9.1,4.5l-6.4-6.8l0.1-4.7
				l9.2-4.2l6.7,6.6L1426.5,431.2z M1758.2,241.6l10.9-3.9l1.2-7.6l10.1-4.2l7.9,8.4l-0.9,6.7l7,6.8l5.3-2.2l7.9,8.4l-2,8.9l-10.8,3
				l-4-4.6l-12.4,4.5l-1.7,6l-10.2,3.6l-7.5-7.8l1.3-5.6l-6.8-6.8l-6.4,2.6l-6.4-7l1.8-10.6l10.1-4.2L1758.2,241.6z M1687.4,182.6
				l10.1-4.2l5.3,5.6l10.9-3.9l1.2-7.6l10.1-4.2l7.9,8.4l-0.9,6.7l7,6.8l5.3-2.2l7.9,8.4l-2,8.9l-10.8,3l-4-4.6l-12.4,4.5l-1.7,6
				l-10.2,3.6l-7.5-7.8l1.3-5.6l-6.8-6.8l-6.4,2.6l-6.4-7L1687.4,182.6z M1685.7,239.7l8-15.2l30.1,7.6l-2.4,12.6l-2.5,5.2l1.2,0.4
				l0.4,9.6l-6.3,12.6l-4.6-2.7l-0.1-0.7l-29.9,61.2l2.5,0.7l-6.3,13.9l6.3-13.9l0.4,9.7l-6.9,13.8l-6.6-2.6l0-0.1l-7.4,15.2
				l-29.1-9.3l-1.5-9.4l4.4-8.9l-1.7-6.4l6.3-13.9l4.7,1.5l30.2-58.9l-1-9.7l6.3-13.9L1685.7,239.7z M1676.9,142v8.7l-29.6,50.9
				l-28.5-10.3l-1.1-9.5l30.4-50L1676.9,142z M1604.1,94.6l10.1-0.9l10.3,15.6l-2.2,9.5l-10.7,2.4l-8.2-14.5L1604.1,94.6z
				 M1600,212.2l29.7,8.9l-1.2,10.2l1.2,0.4v9.6l-6.9,12.3l-4.5-2.9v0l-11.6,22.3l3.2,1.1v9.7l-7.5,13.4l-6.4-2.9v-0.7l-8.1,15.5
				l-28.6-10.6l-1.1-9.5l4.7-8.7l-1.4-6.5l0,0l6.9-13.7l4.6,1.7l11.2-20.5l-0.6-10.1l6.9-13.7l5.6,2.1L1600,212.2z M1560,99L1560,99
				L1560,99c0-1.6,0.8-3.1,2.2-4c2.3-1.5,5.3-0.9,6.8,1.4c0.3,0.5,0.6,1.1,0.7,1.7l0,0l0,0c0.1,0.6,0.1,1.2,0,1.7l0.1,2.2
				c0,0.1,0,0.2,0,0.3l0,0.1l0,0c-0.1,1.5-0.8,3-2.2,3.9c-2.3,1.5-5.3,0.9-6.8-1.4c-0.5-0.8-0.8-1.8-0.8-2.7l0,0v-0.1c0,0,0,0,0,0
				V99C1560,99,1560,99,1560,99z M1542,147.9l4.1-5.9l32,11.2v6.2l-4.5,6l-31.6-11.6V147.9z M1531.2,153.2l64.3,22.3l-0.6,7.4
				l-8.5,11.7l-62.6-23.3l-0.8-6.4L1531.2,153.2z M1511.5,238.7l27.3-46.9l29.9,9.9l-1.1,13.1l-26,48.2l-30.2-12.3V238.7z
				 M1507.5,364.1l4.6,1.7l11.2-20.5l-0.6-10.1l6.9-13.7l5.6,2.1l4.1-7.5l29.7,8.9l-4.7,9l0,0l4.7-9l-1.2,10.2l1.2,0.4v9.6
				l-6.9,12.3l-4.5-2.9v0l-11.6,22.3l3.2,1.1v9.7l-7.5,13.4l-6.4-2.9v-0.7L1527,413l-28.6-10.6l-1.1-9.5l4.7-8.7l-1.4-6.5l0,0
				L1507.5,364.1z M1440.9,108.9L1440.9,108.9L1440.9,108.9c0-1.6,0.8-3.1,2.2-4c2.3-1.5,5.3-0.9,6.8,1.4c0.3,0.5,0.6,1.1,0.7,1.7
				l0,0l0,0c0.1,0.6,0.1,1.2,0,1.7l0.1,2.2c0,0.1,0,0.2,0,0.3l0,0.1l0,0c-0.1,1.5-0.8,3-2.2,3.9c-2.3,1.5-5.3,0.9-6.8-1.4
				c-0.5-0.8-0.8-1.8-0.8-2.7l0,0v-0.1c0,0,0,0,0,0V108.9C1440.9,108.9,1440.9,108.9,1440.9,108.9z M1413.9,215.1l15-26.3v-10.7
				l5.4-8.3l4.5,1.6l15.2-26.6l0.5-12.1l5.4-8.3l4.8,1.7l1.5-2.6l31,9.4l-2.8,10.4l-2.1,3.7l2.6,0.9l-1.3,7.6l-4.6,9.5l-5.8-1.7
				l-24.5,43.4l1.3,0.4l-0.5,7.9l-5.6,10.6l-4.9-1.6l-7.5,13.3l-27.5-9.6V215.1z M1403.7,240.5l62.5,25l-0.1,9.3l-7.4,15l-61-26.3
				l-1.1-8L1403.7,240.5z M1327.2,123.4h29.9l12.1,83.1l-3.1,9.6h-29.9l-10.7-77.1L1327.2,123.4z M1322.8,251.7l-35.2,51.5
				l-18.5-8.4v-9.4l33.3-48.5l20.4,7.1V251.7z M1266.4,122.5h29.9l12.1,83.1l-3.1,9.6h-29.9l-10.7-77.1L1266.4,122.5z M1201.2,123.4
				h33.4l1.3,7.3h7.1l2.4,9.4l-1.4,8.4h-4.8l4.8,25.6l-2.2,7.5l3.7,22.4l0,0l-3.1,7.9h-29.7l-12.6-76.7L1201.2,123.4z M1143.4,120.6
				h29.7l1,9.4h5.5l1.2,7.9l0,0l-1.3,7.1h-3.8l5.8,56.6l-2,7.6h-29.9l-7-80.3L1143.4,120.6z M1148.2,387.7l-0.7,7.5l-14.4,7.5
				l-10.5-10.8v-7.6l14.7-7L1148.2,387.7z M1129.2,315.5v7.2H1094l-3.9-86.3l0.6-9.8h34.1L1129.2,315.5z M1087.5,201.7v-81.9h32.4
				l2.6,81.9v6.9h-35V201.7z M1080.2,629.3l10.4-21.1l24,7c1.2-2.7,4.1-4.6,7.5-4.6c4.5,0,8.1,3.2,8.1,7.2c0,0.6-0.1,1.3-0.3,1.8
				l63,18.3l-0.8,8.8l-8.9,21.3l-79.8-24.4l0,0c-2.3,2.7-6.3,3.4-6.3,3.4v-0.1c-5.9,0.8-8.9-6-8.9-6l-0.3-2l-7.8-2.4V629.3z
				 M1022,205.2v-6.9v-81.9h32.4l2.6,81.9v6.9H1022z M1011.3,488.4l67.2,19.3l-0.8,7.1l-37,85.9l-66.3-20.3l-1-9.9L1011.3,488.4z
				 M1034.8,631.6l-0.7,7.6l-3.2,13.7l-105.5-34v-4.1l6.2-16.5L1034.8,631.6z M861.2,556.9l69.9-39.5l14.9,12.9v7.6l-72,41
				L861.2,566V556.9z M845.7,670.9l13.4,3.7v5.7l129,40.6l3.4-5.3l14.6,4.3v6.7l29.9,10.2l-1.3,9.9l-9.5,23.3l-36.7-11.3l-2.8,5.2
				l-13.4-4.7v-4.9L840.2,712l-3.1,3.1l-13.4-4.6v-4l-31.8-10.8v-8.5l14.5-23.4l36.1,11.5L845.7,670.9z M830.5,637.4l-1.7,7.2
				l-55.6,6.7l-5.1-21.5l0.7-10.2l54.9-5.1L830.5,637.4z M692.3,582.1l82.8-9.4l7.1,20.1l-1.8,10.9l-23,2.4l2.7,11.9l-1.9,11.2
				l-49.1,5.7l-4.4-23.2l0,0l-7.8,0.8l-4.5-19.7V582.1z M600,644.6l143.8,43.6v8.4l-13,21l-142.1-43.1l-1.7-7.8l0.2,0.1L600,644.6z
				 M563.6,812.9l-36,120.6l-48.2-7.8l-2.9-12.3l39.9-121.5l47.2,5.9V812.9z M411,586.3l143.8,43.6v8.4l-13,21l-96.4-29.4l-3.3,5.9
				l-13-4.3l-0.6-6.4l-28.6-9.2l-1.6-7.5L411,586.3z M452.2,660.7v8.6l-14.9,25L362,670.8l-2.7-8l14.5-25.3L452.2,660.7z
				 M337.9,544.9l32.1,6.4v8.4l-25.2,40.5l-31.5-7.5l-2.3-7.1L337.9,544.9z M250.5,535.7l51.3,12.4l0.9,8.9l-17.2,25.3l-50.9-14.2
				l-2.1-9.6L250.5,535.7z M283.1,604.6l-8.6,12.3l-21.4-8.4l-1.3-5.5l8.6-11.9l22,7.5L283.1,604.6z M202.3,713.1L501.1,760v20.1
				l-17.7,47.2l-300.2-47.2l-4.6-14.4L202.3,713.1z M170.9,811.3l298.8,46.9v20.1L452,925.6l-300.2-47.2l-4.6-14.4L170.9,811.3z
				 M117.4,961l23.8-52.6L440,955.2v20.1l-17.7,47.2L122,975.4L117.4,961z"
                  />
                </g>
                <g>
                  <rect
                    x="1594.6"
                    y="257.7"
                    transform="matrix(0.4662 -0.8847 0.8847 0.4662 631.7726 1562.3447)"
                    className={classes.cls0}
                    width="31.9"
                    height="0"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.cls0}
                    points="1720.3,201.9 1720.3,201.9 1737.7,196.2 			"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls1}
                    d="M27.5,683.7c-6.2,1.2-12.3,3-18.1,5.4c-12.8,5.4-24.5,13.2-36.1,20.7c-5.9,3.8-12.8,1.2-16.4-3.8
				c-6,3.9-11.9,8.1-17.5,12.7c-8.1,1.7-15.1,8-17.8,15.8c-3.2,9.1,1.6,18.3,10.9,20.9c7.9,2.2,17.1-0.1,24.9-1.5
				c8.4-1.6,16.7-3.7,24.8-6.4c26.5-8.9,51-23.3,71.5-42.2c6.3-2.9,12-6.8,17-11.6c3.9-3.7,3.2-8.4,0.6-11.6c-0.2-2-1-3.8-2.5-5
				c-1-0.8-2.1-1.5-3.1-2c-5.1,3-10.6,5.2-16.8,6.2C41.8,682.2,34.5,682.3,27.5,683.7z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M10,289.6c0,0.6-0.1,1.1-0.3,1.7c6,0,11.9,0,17.9,0C21.8,290.8,15.9,290.2,10,289.6z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M101,283.7c1.1,0,2.1,0.2,3,0.5c0-0.4,0-0.9,0-1.2c-0.6-0.1-1.1-0.2-1.7-0.3c-1-0.2-2-0.3-3-0.5
				c0,0.1,0,0.1,0,0.2C100,282.7,100.5,283.2,101,283.7z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M-44.5,99.8c0.4,3.5,0.8,7,1.1,10.4c1.7,0.4,3.3,0,5-0.6c6.4-2,12-5.3,18.7-6.3c7.9-1.1,15.7,0.4,23.6,1.4
				c7.6,1,15.2,2,22.9,3c7.8,1,11.8,9,6.4,15.4c-15.6,18.4-31.2,36.8-46.8,55.3c-3,3.6-6.1,7.2-8.6,11.1c-1.5,2.3-5.6,7.6-5,10.6
				c0.9,4.1,10.3,5,13.6,5.7c18,3.9,35.5,11,51.1,20.7c2.9,1.8,5.8,3.8,8.6,5.8c19.9,4.8,39.9,9.7,59.8,14.5
				c12.4,3,25.4,5.3,37.6,9.2c10.8,3.5,19.7,12.7,14.2,24.3c-1.8,3.8-6.5,4.8-10.2,4.1c-3.6-0.7-7.6,0.6-10.4,3
				c1.7,4.1,2.8,8.6,3.3,13.2c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c1.1,1.5,2.4,2.8,3.8,3.8c6.5,1.6,14.5,0.4,20.1-0.5
				c4.8-0.7,9.6,1.1,11.1,6.3c1.2,4.4-1.5,10.2-6.3,11.1c-3.1,0.6-6.3,1.1-9.5,1.6c-0.4,0.2-0.7,0.3-1.1,0.4
				c-2.2,0.7-4.3,1.1-6.4,1.3c-11.4,2-22.8,2.5-34.3,2.6c-9.2,0.4-18.4,0.4-27.6,0.1c-6,0.1-12,0.5-18,1.4c-9.2,1.4-17.9,4.4-26.8,7
				c-7.7,2.2-15.8,4-23.8,3.5c-8.7-0.5-16.8-3.3-25-6c-16.4-5.6-33.1-6.7-50.2-7.7c-17.7-0.9-35.5-1.9-53.2-2.8
				c-9.6-0.5-19.7-1-28.8-4.2l-24.3,81.6l828.8,122.1c63.7,7.4,120.3,2.7,168.1-14c37.6-13.1,70.1-33.7,96.5-61.2
				c44.9-46.7,56.6-96.9,56.7-97.4l0-0.1c13.1-56.3,6.5-102.7-19.6-137.9c-14.3-19.3-42.7-46-97.1-63.2
				c-33.2-10.6-59.9-12.5-60.1-12.5l-1.3-0.1L-47.1,22.1L-67.7,91c4.7-0.1,9.5-0.1,14.2-0.2C-48.2,90.8-45,95-44.5,99.8z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M33.9,320.7c0.2,0,0.3-0.1,0.5-0.1c-6.2,0.1-12.5,0.2-18.7,0.2C21.7,322,27.6,322.1,33.9,320.7z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M-38.1,150.4c0.4-0.6,0.9-1.2,1.3-1.8c-1,0.1-1.9,0.2-2.9,0.3c0,0,0.1,0,0.1,0.1
				C-39,149.4-38.5,149.9-38.1,150.4z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls2}
                    d="M-61.1,118.2c-1.1,0-2.1,0-3.2,0.1c1.2,0.5,2.4,0.8,3.8,0.9C-60.6,118.9-60.9,118.5-61.1,118.2z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls3}
                    d="M-30.2,450.7c4.1-5.4,10.7-8.2,17.1-4.5c5.4,3.1,8.5,11.7,4.5,17.1l672,99l0.6,0.1
				c21.1,2.5,41.5,3.7,61.3,3.7c45.6,0,87.5-6.6,125-19.6c43.6-15.2,81.4-39.2,112.2-71.3c52-54.2,66.1-112.7,66.9-116.2
				c15.9-68.2,7-125.6-26.4-170.8c-59.4-80.2-174.8-90.9-186-91.8L-75.7-22.1l-33.8,113.5c14-0.1,27.9-0.3,41.9-0.4l20.5-68.9
				l859.4,114.1l1.3,0.1c0.3,0,26.9,1.9,60.1,12.5c54.3,17.3,82.8,43.9,97.1,63.2c26.1,35.3,32.7,81.7,19.6,137.9l0,0.1
				c-0.1,0.5-11.9,50.7-56.7,97.4c-26.4,27.5-58.8,48.1-96.5,61.2c-47.9,16.7-104.4,21.4-168.1,14l-828.8-122.1l24.3-81.6
				c-5.1-1.8-9.8-4.4-14-8.4c-10.4-9.9-13.2-24.9-13.5-38.6c0-0.2,0-0.5,0-0.7l-48.3,162.2l82.2,12.1l93,13.7
				C-34.3,456.4-32.3,453.5-30.2,450.7z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls1}
                    d="M-149.5,310.7c4.2,4,8.9,6.6,14,8.4c9,3.2,19.1,3.7,28.8,4.2c17.7,0.9,35.5,1.9,53.2,2.8
				c17.2,0.9,33.8,2.1,50.2,7.7c8.2,2.8,16.3,5.5,25,6c8,0.5,16.1-1.3,23.8-3.5c8.9-2.6,17.6-5.6,26.8-7c5.9-0.9,12-1.3,18-1.4
				c9.2,0.3,18.4,0.3,27.6-0.1c11.5-0.1,23-0.5,34.3-2.6c2.1-0.2,4.2-0.6,6.4-1.3c0.4-0.1,0.8-0.3,1.1-0.4c3.2-0.5,6.3-1.1,9.5-1.6
				c4.8-0.9,7.5-6.7,6.3-11.1c-1.4-5.2-6.2-7-11.1-6.3c-5.6,0.8-13.6,2-20.1,0.5c-1.4-1-2.7-2.3-3.8-3.8c0,0,0,0,0,0
				c0-0.1,0-0.2,0-0.3c-0.5-4.6-1.6-9-3.3-13.2c2.7-2.4,6.7-3.7,10.4-3c3.7,0.7,8.4-0.4,10.2-4.1c5.5-11.6-3.5-20.8-14.2-24.3
				c-12.2-3.9-25.2-6.2-37.6-9.2c-19.9-4.8-39.9-9.7-59.8-14.5c-2.8-2-5.6-4-8.6-5.8c-15.7-9.7-33.1-16.8-51.1-20.7
				c-3.3-0.7-12.7-1.6-13.6-5.7c-0.6-3,3.5-8.3,5-10.6c2.6-3.9,5.6-7.5,8.6-11.1c15.6-18.4,31.2-36.9,46.8-55.3
				c5.4-6.4,1.4-14.3-6.4-15.4c-7.6-1-15.2-2-22.9-3c-7.8-1-15.7-2.5-23.6-1.4c-6.7,0.9-12.3,4.3-18.7,6.3c-1.7,0.5-3.3,1-5,0.6
				c-0.4-3.5-0.8-7-1.1-10.4c-0.5-4.8-3.7-9.1-9-9c-4.7,0.1-9.5,0.1-14.2,0.2c-14,0.1-27.9,0.3-41.9,0.4c-6.6,0.1-13.1,0.1-19.7,0.2
				c-3.4,0-6.8,0.1-10.1,0.1c-4.4,0-9.6,4.1-9,9c3,23,5.2,46.1,6.5,69.3c-0.2,0.7-0.5,1.3-0.7,2c-5.7,16.1-11.6,31.9-15.1,48.6
				c-3.4,16.5-5.7,33.7-5.4,50.6c0,0.2,0,0.5,0,0.7C-162.8,285.7-159.9,300.8-149.5,310.7z M102.3,282.7c0.6,0.1,1.1,0.2,1.7,0.3
				c0,0.4,0,0.8,0,1.2c-0.9-0.3-1.9-0.5-3-0.5c-0.5-0.5-1-1-1.7-1.4c0-0.1,0-0.1,0-0.2C100.3,282.3,101.3,282.5,102.3,282.7z
				 M33.9,320.7c-6.3,1.4-12.2,1.3-18.2,0c6.2,0,12.5,0,18.7-0.2C34.2,320.6,34,320.6,33.9,320.7z M10,289.6
				c5.9,0.7,11.7,1.2,17.6,1.7c-6,0-11.9,0-17.9,0C9.9,290.7,10,290.1,10,289.6z M-36.7,148.6c-0.4,0.6-0.9,1.2-1.3,1.8
				c-0.4-0.5-0.9-1-1.4-1.4c0,0-0.1,0-0.1-0.1C-38.6,148.9-37.7,148.7-36.7,148.6z M-61.1,118.2c0.2,0.3,0.4,0.7,0.6,1
				c-1.4-0.1-2.7-0.4-3.8-0.9C-63.2,118.2-62.1,118.2-61.1,118.2z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls4}
                    d="M-13.1,446.2c-6.4-3.7-13-0.9-17.1,4.5c-2.1,2.8-4.1,5.7-6,8.6c-7.2,10.9-13.3,22.5-18.2,34.7
				c-2.9,7.2-5.4,14.5-7.4,22c-1.1,4.2-2.2,8.7-1,13c1.6,6,6.2,9.9,11.8,12c7.7,2.9,16.1,4.5,24.1,6.3c0.5,0.1,0.9,0.2,1.4,0.3
				c-1.6,2.2-2.5,4.8-2.5,7.3c1.5,47.6-4.2,94.9-17,140.7c-1,3.7-0.1,7.4,2,10.3c3.6,5,10.5,7.6,16.4,3.8
				c11.6-7.5,23.3-15.3,36.1-20.7c5.8-2.4,11.9-4.3,18.1-5.4c7.1-1.3,14.3-1.4,21.4-2.6c6.2-1,11.7-3.3,16.8-6.2
				c7.8-4.5,14.5-10.8,21.3-17.2c10.4-9.8,20.3-20.2,29.7-30.9c9.7-11.1,18.9-22.7,27.7-34.6c3.8-5.2,8.2-10.5,9.9-16.8
				c2.5-9.2-0.5-18.9-9.2-23.5c-6.2-3.2-13.9-3.6-20.6-4.8c-8.1-1.4-16.3-2.6-24.5-3.9c-15.1-2.3-30.2-4.3-45.3-6.5
				c-17-2.5-33.9-5.1-50.8-8.3c-8.1-1.5-16.2-3.2-24.2-5.1c-4.3-1-8.6-2-12.9-3.2c-1.2-0.3-2.3-0.6-3.5-0.9c0.9-3,1.8-5.9,2.8-8.8
				c1.8-5.2,3.9-10.3,6.2-15.3c5.3-11.2,11.7-21.7,19.2-31.6c0,0,0,0,0,0C-4.6,457.9-7.8,449.4-13.1,446.2z M2.9,629
				c0.2,0,0.3,0.1,0.5,0.1c-0.3,0.8-0.5,1.7-0.6,2.6C2.9,630.8,2.9,629.9,2.9,629z M2.8,633.4c0,2.2,0.6,4.5,1.6,6.3
				c-0.6,0.4-1.3,0.7-1.9,1.1C2.5,638.3,2.6,635.8,2.8,633.4z M25.7,656.5c0.5,0.8,1.2,1.4,1.9,2c-2.9,0.4-5.7,0.9-8.5,1.4
				C21.2,658.8,23.5,657.7,25.7,656.5z M127,572.7c0.1,0,0.3,0,0.4,0.1c-0.1,0.1-0.1,0.2-0.2,0.3C127.1,573,127,572.9,127,572.7z
				 M133.2,573.9C133.9,574.1,133.8,574.6,133.2,573.9L133.2,573.9z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls5}
                    d="M932.8,866.9c-2.6,1.2-4.4,3.2-5.5,5.6c0.2,0,0.4,0.1,0.6,0.1C929,870.3,930.7,868.2,932.8,866.9z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls5}
                    d="M1118.7,1174.8c-4.7-17.7-11.7-34.7-18.1-51.8c-6.7-17.8-13.4-35.5-20.1-53.3s-13.4-35.5-20.1-53.3
				c-3.2-8.4-6-17.3-11.1-24.8c-4.7-7-10.9-12.3-17.4-17.6c-12.6-10.2-23-22.4-32.7-35.5c-11-14.9-21.9-29.8-32.9-44.8
				c-5.5-7.5-11-14.9-16.4-22.4c-4-5.4-10.8-8.1-17.1-4.5c-0.1,0-0.1,0.1-0.2,0.1c-2.1,1.3-3.8,3.4-4.9,5.8
				c-0.2-0.1-0.4-0.1-0.6-0.1c-2.1-0.5-4.3-0.5-6.4,0.1L500,1126.5l-1.7-2.7c-13.6,9-26.7,18.5-38.9,29.2c-11.5,5.9-23,11.6-34.7,17
				c-3,0.1-6.1,0.1-9.1,0.2c-5.8,0.1-10.6,4.1-12.1,9.3c-7.3,3.1-14.6,6.2-21.9,9.1c-2.8,1.1-5.2,2.9-6.8,5.1
				c-4.3,3.8-5.2,10.8-2.4,15.7c1.1,1.8,2.5,3.2,4.1,4.2c2.7,1.7,6,2.2,9.3,1.6c0.8,0.5,1.6,0.9,2.5,1.2c16.9,6.6,35.2,4,52.4,0
				c4-0.9,8-1.9,11.9-2.8c12.8-3,25.5-5.5,38.9-6.1c18.5-0.8,37.1,0.2,55.6,0.8c18.9,0.6,37.8,1.4,56.7,2.2c21.9,0.9,43.8,2,65.6,3
				c53.4,2.6,106.8,5.4,160.2,7.7c75.6,3.2,151.2,5.4,226.8,4.3c9.3-0.1,18.6-0.3,27.9-0.6c9-0.2,19.4,0.7,27.4-4.2
				c3.2-2,5.6-4.5,7.3-7.3C1125.6,1202.6,1121.9,1186.7,1118.7,1174.8z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls4}
                    d="M1479.5,537c-2.8,1.3-5.7,2.6-8.5,3.9l-121,73c-0.1,0.9-0.1,1.7,0.1,2.6c-3.2,3.3-2.7,9.5,1.6,11.7
				c62.4,31.9,122.5,68.3,179.7,108.9c56.6,40.2,110.3,84.6,160.6,132.5c50.8,48.3,98.1,100.3,141.4,155.4
				c10.8,13.7,21.3,27.6,31.5,41.7c5.1,7.1,10.2,14.2,15.2,21.4c4.7,6.8,9.1,14,14.2,20.5c13.5,16.9,30.3-5.5,37.2-17.2
				c8-13.4,12.3-28.8,14.4-44.2c4.9-34.9,1.4-70.5,2.1-105.6c0.9-41.9,4.3-83.8,7.7-125.6c6.5-79.6,13.3-159.8,4-239.4
				c-4.5-38.5-12.5-76.6-25.9-112.9c-6.1-16.5-12.6-34.6-26.7-46c-13.9-11.3-31.8-16-49.2-18.1c-34.9-4.3-70.1,4.8-101.2,20.4
				c-15.9,8-30.7,17.8-44.7,28.8c-6.6,5.2-13.5,10.7-17.3,18.4c-4.3,8.4-3.8,17.6-0.2,26.2c3.6,8.4,9.5,15.4,15.2,22.5
				c6.5,8.1,13,16.2,19.6,24.3c5.8,7.2,12.3,14.3,16.9,22.4c4.7,8.4,4.6,16.7,1.6,25.7c-6.1,18.7-16.3,36.7-25.9,53.8
				c-4.6,8.2-9.3,16.5-14.6,24.3c-4.5,6.6-10.1,12.3-17.9,14.8c-8.9,2.9-18.7,2.8-28,3.1c-10.5,0.4-21.1,0.6-31.6,0.5
				c-20.9,0-41.9-0.7-62.8-2.4c-8.2-0.7-17-1.8-23.1-7.9c-6.1-6.2-9.7-15.3-13.7-22.9c-4.9-9.3-9.7-18.6-14.6-28
				c-4.6-8.8-9.8-17.5-13.3-26.8c-2.8-7.3-4.8-15.8-1.7-23.4c2.5-6,7.5-10.9,14.3-10.6c5.3,0.2,9.9-6.7,6.5-11.3
				c-8.6-11.5-20.8-18.3-35.2-19.2c-0.4,0-0.7,0-1.1,0l-5.1,3.1C1479.9,535.9,1479.6,536.4,1479.5,537z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls6}
                    d="M662.6,36.4c129.8,30.9,272.2,50.2,423.3,57.4c45.2,2.2,91.3,3.3,138.1,3.3c147.2,0,301.7-10.7,461-32.1
				c-1-1.8-2-3.6-2.9-5.4c-1.1-2-2.1-4-3.2-5.9c-207.4,27.5-406.5,37-591.9,28.1c-150.3-7.2-291.9-26.3-420.9-57
				C551.3-2.4,467.9-33.8,418.2-55.4c-22.7-9.8-40.6-18.6-53.8-25.4C346.3-90.2,337.1-96,337-96.1L330.5-86c0.3,0.2,3.2,2.1,8.7,5.2
				c12,6.9,36.3,19.9,73.6,36.2C463-22.9,547,8.9,662.6,36.4z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls6}
                    d="M1995.4,421.1l7.9-9c-45.2-39.7-86.7-78.9-124.2-117.3l-10.6,6.4C1906.7,340.3,1949.1,380.4,1995.4,421.1z"
                  />
                </g>
                <g>
                  <path
                    className={classes.cls6}
                    d="M1685,65c25.6,46.3,60.3,95.8,103.2,147.3c21.8,26.1,45.8,52.8,71.8,80l10.5-6.4
				c-26.2-27.2-50.3-54-72.2-80.2c-44-52.7-79.3-103.2-105-150.2c-43.5-79.9-43.8-122.4-43.8-122.8l-6,0l-6-0.1
				c0,1.8,0,42.9,41.3,121.2c1,2,2.1,3.9,3.2,5.9C1683,61.4,1684,63.2,1685,65z"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls6}
                    points="493.8,1116.2 498.3,1123.8 500,1126.5 920.9,872.7 1350,613.9 1471,540.9 1480.2,535.4
				1485.3,532.3 1868.6,301.1 1879.1,294.7 1941.3,257.2 1935.1,246.9 1870.6,285.9 1860,292.2 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.barnPath}
                    points="476.5,913.3 526,920.6 563.6,797.7 516.4,791.8 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.cls9}
                    points="527.6,933.4 563.6,812.9 563.6,797.7 526,920.6 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.cls8}
                    points="476.5,913.3 479.4,925.6 527.6,933.4 526,920.6 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.barnPath}
                    points="600.6,982.2 621.7,987.2 627.5,970.8 606.8,965.7 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.cls9}
                    points="621.7,995.2 627.5,977.6 627.5,970.8 621.7,987.2 			"
                  />
                </g>
                <g data-name={"noName"}>
                  <polygon
                    className={classes.cls8}
                    points="600.6,982.2 602,989.7 621.7,995.2 621.7,987.2 			"
                  />
                </g>
                <g data-name={"maintenance"}>
                  <polygon
                    className={classes.barnPath}
                    points="605.2,906.4 738.3,936.1 749.2,898.8 617.5,869.7 			"
                  />
                </g>
                <g data-name={"maintenance"}>
                  <polygon
                    className={classes.cls9}
                    points="739.7,945.3 749.2,906.4 749.2,898.8 738.3,936.1 			"
                  />
                </g>
                <g data-name={"maintenance"}>
                  <polygon
                    className={classes.cls8}
                    points="605.2,906.4 607.2,916.2 739.7,945.3 738.3,936.1 			"
                  />
                </g>
                <g data-name={"dorm H"}>
                  <polygon
                    className={classes.barnPath}
                    points="925.4,614.7 1030.9,648.8 1034.8,631.6 931.7,598.2 			"
                  />
                </g>
                <g data-name={"dorm H"}>
                  <polygon
                    className={classes.cls9}
                    points="1030.9,652.8 1034.1,639.2 1034.8,631.6 1030.9,648.8 			"
                  />
                </g>
                <g data-name={"dorm H"}>
                  <polygon
                    className={classes.cls8}
                    points="925.4,614.7 925.4,618.8 1030.9,652.8 1030.9,648.8 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.cls9}
                    points="757.4,606.2 780.4,603.7 782.2,592.8 755.2,596 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.cls9}
                    points="697.1,602.8 696.9,612.6 704.7,611.8 705.9,601.8 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.barnPath}
                    points="705.9,601.6 709.9,624 760.1,618 757.4,606.2 755.2,596 755.1,595.9 782.2,592.8 775.1,572.7
				692.3,582.1 697.1,602.8 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.cls9}
                    points="709.1,634.9 758.2,629.2 760.1,618 709.9,624 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.cls8}
                    points="697.1,602.8 692.3,582.1 692.3,592.8 696.9,612.6 			"
                  />
                </g>
                <g data-name={"kitchen"}>
                  <polygon
                    className={classes.cls8}
                    points="705.9,601.6 705.9,601.8 704.7,611.8 704.7,611.8 709.1,634.9 709.9,624 			"
                  />
                </g>
                <g data-name={"dorm I"}>
                  <polygon
                    className={classes.barnPath}
                    points="774.7,643.5 830.5,637.4 823.6,614.4 768.7,619.5 			"
                  />
                </g>
                <g data-name={"dorm I"}>
                  <polygon
                    className={classes.cls8}
                    points="768.7,619.5 768.1,629.8 773.2,651.2 774.7,643.5 			"
                  />
                </g>
                <g data-name={"dorm I"}>
                  <polygon
                    className={classes.cls9}
                    points="773.2,651.2 828.8,644.6 830.5,637.4 774.7,643.5 			"
                  />
                </g>
                <g data-name={"dorm G"}>
                  <polygon
                    className={classes.barnPath}
                    points="945.9,530.3 931.1,517.5 861.2,556.9 873.9,570.5 			"
                  />
                </g>
                <g data-name={"dorm G"}>
                  <polygon
                    className={classes.cls8}
                    points="873.9,570.5 861.2,556.9 861.2,566 873.9,578.9 			"
                  />
                </g>
                <g data-name={"dorm G"}>
                  <polygon
                    className={classes.cls9}
                    points="873.9,578.9 945.9,537.9 945.9,530.3 873.9,570.5 			"
                  />
                </g>
                <g data-name={"dorm F"}>
                  <polygon
                    className={classes.barnPath}
                    points="1149.2,575.9 1215.1,594.7 1221,579.7 1157.6,562.3 			"
                  />
                </g>
                <g data-name={"dorm F"}>
                  <polygon
                    className={classes.cls9}
                    points="1215.1,601.4 1221,587.1 1221,579.7 1215.1,594.7 			"
                  />
                </g>
                <g data-name={"dorm F"}>
                  <polygon
                    className={classes.cls8}
                    points="1149.2,575.9 1150.4,582.2 1215.1,601.4 1215.1,594.7 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.barnPath}
                    points="1133,395.3 1148.2,387.7 1137.2,377.2 1122.5,384.2 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls9}
                    points="1133,402.6 1147.5,395.1 1148.2,387.7 1133,395.3 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls8}
                    points="1122.5,384.2 1122.5,391.8 1133,402.6 1133,395.3 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.barnPath}
                    points="1411.1,424.1 1417.5,431.2 1427.1,426.6 1420.3,419.9 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls9}
                    points="1417.5,435.7 1426.5,431.2 1427.1,426.6 1417.5,431.2 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls8}
                    points="1411.1,424.1 1411.1,428.8 1417.5,435.7 1417.5,431.2 			"
                  />
                </g>
                <g data-name={"dorm E"}>
                  <polygon
                    className={classes.barnPath}
                    points="1269,285.4 1288.3,294.7 1322.8,244 1302.4,236.9 			"
                  />
                </g>
                <g data-name={"dorm E"}>
                  <polygon
                    className={classes.cls8}
                    points="1269,285.4 1269,294.7 1287.6,303.2 1288.3,294.7 			"
                  />
                </g>
                <g data-name={"dorm E"}>
                  <polygon
                    className={classes.cls9}
                    points="1287.6,303.2 1322.8,251.7 1322.8,244 1288.3,294.7 			"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1450.7,111.8l0,0.3C1450.7,112,1450.7,111.9,1450.7,111.8z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1446.9,113.7c-1.3,0.3-2.7,0.1-3.8-0.7l1.4,2.6l-3.5-3.6c0,0.9,0.3,1.9,0.8,2.7c1.5,2.3,4.5,2.9,6.8,1.4
				c1.4-0.9,2.1-2.4,2.2-3.9l-3.2,3.4L1446.9,113.7z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1440.9,111.9L1440.9,111.9C1440.9,111.9,1440.9,111.9,1440.9,111.9z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <polygon
                    className={classes.cls9}
                    points="1440.9,108.9 1440.9,108.9 1440.9,108.9 			"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1440.9,111.9L1440.9,111.9L1440.9,111.9l3.5,3.6l-1.4-2.6c-0.5-0.4-1-0.8-1.4-1.4c-0.6-0.8-0.8-1.8-0.8-2.7
				V111.9L1440.9,111.9z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1450.6,107.9L1450.6,107.9C1450.6,107.9,1450.6,107.9,1450.6,107.9L1450.6,107.9z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1448.5,113c-0.5,0.3-1,0.5-1.6,0.7l0.6,1.9l3.2-3.4l0,0l0-0.1l0-0.3l-0.1-2.2
				C1450.5,111,1449.7,112.2,1448.5,113z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.barnPath}
                    d="M1441.7,111.6c0.4,0.6,0.8,1,1.4,1.4c1.1,0.8,2.5,1,3.8,0.7c0.6-0.1,1.1-0.3,1.6-0.7c1.2-0.8,1.9-2,2.1-3.4
				c0.1-0.6,0.1-1.2,0-1.7c0,0,0,0,0,0c-0.1-0.6-0.3-1.1-0.7-1.7c-1.5-2.3-4.5-2.9-6.8-1.4c-1.4,0.9-2.2,2.5-2.2,4c0,0,0,0,0,0
				c0,0,0,0,0,0C1440.9,109.8,1441.2,110.8,1441.7,111.6z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1569.8,102l0,0.3C1569.8,102.2,1569.8,102.1,1569.8,102z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1560,102.1L1560,102.1C1560,102.1,1560,102.1,1560,102.1z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1566,103.9c-1.3,0.3-2.7,0.1-3.8-0.7l1.4,2.6l-3.5-3.6c0,0.9,0.3,1.9,0.8,2.7c1.5,2.3,4.5,2.9,6.8,1.4
				c1.4-0.9,2.1-2.4,2.2-3.9l-3.2,3.4L1566,103.9z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <polygon
                    className={classes.cls9}
                    points="1560,99 1560,99 1560,99 			"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1560,102.1L1560,102.1L1560,102.1l3.5,3.6l-1.4-2.6c-0.5-0.4-1-0.8-1.4-1.4c-0.6-0.8-0.8-1.8-0.8-2.7V102.1
				L1560,102.1z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1569.7,98.1L1569.7,98.1C1569.7,98.1,1569.7,98.1,1569.7,98.1L1569.7,98.1z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.cls9}
                    d="M1567.6,103.2c-0.5,0.3-1,0.5-1.6,0.7l0.6,1.9l3.2-3.4l0,0l0-0.1l0-0.3l-0.1-2.2
				C1569.6,101.2,1568.8,102.4,1567.6,103.2z"
                  />
                </g>
                <g data-name={"stableGate"}>
                  <path
                    className={classes.barnPath}
                    d="M1560.8,101.8c0.4,0.6,0.8,1,1.4,1.4c1.1,0.8,2.5,1,3.8,0.7c0.6-0.1,1.1-0.3,1.6-0.7c1.2-0.8,1.9-2,2.1-3.4
				c0.1-0.6,0.1-1.2,0-1.7c0,0,0,0,0,0c-0.1-0.6-0.3-1.1-0.7-1.7c-1.5-2.3-4.5-2.9-6.8-1.4c-1.4,0.9-2.2,2.5-2.2,4c0,0,0,0,0,0
				c0,0,0,0,0,0C1560,100,1560.3,100.9,1560.8,101.8z"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.barnPath}
                    points="1578.1,153.2 1546.1,142 1542,147.9 1573.6,159.4 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls8}
                    points="1573.6,159.4 1542,147.9 1542,153.8 1573.6,165.4 			"
                  />
                </g>
                <g data-name={"no name"}>
                  <polygon
                    className={classes.cls9}
                    points="1573.6,165.4 1578.1,159.4 1578.1,153.2 1573.6,159.4 			"
                  />
                </g>
                <g data-name={"dorm C"}>
                  <polygon
                    className={classes.barnPath}
                    points="1595.5,175.5 1531.2,153.2 1523.1,164.9 1586.5,187.8 			"
                  />
                </g>
                <g data-name={"dorm C"}>
                  <polygon
                    className={classes.cls8}
                    points="1586.5,194.6 1586.5,187.8 1523.1,164.9 1523.8,171.3 			"
                  />
                </g>
                <g data-name={"dorm C"}>
                  <polygon
                    className={classes.cls9}
                    points="1586.5,194.6 1595,182.9 1595.5,175.5 1586.5,187.8 			"
                  />
                </g>
                <g data-name={"dorm D"}>
                  <polygon
                    className={classes.barnPath}
                    points="1466.2,265.5 1403.7,240.5 1396.6,255.5 1458.4,281.3 			"
                  />
                </g>
                <g data-name={"dorm D"}>
                  <polygon
                    className={classes.cls8}
                    points="1458.8,289.8 1458.4,281.3 1396.6,255.5 1397.8,263.5 			"
                  />
                </g>
                <g data-name={"dorm D"}>
                  <polygon
                    className={classes.cls9}
                    points="1458.8,289.8 1466.1,274.8 1466.2,265.5 1458.4,281.3 			"
                  />
                </g>
                <g data-name={"security"}>
                  <polygon
                    className={classes.barnPath}
                    points="1624.6,109.3 1614.2,93.7 1604.1,94.6 1614,110.6 			"
                  />
                </g>
                <g data-name={"security"}>
                  <polygon
                    className={classes.cls8}
                    points="1614,110.6 1604.1,94.6 1603.4,106.8 1611.6,121.2 			"
                  />
                </g>
                <g data-name={"security"}>
                  <polygon
                    className={classes.cls9}
                    points="1611.6,121.2 1622.4,118.8 1624.6,109.3 1614,110.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1775.6,259.5 1779.3,263.4 1778.6,265.8 1790.9,261.3 1793,253.8 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1794.9,265.9 1805.7,262.9 1807.7,254 1796.6,258.2 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1787.4,241 1788.3,234.3 1782.7,236.5 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1793,253.8 1790.9,261.3 1794.9,265.9 1796.6,258.2 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1768.2,267.6 1766.7,275.4 1776.9,271.8 1778.6,265.8 1779.3,263.4 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1764.4,263 1763.7,265.1 1760.6,262 1759.2,267.6 1766.7,275.4 1768.2,267.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1742.7,240.2 1740.9,250.8 1747.3,257.8 1749.7,248.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1749.7,248.6 1747.3,257.8 1753.7,255.2 1755.6,246.4 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1764.4,263 1761.2,259.2 1766.2,257.2 1755.6,246.4 1753.7,255.2 1760.6,262 1763.7,265.1 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1770.2,230.1 1769.1,237.7 1774.8,235.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.barnPath}
                    points="1749.7,248.6 1755.6,246.4 1766.2,257.2 1761.2,259.2 1764.4,263 1768.2,267.6 1779.3,263.4
				1775.6,259.5 1775.6,259.5 1793,253.8 1796.6,258.2 1807.7,254 1799.7,245.6 1794.4,247.8 1787.4,241 1782.7,236.5 1788.3,234.3
				1780.4,225.9 1770.2,230.1 1774.8,235.6 1769.1,237.7 1758.2,241.6 1752.8,236 1742.7,240.2 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1720.3,201.9 1724,205.8 1723.3,208.2 1735.7,203.7 1737.7,196.2 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1739.6,208.3 1750.4,205.3 1752.4,196.4 1741.4,200.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1732.1,183.4 1733,176.7 1727.4,178.9 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1737.7,196.2 1735.7,203.7 1739.6,208.3 1741.4,200.6 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1713,210 1711.4,217.8 1721.6,214.2 1723.3,208.2 1724,205.8 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1709.1,205.4 1708.5,207.5 1705.3,204.4 1704,210 1711.4,217.8 1713,210 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1694.5,191 1687.4,182.6 1685.7,193.2 1692.1,200.2 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls9}
                    points="1694.5,191 1692.1,200.2 1698.4,197.6 1700.3,188.8 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1709.1,205.4 1705.9,201.6 1710.9,199.6 1700.3,188.8 1698.4,197.6 1705.3,204.4 1708.5,207.5
				"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.cls8}
                    points="1715,172.5 1713.8,180.1 1719.6,178 			"
                  />
                </g>
                <g>
                  <polygon
                    className={classes.barnPath}
                    points="1700.3,188.8 1710.9,199.6 1705.9,201.6 1709.1,205.4 1713,210 1724,205.8 1720.3,201.9
				1720.3,201.9 1737.7,196.2 1741.4,200.6 1752.4,196.4 1744.5,188 1739.1,190.2 1732.1,183.4 1727.4,178.9 1733,176.7
				1725.1,168.3 1715,172.5 1719.6,178 1713.8,180.1 1702.9,184 1697.6,178.4 1687.4,182.6 1694.5,191 			"
                  />
                </g>
              </g>
              <g data-name={"mapName"}>
                <path
                  d="M1301.9,886.1c-1.5,1-3.2,1.9-4.9,2.7c-1-2.8-3.4-5-6.4-5.8v-26.3c2.9-0.6,5.4-2.3,7-4.7c1.4,0.9,2.8,1.9,4,3l2.9-3.5
			c-1.6-1.4-3.4-2.6-5.2-3.8c0.1-0.6,0.2-1.2,0.2-1.9c0-6.2-5-11.2-11.2-11.2c-3.9,0-7.4,2-9.4,5.1c-2.8-0.5-5.6-0.8-8.3-0.9v-3
			c1.5-0.8,2.6-2.4,2.6-4.3c0-2.7-2.2-4.9-4.9-4.9s-4.9,2.2-4.9,4.9c0,1.9,1.1,3.5,2.6,4.3v3.1c-2.8,0.1-5.5,0.4-8.1,0.9
			c-2-3.1-5.5-5.2-9.4-5.2c-6.2,0-11.2,5-11.2,11.2c0,1,0.1,2,0.4,3c-6.3,5.4-9.7,12.8-9.7,20.8c0,8.9,3.3,16.4,9.7,21.5
			c0.4,0.3,0.8,0.6,1.3,1v13.3h7.7c1.4,5.2,6.1,9,11.7,9c6.7,0,12.2-5.5,12.2-12.2v-2.6c2.6-0.1,5.5-0.4,8.5-0.8v6.6h18.4v-11.8
			c2.4-1,4.7-2.2,6.8-3.6L1301.9,886.1L1301.9,886.1z M1292.8,890.5c-3,1.1-6.1,2-9.1,2.7v-1.3c0-2.6,2.1-4.7,4.7-4.7
			C1290.4,887.3,1292.2,888.6,1292.8,890.5 M1288.3,852.3c-3.7,0-6.6-3-6.6-6.6c0-0.3,0-0.5,0-0.8c4.1,1.1,8.2,2.6,11.9,4.6
			C1292.4,851.2,1290.5,852.3,1288.3,852.3 M1281.5,854.6l-0.1,0.2 M1288.3,839.1c3.4,0,6.3,2.6,6.6,6c-3.5-1.8-7.2-3.2-11-4.3
			C1285,839.7,1286.6,839.1,1288.3,839.1 M1277.2,844c-0.1,0.6-0.1,1.1-0.1,1.7c0,2.9,1.1,5.5,2.9,7.5c-1.6,2.6-5.6,8.8-9.4,14.7
			v-24.5C1272.8,843.4,1275,843.6,1277.2,844 M1255.1,845c0,0.2,0,0.5,0,0.8c0,3.7-3,6.6-6.6,6.6c-2,0-3.8-0.9-5-2.3
			C1246.8,847.8,1250.7,846.1,1255.1,845 M1255.1,854.7L1255.1,854.7L1255.1,854.7L1255.1,854.7 M1248.2,887.3
			c2.6,0,4.7,2.1,4.7,4.7v1.3c-3.3-0.8-6.3-2-8.8-3.4C1244.9,888.3,1246.4,887.3,1248.2,887.3 M1250.8,883.1v-26.4
			c0.7-0.1,1.4-0.4,2.1-0.6c0.3,0.5,0.7,1.1,1.1,1.8c1.2,1.9,2.9,4.5,5,7.8c3,4.6,6,9.2,7,10.7V895c-3-0.1-5.9-0.4-8.6-0.8v-2.3
			C1257.5,887.7,1254.7,884.2,1250.8,883.1 M1268.3,829.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7
			C1266.6,830.5,1267.4,829.7,1268.3,829.7 M1266,843.4v24.5c-3.7-5.8-7.6-11.8-9.4-14.5c1.9-2,3.1-4.7,3.1-7.7c0-0.6,0-1.1-0.1-1.7
			C1261.6,843.7,1263.8,843.5,1266,843.4 M1248.5,839.1c1.7,0,3.3,0.6,4.4,1.7c-4.1,1.1-7.8,2.7-11,4.8
			C1242,842,1244.9,839.1,1248.5,839.1 M1232.7,869.5c0-6.3,2.6-12.2,7.3-16.6c1.6,1.9,3.8,3.3,6.3,3.8v26.3
			c-2.5,0.6-4.6,2.1-5.9,4.3C1235.2,882.9,1232.7,877,1232.7,869.5 M1243.6,894.7c2.8,1.4,5.9,2.4,9.3,3.2v2.8h-9.3V894.7
			L1243.6,894.7z M1258.4,909.7c-3.1,0-5.7-1.8-6.9-4.4h6v-6.5c2.7,0.4,5.5,0.6,8.6,0.7v2.6C1266,906.3,1262.6,909.7,1258.4,909.7
			 M1270.6,895v-18.7c1-1.6,4-6.2,6.9-10.7c2.1-3.3,3.8-5.9,5-7.8c0.5-0.7,0.9-1.3,1.2-1.9c0.7,0.3,1.5,0.6,2.3,0.8V883
			c-4,1-6.9,4.6-6.9,8.9v2.2C1276.1,894.6,1273.2,894.9,1270.6,895 M1293,900.7h-9.3v-2.8c3.1-0.7,6.3-1.5,9.3-2.6V900.7L1293,900.7
			z"
                />
                <polygon
                  points="1333.4,865.8 1326,842.4 1326,865.8 1322.2,865.8 1322.2,839 1328.5,839 1335.4,861.3 1342.2,839 1348.5,839
			1348.5,865.8 1344.8,865.8 1344.8,842.4 1337.4,865.8 1333.4,865.8 		"
                />
                <path
                  d="M1358.8,856.8h10l-5-14L1358.8,856.8L1358.8,856.8z M1361.7,839h4.4l10.1,26.8h-4.1l-2.1-5.8h-12.3l-2.1,5.8h-3.8
			L1361.7,839L1361.7,839z"
                />
                <path
                  d="M1383.1,842.1v9.2h5c4,0,7-0.4,7-4.6c0-4.1-3-4.6-7-4.6H1383.1L1383.1,842.1z M1389.9,854.5c-0.7,0-1.3,0-2,0h-4.7v11.3
			h-3.8V839h8.5c6.5,0,11.2,1.3,11.2,7.7c0,4.3-2,6.3-5.3,7.2l6.2,11.9h-4.2L1389.9,854.5L1389.9,854.5z"
                />
                <polygon
                  points="1404.4,839 1411.7,852.1 1419.2,839 1423.3,839 1413.5,855.4 1413.5,865.8 1409.7,865.8 1409.7,855.3 1400.2,839
			1404.4,839 		"
                />
                <polygon points="1430.3,862.5 1444.5,862.5 1444.5,865.8 1426.5,865.8 1426.5,839 1430.3,839 1430.3,862.5 		" />
                <path
                  d="M1451.5,856.8h10l-5-14L1451.5,856.8L1451.5,856.8z M1454.4,839h4.4l10.1,26.8h-4.1l-2.1-5.8h-12.3l-2.1,5.8h-3.8
			L1454.4,839L1454.4,839z"
                />
                <polygon
                  points="1488.2,865.8 1475.9,842.9 1475.9,865.8 1472.1,865.8 1472.1,839 1477.7,839 1489.9,861.8 1489.9,839 1493.7,839
			1493.7,865.8 1488.2,865.8 		"
                />
                <path
                  d="M1507.3,842.1h-3.4v20.5h3.4c5.5,0,10.9-1.1,10.9-10.3C1518.2,843.2,1512.8,842.1,1507.3,842.1L1507.3,842.1z M1507.4,839
			c8.5,0,14.6,3.2,14.6,13.4c0,10.2-6.1,13.4-14.6,13.4h-7.3V839H1507.4L1507.4,839z"
                />
                <path
                  d="M1546.2,839h3.8v18.3c0,5.9-3.1,9-8.4,9c-5.3,0-8.4-2.9-8.4-8.8h3.5c0,3.7,2.2,5.7,4.9,5.7c2.2,0,4.7-1.1,4.7-6V839
			L1546.2,839z"
                />
                <path
                  d="M1567.4,863.1c4.9,0,8.7-3.8,8.7-10.7c0-6.9-3.8-10.7-8.7-10.7c-4.9,0-8.7,3.8-8.7,10.7
			C1558.7,859.3,1562.5,863.1,1567.4,863.1L1567.4,863.1z M1567.4,866.3c-7.7,0-12.6-5.8-12.6-13.9s4.9-13.9,12.6-13.9
			c7.7,0,12.6,5.8,12.6,13.9S1575.1,866.3,1567.4,866.3L1567.4,866.3z"
                />
                <path
                  d="M1608,857.2c-1.2,5.9-5.8,9-11.6,9c-7.7,0-12.2-5.8-12.2-14c0-8.3,4.9-13.8,12.5-13.8c5.6,0,10,3.3,11.2,9h-3.7
			c-0.8-3.4-3.4-5.8-7.7-5.8c-4.7,0-8.4,3.7-8.4,10.7c0,6.8,3.6,10.8,8.6,10.8c4.3,0,6.9-2.4,7.7-5.8H1608L1608,857.2z"
                />
                <polygon
                  points="1616.1,852.5 1628.2,839 1632.9,839 1622.9,849.9 1634.1,865.8 1629.5,865.8 1620.3,852.7 1616.1,857.3
			1616.1,865.8 1612.3,865.8 1612.3,839 1616.1,839 1616.1,852.5 		"
                />
                <polygon
                  points="1637,839 1655.2,839 1655.2,842.2 1640.8,842.2 1640.8,850.4 1654.4,850.4 1654.4,853.6 1640.8,853.6
			1640.8,862.5 1655.2,862.5 1655.2,865.8 1637,865.8 1637,839 		"
                />
                <polygon
                  points="1660.7,839 1668,852.1 1675.5,839 1679.6,839 1669.8,855.4 1669.8,865.8 1666,865.8 1666,855.3 1656.5,839
			1660.7,839 		"
                />
                <path
                  d="M1714.1,857.2c-1.2,5.9-5.8,9-11.6,9c-7.7,0-12.2-5.8-12.2-14c0-8.3,4.9-13.8,12.5-13.8c5.6,0,10,3.3,11.2,9h-3.7
			c-0.8-3.4-3.4-5.8-7.7-5.8c-4.7,0-8.4,3.7-8.4,10.7c0,6.8,3.6,10.8,8.6,10.8c4.3,0,6.9-2.4,7.7-5.8H1714.1L1714.1,857.2z"
                />
                <polygon points="1722.2,862.5 1736.4,862.5 1736.4,865.8 1718.5,865.8 1718.5,839 1722.2,839 1722.2,862.5 		" />
                <path
                  d="M1743,839v16.3c0,5.3,1.9,7.7,6.9,7.7c5.1,0,7-2.9,7-8.1V839h3.8v15.6c0,7.8-3,11.7-10.8,11.7c-7.4,0-10.7-3-10.7-11.4
			V839H1743L1743,839z"
                />
                <path
                  d="M1770.5,862.6h6.8c3.8,0,5.7-1.6,5.7-4.7c0-3.1-1.8-4.5-5.9-4.5h-6.6V862.6L1770.5,862.6z M1770.5,850.4h6.5
			c3.1,0,5-1.2,5-4.3c0-2.8-2-4-5-4h-6.5V850.4L1770.5,850.4z M1766.7,839h9.7c5,0,9.4,1.3,9.4,6.6c0,2.6-1.1,4.8-3,5.9
			c2.6,1.1,4.1,3.1,4.1,6.4c0,5.7-4.3,7.9-9.6,7.9h-10.6V839L1766.7,839z"
                />
                <path
                  d="M1326.1,895.6h10l-5-14L1326.1,895.6L1326.1,895.6z M1329,877.8h4.4l10.1,26.8h-4.1l-2.1-5.8h-12.3l-2.1,5.8h-3.8
			L1329,877.8L1329,877.8z"
                />
                <polygon points="1349.5,881 1340.8,881 1340.8,877.8 1362,877.8 1362,881 1353.3,881 1353.3,904.6 1349.5,904.6 1349.5,881 		" />
                <polygon points="1377.8,901.4 1392,901.4 1392,904.6 1374,904.6 1374,877.8 1377.8,877.8 1377.8,901.4 		" />
                <path
                  d="M1399,895.6h10l-5-14L1399,895.6L1399,895.6z M1401.9,877.8h4.4l10.1,26.8h-4.1l-2.1-5.8h-12.3l-2.1,5.8h-3.8
			L1401.9,877.8L1401.9,877.8z"
                />
                <path
                  d="M1422.3,877.8v16.3c0,5.3,1.9,7.7,6.9,7.7c5.1,0,7-2.9,7-8.1v-15.9h3.8v15.6c0,7.8-3,11.7-10.8,11.7
			c-7.4,0-10.7-3-10.7-11.4v-15.9H1422.3L1422.3,877.8z"
                />
                <path
                  d="M1449.8,881v9.2h5c4,0,7-0.4,7-4.6c0-4.1-3-4.6-7-4.6H1449.8L1449.8,881z M1456.5,893.3c-0.7,0-1.3,0-2,0h-4.7v11.3h-3.8
			v-26.8h8.5c6.5,0,11.2,1.3,11.2,7.7c0,4.3-2,6.3-5.3,7.2l6.2,11.9h-4.2L1456.5,893.3L1456.5,893.3z"
                />
                <polygon
                  points="1471.1,877.8 1489.3,877.8 1489.3,881 1474.9,881 1474.9,889.2 1488.5,889.2 1488.5,892.4 1474.9,892.4
			1474.9,901.4 1489.3,901.4 1489.3,904.6 1471.1,904.6 1471.1,877.8 		"
                />
                <polygon points="1497.6,901.4 1511.8,901.4 1511.8,904.6 1493.8,904.6 1493.8,877.8 1497.6,877.8 1497.6,901.4 		" />
                <path
                  d="M1527.5,881v9.7h4.9c4,0,7-0.4,7-4.8c0-4.4-3-4.9-7-4.9H1527.5L1527.5,881z M1532.2,877.8c6.6,0,11.1,1.5,11.1,8.1
			c0,6.7-4.6,8.1-11.1,8.1h-4.6v10.6h-3.8v-26.8H1532.2L1532.2,877.8z"
                />
                <path
                  d="M1548.6,895.6h10l-5-14L1548.6,895.6L1548.6,895.6z M1551.5,877.8h4.4l10.1,26.8h-4.1l-2.1-5.8h-12.3l-2.1,5.8h-3.8
			L1551.5,877.8L1551.5,877.8z"
                />
                <path
                  d="M1572.9,881v9.2h5c4,0,7-0.4,7-4.6c0-4.1-3-4.6-7-4.6H1572.9L1572.9,881z M1579.7,893.3c-0.7,0-1.3,0-2,0h-4.7v11.3h-3.8
			v-26.8h8.5c6.5,0,11.2,1.3,11.2,7.7c0,4.3-2,6.3-5.3,7.2l6.2,11.9h-4.2L1579.7,893.3L1579.7,893.3z"
                />
                <polygon
                  points="1598.1,891.3 1610.2,877.8 1614.9,877.8 1604.9,888.7 1616,904.6 1611.5,904.6 1602.3,891.5 1598.1,896.2
			1598.1,904.6 1594.3,904.6 1594.3,877.8 1598.1,877.8 1598.1,891.3 		"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M624.3,898l-1.2-10.2l-1.9,9.6l-1.8-0.3l2.2-11.4l2.9,0.6l1,9.9l4.7-8.7l2.9,0.6l-2.2,11.4l-1.8-0.3l1.9-9.6
			l-4.9,9L624.3,898z"
                />
                <path
                  className={classes.cls10}
                  d="M638.6,889l2,0.4l2.1,12.2l-1.9-0.4l-0.4-2.7l-4.9-1l-1.4,2.3l-1.8-0.4L638.6,889z M636.2,896.2l3.9,0.8
			l-0.9-5.8L636.2,896.2z"
                />
                <path
                  className={classes.cls10}
                  d="M645.7,902.2l-1.8-0.3l2.2-11.4l1.8,0.3L645.7,902.2z"
                />
                <path
                  className={classes.cls10}
                  d="M655,904l-3.2-10.4L650,903l-1.8-0.3l2.2-11.4l2.5,0.5l3.2,10.4l1.8-9.4l1.8,0.3l-2.2,11.4L655,904z"
                />
                <path
                  className={classes.cls10}
                  d="M664.4,895.6l-3.7-0.7l0.3-1.5l9.1,1.8l-0.3,1.5l-3.6-0.7l-1.9,9.9l-1.8-0.3L664.4,895.6z"
                />
                <path
                  className={classes.cls10}
                  d="M671.4,895.4l7.9,1.5l-0.3,1.5l-6.1-1.2l-0.6,3.3l5.8,1.1l-0.3,1.5l-5.8-1.1l-0.7,3.6l6.1,1.2l-0.3,1.5
			l-7.9-1.5L671.4,895.4z"
                />
                <path
                  className={classes.cls10}
                  d="M685.6,910l-3.2-10.4l-1.8,9.4l-1.8-0.3l2.2-11.4l2.5,0.5l3.2,10.4l1.8-9.4l1.8,0.3l-2.2,11.4L685.6,910z"
                />
                <path
                  className={classes.cls10}
                  d="M695.8,900.1l2,0.4l2.1,12.2l-1.9-0.4l-0.4-2.7l-4.9-1l-1.4,2.3l-1.8-0.4L695.8,900.1z M693.4,907.3l3.9,0.8
			l-0.9-5.8L693.4,907.3z"
                />
                <path
                  className={classes.cls10}
                  d="M707.9,914.3l-3.2-10.4l-1.8,9.4l-1.8-0.3l2.2-11.4l2.5,0.5l3.2,10.4l1.8-9.4l1.8,0.3l-2.2,11.4L707.9,914.3
			z"
                />
                <path
                  className={classes.cls10}
                  d="M723.2,913.4c-1,2.4-3.1,3.5-5.7,3c-3.3-0.6-4.7-3.4-4.1-6.9c0.7-3.6,3.2-5.5,6.5-4.8c2.4,0.5,4,2.3,4,4.8
			l-1.7-0.3c-0.1-1.6-1-2.7-2.6-3c-1.9-0.4-3.7,0.9-4.3,3.7c-0.5,2.8,0.6,4.7,2.6,5.1c1.7,0.3,3-0.4,3.6-1.8L723.2,913.4z"
                />
                <path
                  className={classes.cls10}
                  d="M726.5,906.1l7.9,1.5l-0.3,1.5L728,908l-0.6,3.3l5.8,1.1l-0.3,1.5l-5.8-1.1l-0.7,3.6l6.1,1.2l-0.3,1.5
			l-7.9-1.5L726.5,906.1z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M705.3,591.1l4.3-6.3l2.2-0.3l-3.7,5.3l5.6,6.2l-2.1,0.3l-4.5-5l-1.5,2.1l0.5,3.6l-1.8,0.2l-1.5-11.5
			l1.8-0.2L705.3,591.1z"
                />
                <path
                  className={classes.cls10}
                  d="M716.7,595.6l-1.8,0.2l-1.5-11.5l1.8-0.2L716.7,595.6z"
                />
                <path
                  className={classes.cls10}
                  d="M720.4,584.9l-3.7,0.5l-0.2-1.5l9.2-1.2l0.2,1.5l-3.7,0.5l1.3,10l-1.8,0.2L720.4,584.9z"
                />
                <path
                  className={classes.cls10}
                  d="M737.1,589.1c-0.2,2.6-1.9,4.3-4.4,4.6c-3.3,0.4-5.6-1.8-6.1-5.3c-0.5-3.6,1.3-6.2,4.6-6.6
			c2.5-0.3,4.5,0.9,5.3,3.3l-1.7,0.2c-0.6-1.5-1.8-2.3-3.5-2c-2,0.3-3.2,2-2.9,4.9c0.4,2.8,2.1,4.3,4,4c1.7-0.2,2.7-1.3,2.9-2.9
			L737.1,589.1z"
                />
                <path
                  className={classes.cls10}
                  d="M747.3,579.8l1.5,11.5l-1.8,0.2l-0.7-5.2l-5.8,0.8l0.7,5.2l-1.8,0.2l-1.5-11.5l1.8-0.2l0.6,4.8l5.8-0.8
			l-0.6-4.8L747.3,579.8z"
                />
                <path
                  className={classes.cls10}
                  d="M749.8,579.5l8-1l0.2,1.5l-6.2,0.8l0.4,3.3l5.8-0.8l0.2,1.5l-5.8,0.8l0.5,3.6l6.2-0.8l0.2,1.5l-8,1
			L749.8,579.5z"
                />
                <path
                  className={classes.cls10}
                  d="M767.9,588.8l-6.3-8.9l1.2,9.5l-1.8,0.2l-1.5-11.5l2.5-0.3l6.3,8.8l-1.2-9.5l1.8-0.2l1.5,11.5L767.9,588.8z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M777.5,625.8c3.2-0.3,5.7,0.6,6.1,4.5c0.4,3.9-1.9,5.3-5.1,5.6l-2.8,0.3l-1-10.1L777.5,625.8z M777.5,627.1
			l-1.1,0.1l0.8,7.5l1.1-0.1c2-0.2,4-0.8,3.6-4.2C781.6,627.1,779.6,626.9,777.5,627.1z"
                />
                <path
                  className={classes.cls10}
                  d="M790.3,634.9c-2.9,0.3-5-1.7-5.3-4.8s1.3-5.4,4.3-5.7c2.9-0.3,5,1.7,5.3,4.7
			C794.9,632.2,793.3,634.6,790.3,634.9z M790.2,633.5c1.7-0.2,3-1.7,2.7-4.2c-0.3-2.5-1.8-3.8-3.5-3.6c-1.8,0.2-3,1.7-2.8,4.2
			C786.9,632.5,788.4,633.7,790.2,633.5z"
                />
                <path
                  className={classes.cls10}
                  d="M800.4,629.3c-0.2,0-0.4,0.1-0.7,0.1l-1.7,0.2l0.4,4.3l-1.6,0.2l-1-10.1l3.2-0.3c2.7-0.3,4.4,0.1,4.6,2.5
			c0.1,1.4-0.5,2.3-1.7,2.9l2.8,4.3l-1.8,0.2L800.4,629.3z M797.6,625.1l0.3,3.2l1.8-0.2c1.5-0.2,2.5-0.5,2.3-1.9
			c-0.1-1.4-1.3-1.5-2.7-1.4L797.6,625.1z"
                />
                <path
                  className={classes.cls10}
                  d="M810.6,632.6l-3.5-8.2l0.9,8.5l-1.6,0.2l-1-10.1l2.6-0.3l3.4,8l1.7-8.5l2.6-0.3l1,10.1l-1.6,0.2l-0.9-8.5
			l-1.8,8.8L810.6,632.6z"
                />
                <path
                  className={classes.cls10}
                  d="M823.5,631.3l-1.6,0.2l-1-10.1l1.6-0.2L823.5,631.3z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M955.9,608.6c3,1.1,4.9,3,3.6,6.6c-1.3,3.7-3.9,4-7,2.9l-2.6-0.9l3.4-9.6L955.9,608.6z M955.4,609.8l-1-0.4
			l-2.5,7.1l1,0.4c1.9,0.7,3.9,0.9,5-2.2C959.1,611.5,957.3,610.5,955.4,609.8z"
                />
                <path
                  className={classes.cls10}
                  d="M963.7,622.2c-2.8-1-3.8-3.6-2.8-6.6c1-2.9,3.5-4.3,6.3-3.4c2.8,1,3.8,3.6,2.8,6.5
			C969,621.8,966.5,623.2,963.7,622.2z M964.2,621c1.7,0.6,3.4-0.3,4.3-2.7c0.8-2.4,0-4.2-1.7-4.7c-1.7-0.6-3.4,0.2-4.3,2.7
			C961.6,618.6,962.5,620.4,964.2,621z"
                />
                <path
                  className={classes.cls10}
                  d="M975.2,621.5c-0.2-0.1-0.4-0.1-0.6-0.2l-1.7-0.6l-1.4,4l-1.5-0.5l3.4-9.6l3,1.1c2.6,0.9,3.9,2,3.2,4.2
			c-0.5,1.4-1.4,1.9-2.7,1.9l0.7,5.1l-1.7-0.6L975.2,621.5z M974.4,616.4l-1.1,3.1l1.7,0.6c1.4,0.5,2.5,0.6,2.9-0.7
			c0.5-1.4-0.5-1.9-1.9-2.4L974.4,616.4z"
                />
                <path
                  className={classes.cls10}
                  d="M983,628.8l0.3-9l-2.8,8.1l-1.5-0.5l3.4-9.6l2.4,0.8l-0.4,8.7l5.1-7l2.4,0.8l-3.4,9.6l-1.5-0.5l2.8-8.1
			l-5.4,7.2L983,628.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1004.9,625.8l-3.4,9.6l-1.5-0.5l1.5-4.3l-4.8-1.7l-1.5,4.3l-1.5-0.5l3.4-9.6l1.5,0.5l-1.4,4l4.8,1.7l1.4-4
			L1004.9,625.8z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1162.4,715.7l3.2-2c1.6-1,3.3-1.5,4.4,0.2c0.5,0.8,0.6,1.8,0.2,2.5c1-0.1,1.9,0.1,2.6,1.2
			c1.1,1.8,0.2,3.4-1.6,4.5l-3.4,2.1L1162.4,715.7z M1166,718.5l2-1.2c0.9-0.6,1.3-1.3,0.7-2.3c-0.5-0.8-1.4-0.8-2.3-0.3l-2,1.2
			L1166,718.5z M1168.4,722.3l2.1-1.3c1.2-0.7,1.4-1.6,0.8-2.5c-0.6-0.9-1.4-1-2.7-0.3l-2,1.3L1168.4,722.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1176.8,713.5c-0.2,0.1-0.4,0.2-0.6,0.4l-1.5,0.9l2.3,3.6l-1.4,0.8l-5.4-8.6l2.7-1.7c2.3-1.5,4-1.8,5.3,0.2
			c0.8,1.2,0.6,2.3-0.2,3.3l4.4,2.6l-1.5,1L1176.8,713.5z M1172.4,710.9l1.7,2.8l1.6-1c1.3-0.8,2-1.5,1.3-2.7c-0.8-1.2-1.8-0.8-3,0
			L1172.4,710.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1187.4,712.2c-2.5,1.6-5.2,0.7-6.9-1.9s-1.2-5.4,1.3-7c2.5-1.6,5.2-0.7,6.8,1.9S1189.9,710.6,1187.4,712.2z
			 M1186.7,711c1.5-0.9,1.9-2.9,0.6-5c-1.4-2.2-3.3-2.6-4.8-1.7c-1.5,0.9-2,2.8-0.6,5C1183.3,711.5,1185.2,712,1186.7,711z"
                />
                <path
                  className={classes.cls10}
                  d="M1198.6,701.1c0.8,2.1,0.1,4.1-1.9,5.3c-2.5,1.6-5.1,0.6-6.7-2c-1.7-2.7-1.2-5.4,1.2-7
			c1.8-1.2,3.9-1,5.4,0.7l-1.3,0.8c-1-1-2.2-1.2-3.5-0.4c-1.5,0.9-1.8,2.8-0.5,4.9c1.3,2.1,3.2,2.7,4.7,1.7c1.3-0.8,1.7-2,1.2-3.3
			L1198.6,701.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1200.3,697.8l1.1-6.6l1.6-1l-1,5.5l6.7,2.9l-1.6,1l-5.4-2.3l-0.4,2.3l1.7,2.7l-1.4,0.8l-5.4-8.6l1.4-0.8
			L1200.3,697.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1207,687.7l3.2-2c1.6-1,3.3-1.5,4.4,0.2c0.5,0.8,0.6,1.8,0.2,2.5c1-0.1,1.9,0.1,2.6,1.2
			c1.1,1.8,0.2,3.4-1.6,4.5l-3.4,2.1L1207,687.7z M1210.6,690.5l2-1.2c0.9-0.6,1.3-1.3,0.7-2.3c-0.5-0.8-1.4-0.8-2.3-0.3l-2,1.2
			L1210.6,690.5z M1213,694.4l2.1-1.3c1.2-0.7,1.4-1.6,0.8-2.5c-0.6-1-1.4-1-2.7-0.3l-2,1.3L1213,694.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1221.5,685.6c-0.2,0.1-0.4,0.2-0.6,0.4l-1.5,0.9l2.3,3.6l-1.4,0.8l-5.4-8.6l2.7-1.7c2.3-1.5,4-1.8,5.3,0.2
			c0.8,1.2,0.6,2.3-0.2,3.3l4.4,2.6l-1.5,1L1221.5,685.6z M1217,683l1.7,2.8l1.6-1c1.3-0.8,2-1.5,1.3-2.7c-0.8-1.2-1.8-0.8-3,0
			L1217,683z"
                />
                <path
                  className={classes.cls10}
                  d="M1229.7,685.5l-1.4,0.8l-5.4-8.6l1.4-0.8L1229.7,685.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1228.6,674.2c2.7-1.7,5.4-2,7.4,1.3c2.1,3.3,0.7,5.6-2.1,7.3l-2.4,1.5l-5.4-8.6L1228.6,674.2z
			 M1229.2,675.3l-0.9,0.6l4,6.4l0.9-0.6c1.7-1.1,3.2-2.5,1.4-5.3C1232.9,673.6,1231,674.3,1229.2,675.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1243.9,668.3l-1.3,0.8c-0.9-0.8-2.1-1-3.4-0.2c-1.5,0.9-1.9,2.8-0.5,5c1.3,2.1,3.2,2.7,4.7,1.7
			c1.1-0.7,2.2-2,1.1-3.6l-0.1-0.2l-2.2,1.4l-0.7-1.2l3.5-2.2l2.8,4.4l-1.1,0.7l-0.7-1c0,1.2-0.7,2.1-1.9,2.9
			c-2.5,1.5-5.1,0.6-6.7-2c-1.7-2.7-1.2-5.4,1.3-7C1240.4,666.6,1242.4,666.7,1243.9,668.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1244.1,664.5l6-3.7l0.7,1.2l-4.6,2.9l1.5,2.5l4.3-2.7l0.7,1.1l-4.3,2.7l1.7,2.7l4.6-2.9l0.7,1.2l-6,3.7
			L1244.1,664.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1260.6,661.1c-0.2,0.1-0.4,0.2-0.6,0.4l-1.5,0.9l2.3,3.6l-1.4,0.8l-5.4-8.6l2.7-1.7c2.3-1.5,4-1.8,5.3,0.2
			c0.8,1.2,0.6,2.3-0.2,3.3l4.4,2.6l-1.5,1L1260.6,661.1z M1256.2,658.5l1.7,2.8l1.6-1c1.3-0.8,2-1.5,1.3-2.7c-0.8-1.2-1.8-0.8-3,0
			L1256.2,658.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1264.5,651.7c2.7-1.7,5.4-2,7.4,1.3c2.1,3.3,0.7,5.6-2.1,7.3l-2.4,1.5l-5.4-8.6L1264.5,651.7z
			 M1265.2,652.8l-0.9,0.6l4,6.4l0.9-0.6c1.7-1.1,3.2-2.5,1.4-5.3C1268.8,651.1,1266.9,651.8,1265.2,652.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1275.3,656.9l-0.9-1.5l1.5-0.9l0.9,1.5L1275.3,656.9z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1175.6,94h5.5v1.5h-7.2V84.1h1.7V94z"
                />
                <path
                  className={classes.cls10}
                  d="M1185.1,84.1h1.9l4,11.5h-1.8l-0.8-2.5h-4.6l-0.8,2.5h-1.7L1185.1,84.1z M1184.1,91.5h3.6l-1.8-5.5
			L1184.1,91.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1193.7,84.1v6.9c0,2.2,0.6,3.3,2.6,3.3s2.7-1.2,2.7-3.4v-6.8h1.7v6.7c0,3.5-1.2,5-4.3,5
			c-3,0-4.3-1.3-4.3-4.9v-6.8H1193.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1207,90.7c-0.2,0-0.5,0-0.7,0h-1.8v4.8h-1.7V84.1h3.4c2.9,0,4.6,0.6,4.6,3.3c0,1.6-0.7,2.6-2.1,3l2.5,5.1
			h-1.9L1207,90.7z M1204.5,85.6v3.7h1.9c1.6,0,2.7-0.3,2.7-1.8c0-1.6-1.2-1.9-2.7-1.9H1204.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1212.8,84.1h7.4v1.5h-5.7v3.3h5.4v1.5h-5.4V94h5.7v1.5h-7.4V84.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1223.6,94h5.5v1.5h-7.2V84.1h1.7V94z"
                />
                <path
                  className={classes.cls10}
                  d="M1237.9,90.7c-0.2,0-0.5,0-0.7,0h-1.8v4.8h-1.7V84.1h3.4c2.9,0,4.6,0.6,4.6,3.3c0,1.6-0.7,2.6-2.1,3l2.5,5.1
			h-1.9L1237.9,90.7z M1235.4,85.6v3.7h1.9c1.6,0,2.7-0.3,2.7-1.8c0-1.6-1.2-1.9-2.7-1.9H1235.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1246.6,84.1h1.9l4,11.5h-1.8l-0.8-2.5h-4.6l-0.8,2.5h-1.7L1246.6,84.1z M1245.7,91.5h3.6l-1.8-5.5
			L1245.7,91.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1262.7,91.8c-0.5,2.5-2.2,3.9-4.6,3.9c-3.1,0-4.9-2.4-4.9-6c0-3.6,1.9-5.9,5-5.9c2.3,0,4,1.4,4.5,3.9h-1.6
			c-0.3-1.5-1.3-2.4-2.9-2.4c-1.8,0-3.2,1.6-3.2,4.4c0,2.8,1.4,4.5,3.2,4.5c1.6,0,2.6-0.9,2.9-2.4H1262.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1264.4,84.1h7.4v1.5h-5.7v3.3h5.4v1.5h-5.4V94h5.7v1.5h-7.4V84.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1275.7,85.6h-3.4v-1.5h8.5v1.5h-3.4v9.9h-1.7V85.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1286.3,90.7c-0.2,0-0.5,0-0.7,0h-1.8v4.8h-1.7V84.1h3.4c2.9,0,4.6,0.6,4.6,3.3c0,1.6-0.7,2.6-2.1,3l2.5,5.1
			h-1.9L1286.3,90.7z M1283.7,85.6v3.7h1.9c1.6,0,2.7-0.3,2.7-1.8c0-1.6-1.2-1.9-2.7-1.9H1283.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1295,84.1h1.9l4,11.5h-1.8l-0.8-2.5h-4.6l-0.8,2.5h-1.7L1295,84.1z M1294.1,91.5h3.6l-1.8-5.5L1294.1,91.5z
			"
                />
                <path
                  className={classes.cls10}
                  d="M1311.1,91.8c-0.5,2.5-2.2,3.9-4.6,3.9c-3.1,0-4.9-2.4-4.9-6c0-3.6,1.9-5.9,5-5.9c2.3,0,4,1.4,4.5,3.9h-1.6
			c-0.3-1.5-1.3-2.4-2.9-2.4c-1.8,0-3.2,1.6-3.2,4.4c0,2.8,1.4,4.5,3.2,4.5c1.6,0,2.6-0.9,2.9-2.4H1311.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1314.4,89.7l4.7-5.6h2l-4,4.7l4.4,6.8h-2l-3.5-5.5l-1.6,1.9v3.6h-1.7V84.1h1.7V89.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1330.3,90.7c-0.2,0-0.5,0-0.7,0h-1.8v4.8h-1.7V84.1h3.4c2.9,0,4.6,0.6,4.6,3.3c0,1.6-0.7,2.6-2.1,3l2.5,5.1
			h-1.9L1330.3,90.7z M1327.8,85.6v3.7h1.9c1.6,0,2.7-0.3,2.7-1.8c0-1.6-1.2-1.9-2.7-1.9H1327.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1339,84.1c3.4,0,5.9,1.3,5.9,5.7c0,4.4-2.5,5.7-5.9,5.7h-2.9V84.1H1339z M1338.9,85.6h-1.2V94h1.2
			c2.1,0,4.2-0.5,4.2-4.3C1343.2,86,1341.1,85.6,1338.9,85.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1345.7,95.5v-2h1.8v2H1345.7z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1762.8,169.6l-6.7,2.6l-0.8-1.2l8.4-3l0.9,1.4l-4.9,5.1l6.6-2.5l0.9,1.4l-6.1,6.6l-0.8-1.3l5-5.1l-6.7,2.6
			l-0.9-1.3L1762.8,169.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1750.9,164.2l7.3-4.8l0.8,1.1l-3.3,2.1l2.4,3.6l3.3-2.1l0.8,1.1l-7.3,4.8l-0.8-1.1l3-2l-2.4-3.6l-3,2
			L1750.9,164.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1756.3,156.7l0.8,1.1l-7.3,4.8l-0.8-1.1L1756.3,156.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1750.7,155.5c0.5,1.2,0.5,2.5-0.7,3.3c-1.4,0.9-3-0.1-3.8-1.3c-0.9-1.3-1-2.9,0.3-4.1l0.7,1.1
			c-0.7,0.8-0.5,1.8,0,2.5c0.3,0.5,1.2,1.3,2,0.8c0.6-0.4,0.6-1.1,0.3-1.8l-0.4-1c-0.5-1.3-0.9-2.9,0.5-3.8c1.4-0.9,3.1,0,4,1.4
			c1.1,1.7,0.9,3.4-0.5,4.6l-0.7-1.1c0.9-0.9,0.9-1.9,0.3-2.9c-0.6-1-1.5-1.3-2.2-0.8c-0.8,0.5-0.6,1.4-0.2,2.3L1750.7,155.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1746.6,149.9l-5.7-0.8l-0.9-1.4l4.7,0.8l2.3-5.8l0.9,1.4l-1.9,4.7l1.9,0.3l2.3-1.5l0.8,1.1l-7.3,4.8
			l-0.8-1.1L1746.6,149.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1739.3,146.7l-3.3-5l1-0.6l2.6,3.9l2.1-1.4l-2.4-3.7l1-0.6l2.4,3.7l2.3-1.5l-2.6-3.9l1-0.6l3.3,5
			L1739.3,146.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1735,140.1l2.2-4.1l-4.7,0.3l-0.8-1.3l6.2-0.3l2.8-1.9l0.8,1.1l-2.8,1.9l-2.7,5.5L1735,140.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1729.6,131.8l-1.8-2.7c-0.9-1.3-1.3-2.8,0.1-3.8c0.7-0.4,1.5-0.5,2.1-0.2c-0.1-0.8,0.1-1.6,1-2.2
			c1.5-1,2.9-0.2,3.9,1.2l1.9,2.9L1729.6,131.8z M1731.9,128.7l-1.1-1.7c-0.5-0.8-1.2-1.1-2-0.6c-0.7,0.5-0.7,1.2-0.2,2l1.1,1.7
			L1731.9,128.7z M1735.2,126.5l-1.2-1.8c-0.6-1-1.4-1.2-2.2-0.7c-0.8,0.5-0.9,1.2-0.2,2.3l1.1,1.7L1735.2,126.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1730.5,117.1c1.4,2.1,0.7,4.5-1.5,5.9s-4.6,1.1-6-1c-1.4-2.1-0.7-4.4,1.5-5.9
			C1726.7,114.7,1729.1,115,1730.5,117.1z M1729.6,117.8c-0.8-1.3-2.5-1.6-4.3-0.4c-1.8,1.2-2.1,2.8-1.3,4.1
			c0.8,1.3,2.5,1.6,4.3,0.4C1730,120.7,1730.4,119,1729.6,117.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1720.2,115.5l1.5,2.3l-1,0.6l-3.8-5.8l1-0.6l1.5,2.3l6.3-4.1l0.8,1.1L1720.2,115.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1716.2,109.4l1.5,2.3l-1,0.6l-3.8-5.8l1-0.6l1.5,2.3l6.3-4.1l0.8,1.1L1716.2,109.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1718,98.2c1.4,2.1,0.7,4.5-1.5,5.9c-2.2,1.5-4.6,1.1-6-1c-1.4-2.1-0.7-4.4,1.5-5.9S1716.7,96.1,1718,98.2z
			 M1717.1,98.8c-0.8-1.3-2.5-1.6-4.3-0.4c-1.8,1.2-2.1,2.8-1.3,4.1c0.8,1.3,2.5,1.6,4.3,0.4C1717.6,101.7,1717.9,100.1,1717.1,98.8
			z"
                />
                <path
                  className={classes.cls10}
                  d="M1712.8,90.5l-4.8,6l6.1-4l0.7,1.1l-7.3,4.8l-1.2-1.8l4.7-5.7l-7.1,2.1l-1.2-1.8l7.3-4.8l0.7,1.1l-6.1,4
			l7.4-2.1L1712.8,90.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1702.5,81.4c0.1,0.1,0.2,0.3,0.3,0.5l0.8,1.3l3.1-2l0.8,1.1l-7.3,4.8l-1.5-2.3c-1.3-2-1.6-3.4,0-4.5
			c1-0.7,2-0.6,2.8,0.1l2.2-3.8l0.8,1.3L1702.5,81.4z M1700.4,85.3l2.3-1.5l-0.9-1.3c-0.7-1.1-1.3-1.7-2.3-1c-1,0.7-0.7,1.6,0,2.6
			L1700.4,85.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1694.4,78.3c-1.5-2.3-1.8-4.6,1-6.4c2.8-1.8,4.8-0.7,6.3,1.6l1.3,2l-7.3,4.8L1694.4,78.3z M1695.4,77.7
			l0.5,0.8l5.4-3.5l-0.5-0.8c-1-1.5-2.2-2.7-4.6-1.1C1693.8,74.6,1694.4,76.3,1695.4,77.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1698.7,69l-1.3,0.8l-0.8-1.3l1.3-0.8L1698.7,69z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1165.3,568c3.1,0.8,5.2,2.5,4.2,6.3c-0.9,3.8-3.5,4.4-6.7,3.6l-2.7-0.7l2.4-9.9L1165.3,568z M1164.9,569.3
			l-1.1-0.3l-1.8,7.3l1.1,0.3c2,0.5,4,0.5,4.8-2.7C1168.7,570.6,1166.9,569.7,1164.9,569.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1174.4,580.8c-2.9-0.7-4.2-3.2-3.4-6.3c0.7-3,3-4.7,5.9-4c2.9,0.7,4.1,3.2,3.4,6.2
			C1179.5,579.9,1177.2,581.5,1174.4,580.8z M1174.7,579.6c1.7,0.4,3.4-0.6,4-3.1c0.6-2.5-0.4-4.1-2.1-4.6c-1.7-0.4-3.4,0.6-4,3.1
			C1171.9,577.4,1173,579.1,1174.7,579.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1185.7,579c-0.2,0-0.4-0.1-0.6-0.1l-1.7-0.4l-1,4.2l-1.6-0.4l2.4-9.9l3.1,0.8c2.7,0.6,4.1,1.6,3.6,3.9
			c-0.3,1.4-1.2,2.1-2.5,2.1l1.2,5l-1.7-0.4L1185.7,579z M1184.4,574l-0.8,3.2l1.8,0.4c1.5,0.4,2.5,0.4,2.8-1
			c0.3-1.4-0.7-1.9-2.1-2.2L1184.4,574z"
                />
                <path
                  className={classes.cls10}
                  d="M1194.2,585.5l-0.6-8.9l-2,8.3l-1.5-0.4l2.4-9.9l2.5,0.6l0.5,8.7l4.4-7.5l2.5,0.6l-2.4,9.9l-1.5-0.4l2-8.3
			l-4.7,7.7L1194.2,585.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1207.7,578.3l6.6,1.6l-0.3,1.3l-5.1-1.2l-0.7,2.8l4.8,1.2l-0.3,1.3l-4.8-1.2l-1.1,4.4l-1.6-0.4
			L1207.7,578.3z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1170,334.8c-0.2,0-0.4,0-0.7,0h-1.8v4.3h-1.6v-10.2h3.2c2.7,0,4.4,0.6,4.4,2.9c0,1.5-0.7,2.3-2,2.7l2.3,4.6
			h-1.8L1170,334.8z M1167.6,330.2v3.3h1.8c1.5,0,2.5-0.2,2.5-1.6c0-1.5-1.1-1.6-2.5-1.6H1167.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1175.5,328.9h7v1.4h-5.4v2.9h5.1v1.3h-5.1v3.2h5.4v1.4h-7V328.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1192.7,335.8c-0.4,2.2-2.1,3.5-4.4,3.5c-2.9,0-4.7-2.2-4.7-5.3c0-3.2,1.8-5.2,4.7-5.2
			c2.2,0,3.8,1.3,4.2,3.5h-1.5c-0.3-1.3-1.3-2.2-2.8-2.2c-1.7,0-3,1.4-3,3.9c0,2.5,1.3,4,3.1,4c1.5,0,2.5-0.8,2.8-2.2H1192.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1194.2,328.9h7v1.4h-5.4v2.9h5.1v1.3h-5.1v3.2h5.4v1.4h-7V328.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1204.4,339.1h-1.6v-10.2h1.6V339.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1207.4,328.9l2.7,8.4l2.6-8.4h1.7l-3.5,10.2h-1.8l-3.5-10.2H1207.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1217.2,339.1h-1.6v-10.2h1.6V339.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1225.5,339.1l-4.5-8.4v8.4h-1.6v-10.2h2.2l4.5,8.4v-8.4h1.6v10.2H1225.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1238.5,332h-1.5c-0.3-1.2-1.3-1.9-2.8-1.9c-1.8,0-3.1,1.3-3.1,3.9c0,2.5,1.2,4,3.1,4c1.3,0,2.9-0.5,2.9-2.5
			v-0.2h-2.6v-1.4h4.1v5.2h-1.2l-0.1-1.2c-0.6,1-1.8,1.4-3.2,1.4c-2.9,0-4.6-2.2-4.6-5.3c0-3.1,1.9-5.2,4.8-5.2
			C1236.5,328.7,1238.1,329.9,1238.5,332z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1630.5,107.5c-1.4-0.3-2.8-1.1-2.8-2.8c0-1.9,2-2.8,3.7-2.8c1.9,0,3.5,0.9,3.9,2.9h-1.5
			c-0.3-1.2-1.4-1.6-2.4-1.6c-0.7,0-2,0.4-2,1.4c0,0.8,0.7,1.3,1.5,1.5l1.2,0.3c1.6,0.3,3.4,0.9,3.4,3c0,2-1.9,3.1-3.9,3.1
			c-2.3,0-4-1.3-4.2-3.4h1.6c0.3,1.4,1.2,2.1,2.7,2.1c1.3,0,2.2-0.6,2.2-1.6c0-1-1-1.5-2.1-1.7L1630.5,107.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1637,102.1h7v1.4h-5.4v2.9h5.1v1.3h-5.1v3.2h5.4v1.4h-7V102.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1654.2,108.9c-0.4,2.2-2.1,3.5-4.4,3.5c-2.9,0-4.7-2.2-4.7-5.3c0-3.2,1.8-5.2,4.7-5.2
			c2.2,0,3.8,1.3,4.2,3.5h-1.5c-0.3-1.3-1.3-2.2-2.8-2.2c-1.7,0-3,1.4-3,3.9c0,2.5,1.3,4,3.1,4c1.5,0,2.5-0.8,2.8-2.2H1654.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1657.2,102.1v6.1c0,1.9,0.6,2.9,2.5,2.9c1.9,0,2.5-1.1,2.5-3v-6h1.6v5.9c0,3.1-1.2,4.4-4.1,4.4
			c-2.9,0-4.1-1.1-4.1-4.4v-6H1657.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1669.9,107.9c-0.2,0-0.4,0-0.7,0h-1.8v4.3h-1.6v-10.2h3.2c2.7,0,4.4,0.6,4.4,2.9c0,1.5-0.7,2.3-2,2.7
			l2.3,4.6h-1.8L1669.9,107.9z M1667.5,103.4v3.3h1.8c1.5,0,2.5-0.2,2.5-1.6c0-1.5-1.1-1.6-2.5-1.6H1667.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1677,112.2h-1.6v-10.2h1.6V112.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1681.4,103.4h-3.3v-1.4h8.1v1.4h-3.2v8.8h-1.6V103.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1688.4,102.1l2.7,4.8l2.7-4.8h1.8l-3.7,6.2v3.9h-1.6v-4l-3.6-6.2H1688.4z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1761.2,206.6h5.2v1.4h-6.8v-10.2h1.6V206.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1767,206c0-1.8,2.2-2.3,5.1-2.6v-0.2c0-1.3-0.7-1.8-1.6-1.8c-1,0-1.6,0.5-1.6,1.4h-1.5
			c0.1-1.6,1.4-2.6,3.2-2.6c1.9,0,3.1,0.9,3,3.2c0,0.2,0,1.5,0,1.8c0,1.1,0.1,2,0.2,2.7h-1.4c-0.1-0.3-0.1-0.5-0.1-1
			c-0.5,0.8-1.3,1.2-2.5,1.2C1768.2,208.2,1767,207.3,1767,206z M1772.2,204.4c-2.3,0.2-3.6,0.6-3.6,1.5c0,0.7,0.5,1.1,1.4,1.1
			c1.2,0,2.1-0.6,2.1-2.1V204.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1780,206.9c-0.4,0.8-1.2,1.2-2.3,1.2c-1.8,0-2.5-1.1-2.5-2.9v-4.8h1.5v4.4c0,1.1,0.2,2.1,1.5,2.1
			c1.2,0,1.8-0.9,1.8-2.4v-4.1h1.5v7.5h-1.5V206.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1787.4,202c-0.3,0-0.5,0-0.8,0c-1.1,0-1.7,0.5-1.7,2.1v4h-1.5v-7.5h1.4v1.3c0.4-0.9,1.1-1.3,2.1-1.4
			c0.1,0,0.3,0,0.4,0V202z"
                />
                <path
                  className={classes.cls10}
                  d="M1793.5,205.8h1.5c-0.3,1.2-1.5,2.4-3.4,2.4c-2.4,0-3.8-1.8-3.8-4c0-2.3,1.6-3.9,3.7-3.9
			c2.3,0,3.7,1.9,3.5,4.4h-5.7c0.2,1.4,1,2.3,2.2,2.3C1792.6,206.9,1793.2,206.5,1793.5,205.8z M1789.4,203.5h4.2c0-1.1-0.8-2-2-2
			C1790.4,201.5,1789.6,202.1,1789.4,203.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1798,208h-1.5v-10.2h1.5V208z"
                />
                <path
                  className={classes.cls10}
                  d="M1811.9,204.7c-0.4,2.2-2.1,3.5-4.4,3.5c-2.9,0-4.7-2.2-4.7-5.3c0-3.2,1.8-5.2,4.7-5.2
			c2.2,0,3.8,1.3,4.2,3.5h-1.5c-0.3-1.3-1.3-2.2-2.8-2.2c-1.7,0-3,1.4-3,3.9c0,2.5,1.3,4,3.1,4c1.5,0,2.5-0.8,2.8-2.2H1811.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1820.3,204.3c0,2.7-1.9,3.9-3.7,3.9c-1.8,0-3.7-1.2-3.7-3.9c0-2.7,1.9-3.9,3.7-3.9
			C1818.4,200.3,1820.3,201.5,1820.3,204.3z M1816.6,206.9c1.1,0,2.1-0.9,2.1-2.7c0-1.9-1-2.7-2.1-2.7c-1.1,0-2.1,0.8-2.1,2.7
			C1814.5,206.1,1815.5,206.9,1816.6,206.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1823.2,208h-1.5v-7.5h1.5v1.1c0.4-0.7,1.1-1.2,2.2-1.2c1.2,0,1.8,0.5,2.2,1.3c0.6-1,1.5-1.3,2.5-1.3
			c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1c-1.2,0-1.7,0.9-1.7,2.4v4h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1
			c-1.2,0-1.7,0.9-1.7,2.4V208z"
                />
                <path
                  className={classes.cls10}
                  d="M1835.8,208h-1.5v-7.5h1.5v1.1c0.4-0.7,1.1-1.2,2.2-1.2c1.2,0,1.8,0.5,2.2,1.3c0.6-1,1.5-1.3,2.5-1.3
			c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1c-1.2,0-1.7,0.9-1.7,2.4v4h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1
			c-1.2,0-1.7,0.9-1.7,2.4V208z"
                />
                <path
                  className={classes.cls10}
                  d="M1853.8,204.3c0,2.7-1.9,3.9-3.7,3.9c-1.8,0-3.7-1.2-3.7-3.9c0-2.7,1.9-3.9,3.7-3.9
			C1851.9,200.3,1853.8,201.5,1853.8,204.3z M1850.2,206.9c1.1,0,2.1-0.9,2.1-2.7c0-1.9-1-2.7-2.1-2.7c-1.1,0-2.1,0.8-2.1,2.7
			C1848,206.1,1849.1,206.9,1850.2,206.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1856.7,201.5c0.4-0.7,1.2-1.2,2.4-1.2c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.6-2.1
			c-1.3,0-1.9,0.9-1.9,2.4v4h-1.5v-7.5h1.5V201.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1867.7,202.6c-0.2-0.8-0.9-1.1-1.7-1.1c-0.7,0-1.5,0.3-1.5,0.9c0,0.6,0.4,0.8,1,0.9l1.1,0.2
			c1.4,0.3,2.7,0.7,2.7,2.2c0,1.5-1.4,2.4-3.2,2.4c-1.9,0-3.1-1.1-3.2-2.5h1.5c0.2,0.9,0.7,1.4,1.8,1.4c1,0,1.7-0.4,1.7-1.1
			c0-0.7-0.7-1-1.4-1.1l-1.1-0.2c-1.1-0.2-2.2-0.7-2.2-2.1c0-1.3,1.4-2.1,3.1-2.1c1.5,0,2.7,0.8,3,2.3H1867.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1876.8,197.8h1.8l3.8,10.2h-1.7l-0.8-2.2h-4.4l-0.8,2.2h-1.6L1876.8,197.8z M1876,204.4h3.4l-1.7-4.8
			L1876,204.4z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1761.2,290.1h5.2v1.4h-6.8v-10.2h1.6V290.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1767,289.4c0-1.8,2.2-2.3,5.1-2.6v-0.2c0-1.3-0.7-1.8-1.6-1.8c-1,0-1.6,0.5-1.6,1.4h-1.5
			c0.1-1.6,1.4-2.6,3.2-2.6c1.9,0,3.1,0.9,3,3.2c0,0.2,0,1.5,0,1.8c0,1.1,0.1,2,0.2,2.7h-1.4c-0.1-0.3-0.1-0.5-0.1-1
			c-0.5,0.8-1.3,1.2-2.5,1.2C1768.2,291.7,1767,290.8,1767,289.4z M1772.2,287.9c-2.3,0.2-3.6,0.6-3.6,1.5c0,0.7,0.5,1.1,1.4,1.1
			c1.2,0,2.1-0.6,2.1-2.1V287.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1780,290.4c-0.4,0.8-1.2,1.2-2.3,1.2c-1.8,0-2.5-1.1-2.5-2.9v-4.8h1.5v4.4c0,1.1,0.2,2.1,1.5,2.1
			c1.2,0,1.8-0.9,1.8-2.4v-4.1h1.5v7.5h-1.5V290.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1787.3,285.4c-0.3,0-0.5,0-0.8,0c-1.1,0-1.7,0.5-1.7,2.1v4h-1.5v-7.5h1.4v1.3c0.4-0.9,1.1-1.3,2.1-1.4
			c0.1,0,0.3,0,0.4,0V285.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1793.5,289.3h1.5c-0.3,1.2-1.5,2.4-3.4,2.4c-2.4,0-3.8-1.8-3.8-4c0-2.3,1.6-3.9,3.7-3.9
			c2.3,0,3.7,1.9,3.5,4.4h-5.7c0.2,1.4,1,2.3,2.2,2.3C1792.6,290.4,1793.2,290,1793.5,289.3z M1789.4,287h4.2c0-1.1-0.8-2-2-2
			C1790.4,285,1789.6,285.6,1789.4,287z"
                />
                <path
                  className={classes.cls10}
                  d="M1798,291.5h-1.5v-10.2h1.5V291.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1811.9,288.2c-0.4,2.2-2.1,3.5-4.4,3.5c-2.9,0-4.7-2.2-4.7-5.3c0-3.2,1.8-5.2,4.7-5.2
			c2.2,0,3.8,1.3,4.2,3.5h-1.5c-0.3-1.3-1.3-2.2-2.8-2.2c-1.7,0-3,1.4-3,3.9c0,2.5,1.3,4,3.1,4c1.5,0,2.5-0.8,2.8-2.2H1811.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1820.2,287.7c0,2.7-1.9,3.9-3.7,3.9c-1.8,0-3.7-1.2-3.7-3.9c0-2.7,1.9-3.9,3.7-3.9
			C1818.4,283.8,1820.2,285,1820.2,287.7z M1816.6,290.4c1.1,0,2.1-0.9,2.1-2.7c0-1.9-1-2.7-2.1-2.7c-1.1,0-2.1,0.8-2.1,2.7
			C1814.5,289.6,1815.5,290.4,1816.6,290.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1823.2,291.5h-1.5v-7.5h1.5v1.1c0.4-0.7,1.1-1.2,2.2-1.2c1.2,0,1.8,0.5,2.2,1.3c0.6-1,1.5-1.3,2.5-1.3
			c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1c-1.2,0-1.7,0.9-1.7,2.4v4h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1
			c-1.2,0-1.7,0.9-1.7,2.4V291.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1835.8,291.5h-1.5v-7.5h1.5v1.1c0.4-0.7,1.1-1.2,2.2-1.2c1.2,0,1.8,0.5,2.2,1.3c0.6-1,1.5-1.3,2.5-1.3
			c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1c-1.2,0-1.7,0.9-1.7,2.4v4h-1.5v-4.4c0-1.1-0.2-2.1-1.5-2.1
			c-1.2,0-1.7,0.9-1.7,2.4V291.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1853.8,287.7c0,2.7-1.9,3.9-3.7,3.9c-1.8,0-3.7-1.2-3.7-3.9c0-2.7,1.9-3.9,3.7-3.9
			C1851.9,283.8,1853.8,285,1853.8,287.7z M1850.1,290.4c1.1,0,2.1-0.9,2.1-2.7c0-1.9-1-2.7-2.1-2.7c-1.1,0-2.1,0.8-2.1,2.7
			C1848,289.6,1849,290.4,1850.1,290.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1856.7,285c0.4-0.7,1.2-1.2,2.4-1.2c1.8,0,2.5,1.2,2.5,2.9v4.7h-1.5v-4.4c0-1.1-0.2-2.1-1.6-2.1
			c-1.3,0-1.9,0.9-1.9,2.4v4h-1.5v-7.5h1.5V285z"
                />
                <path
                  className={classes.cls10}
                  d="M1867.7,286c-0.2-0.8-0.9-1.1-1.7-1.1c-0.7,0-1.5,0.3-1.5,0.9c0,0.6,0.4,0.8,1.1,0.9l1.1,0.2
			c1.4,0.3,2.7,0.7,2.7,2.2c0,1.5-1.4,2.4-3.2,2.4c-1.9,0-3.1-1.1-3.2-2.5h1.5c0.2,0.9,0.7,1.4,1.8,1.4c1,0,1.7-0.4,1.7-1.1
			c0-0.7-0.7-1-1.4-1.1l-1.1-0.2c-1.1-0.2-2.2-0.7-2.2-2.1c0-1.3,1.4-2.1,3.1-2.1c1.5,0,2.7,0.8,3,2.3H1867.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1874.2,281.3h3.7c1.9,0,3.6,0.5,3.6,2.5c0,1-0.5,1.8-1.1,2.2c0.9,0.4,1.5,1.1,1.5,2.4c0,2.2-1.6,3-3.7,3h-4
			V281.3z M1875.8,285.6h2.3c1.1,0,1.8-0.4,1.8-1.6c0-1-0.7-1.4-1.8-1.4h-2.3V285.6z M1875.8,290.2h2.5c1.4,0,2-0.6,2-1.7
			c0-1.1-0.7-1.6-2.1-1.6h-2.4V290.2z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1075.1,313.5c-0.1-3.2,0.9-5.6,4.8-5.8c3.9-0.2,5.2,2.2,5.3,5.4l0.1,2.8l-10.1,0.4L1075.1,313.5z
			 M1076.4,313.6l0,1.1l7.5-0.3l0-1.1c-0.1-2-0.6-4-3.9-3.9C1076.7,309.5,1076.3,311.5,1076.4,313.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1074.8,306.2l-0.3-7l1.4-0.1l0.2,5.4l2.9-0.1l-0.2-5.1l1.3-0.1l0.2,5.1l3.2-0.1l-0.2-5.4l1.4-0.1l0.3,7
			L1074.8,306.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1075.7,295.4l0.1,3.3l-1.4,0.1l-0.4-8.1l1.4-0.1l0.1,3.2l8.8-0.4l0.1,1.6L1075.7,295.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1074.1,289.4l-0.3-7l1.4-0.1l0.2,5.4l2.9-0.1l-0.2-5.1l1.3-0.1l0.2,5.1l3.2-0.1l-0.2-5.4l1.4-0.1l0.3,7
			L1074.1,289.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1083.6,274.4l-8.2,4.8l8.4-0.4l0.1,1.6l-10.1,0.4l-0.1-2.2l8.2-4.8l-8.4,0.4l-0.1-1.6l10.1-0.4
			L1083.6,274.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1074.5,268.1l0.1,3.3l-1.4,0.1l-0.4-8.1l1.4-0.1l0.1,3.2l8.8-0.4l0.1,1.6L1074.5,268.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1082.9,260.1l0.1,1.6l-10.1,0.4l-0.1-1.6L1082.9,260.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1082.8,253.6c0.1,3-2,4.9-5.1,5s-5.3-1.6-5.5-4.6c-0.1-2.9,1.9-4.9,5-5
			C1080.5,248.9,1082.7,250.6,1082.8,253.6z M1081.5,253.6c-0.1-1.7-1.5-3.1-4.1-3c-2.5,0.1-3.9,1.6-3.8,3.3c0.1,1.8,1.5,3.1,4.1,3
			C1080.2,256.8,1081.6,255.4,1081.5,253.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1082.1,240.9l-8.2,4.8l8.4-0.4l0.1,1.6l-10.1,0.4l-0.1-2.2l8.2-4.8l-8.4,0.4l-0.1-1.6l10.1-0.4
			L1082.1,240.9z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M879.5,553.7c2.8-1.6,5.4-1.8,7.4,1.6c2,3.4,0.5,5.6-2.3,7.2l-2.4,1.4l-5.1-8.8L879.5,553.7z M880.1,554.9
			l-1,0.6l3.8,6.5l1-0.6c1.8-1,3.3-2.4,1.6-5.3C883.8,553.2,881.8,553.9,880.1,554.9z"
                />
                <path
                  className={classes.cls10}
                  d="M895,556.7c-2.6,1.5-5.2,0.5-6.8-2.1c-1.6-2.7-1.1-5.5,1.5-7c2.5-1.5,5.2-0.6,6.8,2.1
			C898,552.4,897.5,555.2,895,556.7z M894.3,555.5c1.5-0.9,2-2.8,0.7-5c-1.3-2.2-3.2-2.7-4.7-1.8c-1.5,0.9-2,2.8-0.8,5
			C890.8,555.9,892.7,556.4,894.3,555.5z"
                />
                <path
                  className={classes.cls10}
                  d="M901.8,547.5c-0.2,0.1-0.4,0.2-0.6,0.3l-1.5,0.9l2.2,3.7l-1.4,0.8l-5.1-8.8l2.8-1.6c2.4-1.4,4.1-1.7,5.2,0.3
			c0.7,1.3,0.6,2.3-0.3,3.3l4.3,2.8l-1.5,0.9L901.8,547.5z M897.5,544.8l1.6,2.8l1.6-0.9c1.3-0.8,2.1-1.5,1.4-2.7
			c-0.7-1.3-1.8-0.9-3-0.1L897.5,544.8z"
                />
                <path
                  className={classes.cls10}
                  d="M912.4,546.3l-6.6-6l4.3,7.4l-1.4,0.8l-5.1-8.8l2.2-1.3l6.4,5.9l-2-8.4l2.2-1.3l5.1,8.8l-1.4,0.8l-4.3-7.4
			l2,8.7L912.4,546.3z"
                />
                <path
                  className={classes.cls10}
                  d="M926.2,530.1l-1.3,0.8c-0.9-0.9-2.1-1-3.4-0.3c-1.5,0.9-2,2.7-0.7,4.9c1.3,2.2,3.1,2.8,4.7,1.9
			c1.1-0.6,2.2-1.9,1.2-3.6l-0.1-0.2l-2.3,1.3l-0.7-1.2l3.6-2.1l2.6,4.5l-1.1,0.6l-0.7-1c-0.1,1.2-0.8,2.1-2,2.8
			c-2.5,1.5-5.1,0.5-6.6-2.2c-1.6-2.7-1-5.5,1.5-6.9C922.8,528.3,924.7,528.5,926.2,530.1z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1464,107.1c-0.3-0.8-1-1.1-2.1-1.1c-0.9,0.1-1.6,0.4-1.5,1.1c0,0.5,0.5,0.8,1.2,0.9l1.4,0.2
			c1.7,0.2,3.8,0.6,3.9,2.7c0.1,2.1-1.9,3.5-4.1,3.6c-2.6,0.2-4.4-1-4.9-3.2l2.4-0.1c0.3,1,1.2,1.5,2.4,1.4c0.8,0,1.7-0.4,1.7-1.2
			c0-0.7-0.8-0.9-2-1.1l-1.2-0.2c-1.7-0.2-3.2-0.9-3.3-2.8c-0.1-2.1,2-3.2,4-3.3c2-0.1,3.9,0.6,4.4,2.9L1464,107.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1469.9,105.9l-3.2,0.2l-0.1-2.1l8.9-0.5l0.1,2.1l-3.3,0.2l0.5,8l-2.4,0.1L1469.9,105.9z"
                />
                <path
                  className={classes.cls10}
                  d="M1478.2,103.3l2.6-0.2l4.4,9.9l-2.6,0.2l-0.7-1.8l-3.9,0.2l-0.5,1.8l-2.5,0.2L1478.2,103.3z M1478.6,109.7
			l2.6-0.2l-1.5-3.8L1478.6,109.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1485.5,102.8l4.4-0.3c2.2-0.1,3.9,0.3,4,2.4c0.1,0.9-0.3,1.6-1.1,2.2c1,0.3,1.7,1,1.7,2.2
			c0.1,2.3-1.4,3.2-3.9,3.4l-4.6,0.3L1485.5,102.8z M1488.2,106.7l2.1-0.1c0.8-0.1,1.3-0.5,1.2-1.1c0-0.6-0.5-1-1.4-0.9l-2.1,0.1
			L1488.2,106.7z M1488.4,110.8l2.2-0.1c1-0.1,1.5-0.5,1.5-1.2c0-0.7-0.6-1.1-1.6-1.1l-2.2,0.1L1488.4,110.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1498.4,110.1l4.9-0.3l0.1,2.1l-7.3,0.4l-0.6-10.1l2.4-0.1L1498.4,110.1z"
                />
                <path
                  className={classes.cls10}
                  d="M1503.7,101.7l7.8-0.5l0.1,2.1l-5.4,0.3l0.1,1.8l5.1-0.3l0.1,2.1l-5.1,0.3l0.1,2l5.4-0.3l0.1,2.1l-7.8,0.5
			L1503.7,101.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1525.2,103.6l-2.3,0.1c-0.3-0.7-1-1.3-2.3-1.2c-1.5,0.1-2.5,1.2-2.4,3.4c0.1,2.2,1.2,3.3,2.9,3.2
			c1.1-0.1,2.2-0.6,2.1-1.8l0-0.2l-2.4,0.1l-0.1-2l4.8-0.3l0.3,5.6l-1.8,0.1l-0.1-1.1c-0.6,0.9-1.6,1.4-3,1.5c-3,0.2-4.9-1.8-5.1-5
			c-0.2-3.2,1.8-5.3,4.9-5.5C1522.7,100.4,1524.6,101.5,1525.2,103.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1529.8,100.2l2.6-0.2l4.4,9.9l-2.6,0.2l-0.7-1.8l-3.9,0.2l-0.5,1.8l-2.5,0.2L1529.8,100.2z M1530.2,106.6
			l2.6-0.2l-1.5-3.8L1530.2,106.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1539.6,101.7l-3.2,0.2l-0.1-2.1l8.9-0.5l0.1,2.1l-3.3,0.2l0.5,8l-2.4,0.1L1539.6,101.7z"
                />
                <path
                  className={classes.cls10}
                  d="M1546.1,99.2l7.8-0.5l0.1,2.1l-5.4,0.3l0.1,1.8l5.1-0.3l0.1,2.1l-5.1,0.3l0.1,2l5.4-0.3l0.1,2.1l-7.8,0.5
			L1546.1,99.2z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1277.7,282.2c1.8-2.7,4.1-4,7.4-1.7c3.2,2.2,2.8,4.8,1,7.5l-1.6,2.3l-8.4-5.8L1277.7,282.2z M1278.8,283
			l-0.6,0.9l6.2,4.3l0.6-0.9c1.2-1.7,1.9-3.5-0.8-5.4C1281.4,280,1279.9,281.4,1278.8,283z"
                />
                <path
                  className={classes.cls10}
                  d="M1293,278.3c-1.7,2.4-4.5,2.7-7.1,1c-2.5-1.8-3.3-4.5-1.6-6.9c1.7-2.4,4.5-2.7,7-1
			C1293.9,273.1,1294.7,275.9,1293,278.3z M1291.9,277.6c1-1.4,0.6-3.4-1.5-4.8c-2.1-1.4-4-1.1-5,0.4c-1,1.5-0.7,3.4,1.4,4.8
			C1288.9,279.4,1290.9,279,1291.9,277.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1295.3,267.1c-0.1,0.2-0.2,0.4-0.4,0.5l-1,1.4l3.5,2.4l-0.9,1.3l-8.4-5.8l1.8-2.7c1.5-2.2,3-3.3,4.9-1.9
			c1.2,0.8,1.5,1.9,1.1,3.1l5.1,0.7l-1,1.5L1295.3,267.1z M1290.2,266.5l2.7,1.9l1-1.5c0.9-1.2,1.2-2.2,0.1-3c-1.2-0.8-2,0-2.8,1.2
			L1290.2,266.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1304.4,261.5l-8.6-2.6l7,4.9l-0.9,1.3l-8.4-5.8l1.5-2.1l8.3,2.6l-5.4-6.8l1.5-2.1l8.4,5.8l-0.9,1.3l-7-4.9
			l5.5,7.1L1304.4,261.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1302.5,246.3l4-5.8l1.1,0.8l-3.1,4.5l2.4,1.6l2.9-4.2l1.1,0.8l-2.9,4.2l2.6,1.8l3.1-4.5l1.1,0.8l-4,5.8
			L1302.5,246.3z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1410.3,246.1c2.9,1.3,4.6,3.4,3,6.9c-1.6,3.6-4.3,3.6-7.2,2.3l-2.5-1.2l4.2-9.2L1410.3,246.1z
			 M1409.7,247.3l-1-0.5l-3.1,6.8l1,0.5c1.8,0.8,3.8,1.3,5.2-1.8C1413.2,249.3,1411.5,248.1,1409.7,247.3z"
                />
                <path
                  className={classes.cls10}
                  d="M1416.8,260.4c-2.7-1.2-3.5-4-2.2-6.8c1.3-2.8,3.9-4,6.6-2.8c2.7,1.2,3.5,4,2.2,6.8
			C1422,260.5,1419.5,261.7,1416.8,260.4z M1417.3,259.2c1.6,0.7,3.4,0,4.5-2.3c1.1-2.3,0.4-4.1-1.2-4.9c-1.6-0.7-3.5-0.1-4.5,2.2
			C1415,256.6,1415.7,258.5,1417.3,259.2z"
                />
                <path
                  className={classes.cls10}
                  d="M1428.3,260.8c-0.2-0.1-0.4-0.2-0.6-0.3l-1.6-0.7l-1.8,3.9l-1.5-0.7l4.2-9.2l2.9,1.3
			c2.5,1.1,3.7,2.3,2.8,4.5c-0.6,1.3-1.6,1.8-2.9,1.6l0.2,5.1l-1.6-0.7L1428.3,260.8z M1428,255.6l-1.4,3l1.7,0.8
			c1.4,0.6,2.4,0.8,3-0.4c0.6-1.3-0.3-2-1.6-2.6L1428,255.6z"
                />
                <path
                  className={classes.cls10}
                  d="M1435.4,268.8l1.1-8.9l-3.6,7.8l-1.4-0.7l4.2-9.2l2.3,1.1l-1.1,8.6l5.8-6.5l2.3,1.1l-4.2,9.2l-1.4-0.7
			l3.6-7.8l-6,6.6L1435.4,268.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1452.5,265.4c2.9,1.3,4.6,3.4,3,6.9c-1.6,3.6-4.3,3.6-7.2,2.3l-2.5-1.2l4.2-9.2L1452.5,265.4z
			 M1451.9,266.6l-1-0.5l-3.1,6.8l1,0.5c1.8,0.8,3.8,1.3,5.2-1.8C1455.4,268.7,1453.7,267.4,1451.9,266.6z"
                />
              </g>
              <g>
                <path
                  className={classes.cls10}
                  d="M1538.3,157.2c3,1.2,4.8,3.1,3.3,6.8c-1.4,3.6-4.1,3.9-7.1,2.7l-2.6-1l3.7-9.4L1538.3,157.2z M1537.8,158.4
			l-1-0.4l-2.8,7l1,0.4c1.9,0.7,3.9,1.1,5.1-2C1541.4,160.3,1539.7,159.2,1537.8,158.4z"
                />
                <path
                  className={classes.cls10}
                  d="M1545.6,171.2c-2.7-1.1-3.7-3.8-2.5-6.7c1.1-2.9,3.6-4.2,6.4-3.1c2.7,1.1,3.7,3.8,2.5,6.6
			C1550.8,170.9,1548.3,172.3,1545.6,171.2z M1546.1,170c1.6,0.6,3.4-0.1,4.4-2.5c0.9-2.4,0.1-4.2-1.5-4.8c-1.7-0.7-3.4,0.1-4.4,2.5
			C1543.6,167.5,1544.4,169.3,1546.1,170z"
                />
                <path
                  className={classes.cls10}
                  d="M1557.1,170.9c-0.2-0.1-0.4-0.1-0.6-0.2l-1.6-0.6l-1.6,4l-1.5-0.6l3.7-9.4l3,1.2c2.5,1,3.9,2.1,3,4.3
			c-0.5,1.4-1.5,1.9-2.8,1.8l0.5,5.1l-1.7-0.7L1557.1,170.9z M1556.5,165.8l-1.2,3l1.7,0.7c1.4,0.6,2.4,0.7,2.9-0.6
			c0.5-1.4-0.4-1.9-1.8-2.5L1556.5,165.8z"
                />
                <path
                  className={classes.cls10}
                  d="M1564.6,178.5l0.6-8.9l-3.1,7.9l-1.5-0.6l3.7-9.4l2.4,0.9l-0.7,8.6l5.4-6.8l2.4,0.9l-3.7,9.4l-1.5-0.6
			l3.1-7.9l-5.7,7L1564.6,178.5z"
                />
                <path
                  className={classes.cls10}
                  d="M1584.4,182.8c-1.2,1.9-3.2,2.5-5.4,1.6c-2.7-1.1-3.5-3.7-2.4-6.6c1.2-3,3.6-4.2,6.3-3.1
			c2,0.8,3.1,2.6,2.7,4.8l-1.4-0.6c0.2-1.4-0.4-2.5-1.8-3c-1.6-0.6-3.3,0.2-4.3,2.5c-0.9,2.3-0.2,4.2,1.4,4.8c1.4,0.6,2.6,0.2,3.4-1
			L1584.4,182.8z"
                />
              </g>
            </g>
            <g id="barns" onClick={handleGroupClick}>
              <g
                data-name={"L01"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l01"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1054.4,116.3 1022,116.3 1022,198.2 1057.1,198.2 			"
                />
                <rect
                  x="1022"
                  y="198.2"
                  className={classes.cls9}
                  width="35"
                  height="6.9"
                />
                <path d="M1035.7,161.9v-10.6h-3.1V150c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1035.7z" />
                <path
                  className={classes.circle}
                  d="M1015.9,155.4c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S1015.9,144.4,1015.9,155.4z M1032.6,150
			c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6h-3.1V150z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1056,164.5c1.3-2.8,2-5.8,2-9.1c0-3.7-0.9-7.3-2.6-10.3c-3.7-6.9-11-11.7-19.4-11.7
			c-5.3,0-10.1,1.9-13.9,4.9c-5,4-8.1,10.2-8.1,17.1s3.2,13,8.1,17.1c3.8,3.1,8.6,4.9,13.9,4.9
			C1044.8,177.5,1052.5,172.1,1056,164.5z M1055.9,155.4c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20
			S1055.9,144.4,1055.9,155.4z"
                />
              </g>
              <g
                data-name={"L02"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l02"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1119.9,119.8 1087.5,119.8 1087.5,201.7 1122.5,201.7 			"
                />
                <rect
                  x="1087.5"
                  y="201.7"
                  className={classes.cls9}
                  width="35"
                  height="6.9"
                />
                <path
                  className={classes.circle}
                  d="M1085.2,155.4c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S1085.2,144.4,1085.2,155.4z M1100.2,160.2
			c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6
			c0,3-3,5.7-7,8.5h7.4v1.8h-9.9V160.2z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1105.2,177.5c6.5,0,12.3-2.8,16.3-7.3c3.5-3.9,5.7-9.1,5.7-14.7c0-6.2-2.5-11.7-6.6-15.7
			c-4-3.9-9.4-6.3-15.4-6.3c-7.2,0-13.6,3.5-17.6,8.9c-2.7,3.7-4.4,8.2-4.4,13.1s1.6,9.5,4.4,13.1
			C1091.5,174,1098,177.5,1105.2,177.5z M1105.2,135.4c11.1,0,20,9,20,20c0,11.1-9,20-20,20s-20-9-20-20
			C1085.2,144.4,1094.1,135.4,1105.2,135.4z"
                />
              </g>
              <g
                data-name={"L03"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l03"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="1149.5,209.3 1179.4,209.3 1181.4,201.7 1150.5,201.7 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1150.5,201.7 1143.4,120.6 1142.5,129 1149.5,209.3 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1175.6,145.1 1179.4,145.1 1180.7,138 1180.7,138 1174.9,138 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="1181.4,201.7 1175.6,145.1 1174.9,138 1180.7,138 1179.6,130 1174.1,130 1173.1,120.6 1143.4,120.6
				1150.5,201.7 			"
                />
                <path
                  className={classes.circle}
                  d="M1181.2,155.4c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S1181.2,166.5,1181.2,155.4z M1161,162.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2
			c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1
			c1.8,0.6,2.5,2,2.5,3.4C1166,160.8,1163.6,162.1,1161,162.1z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1178.1,169.5c3.2-3.8,5.1-8.7,5.1-14.1c0-6.9-3.2-13.1-8.3-17.2c-3.8-3-8.6-4.8-13.7-4.8
			c-6.3,0-12,2.7-16,7c-3.7,3.9-6,9.2-6,15c0,7.2,3.5,13.6,8.8,17.6c3.7,2.8,8.2,4.4,13.2,4.4C1168,177.5,1174.1,174.4,1178.1,169.5
			z M1161.2,175.5c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20C1181.2,166.5,1172.2,175.5,1161.2,175.5z"
                />
              </g>
              <g
                data-name={"L04"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l04"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="1241.7,181.6 1244,174.1 1240.5,174.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1212.6,212 1242.3,212 1245.4,204 1245.4,204 1214.6,204 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1214.6,204 1201.2,123.4 1200,135.3 1212.6,212 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1239.2,148.5 1244,148.5 1245.4,140.1 1237.7,140.1 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="1245.4,204 1241.7,181.6 1240.5,174.1 1244,174.1 1239.2,148.5 1237.7,140.1 1245.4,140.1
				1243,130.7 1235.9,130.7 1234.6,123.4 1201.2,123.4 1214.6,204 			"
                />
                <polygon
                  className={classes.circle}
                  points="1224.5,150.8 1219.9,156.8 1224.5,156.8 		"
                />
                <path
                  className={classes.circle}
                  d="M1203.3,155.4c0,11.1,9,20,20,20c11.1,0,20-9,20-20c0-11.1-9-20-20-20
			C1212.3,135.4,1203.3,144.4,1203.3,155.4z M1217.7,156.8l6.8-8.6h2v8.6h2.5v1.8h-2.5v3.3h-2v-3.3h-6.8V156.8z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1242.5,166.2c1.8-3.2,2.8-6.9,2.8-10.8c0-6-2.4-11.4-6.2-15.3c-4-4.1-9.6-6.7-15.8-6.7
			c-7.9,0-14.8,4.2-18.7,10.4c-2.1,3.4-3.3,7.3-3.3,11.6c0,6.8,3.1,13,8,17c3.8,3.1,8.7,5,14,5
			C1231.6,177.5,1238.7,172.9,1242.5,166.2z M1243.3,155.4c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-11.1,9-20,20-20
			C1234.4,135.4,1243.3,144.4,1243.3,155.4z"
                />
              </g>
              <g
                data-name={"L05"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l05"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1308.4,205.5 1296.3,122.5 1266.4,122.5 1277.2,205.5 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1277.2,205.5 1266.4,122.5 1264.6,138 1275.4,215.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1275.4,215.1 1305.3,215.1 1308.4,205.5 1277.2,205.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1263.9,155.4c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S1263.9,144.4,1263.9,155.4z M1283.8,154.3
			c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8h-6.4l-0.5,3.7c0.7-0.6,1.7-0.9,2.9-0.9c2.4,0,4.5,1.6,4.5,4.7
			c0,3.1-2.3,4.7-5,4.7c-3.2,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7c1.6,0,2.9-1.1,2.9-3.1
			C1286.7,155.3,1285.2,154.3,1283.8,154.3z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1302.8,166.7c2-3.3,3.1-7.2,3.1-11.3c0-6.4-2.7-12.2-7.1-16.2c-3.9-3.6-9.2-5.8-14.9-5.8
			c-5.9,0-11.3,2.3-15.2,6.1c-4.2,4-6.8,9.6-6.8,15.9c0,8.3,4.6,15.5,11.3,19.2c3.2,1.8,6.8,2.8,10.7,2.8
			C1291.9,177.5,1298.9,173.1,1302.8,166.7z M1283.9,135.4c11.1,0,20,9,20,20c0,11.1-9,20-20,20s-20-9-20-20
			C1263.9,144.4,1272.8,135.4,1283.9,135.4z"
                />
              </g>
              <g
                data-name={"L06"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l06"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1369.2,206.5 1357.1,123.4 1327.2,123.4 1338,206.5 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1338,206.5 1327.2,123.4 1325.4,139 1336.1,216.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1336.1,216.1 1366,216.1 1369.2,206.5 1338,206.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1326.9,155.4c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S1326.9,144.4,1326.9,155.4z M1347.3,148
			c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2c-2,0-3.1,2-3.2,5c0.6-1,1.7-1.8,3.5-1.8c2.5,0,4.5,1.9,4.5,4.7
			c0,2.6-1.9,4.7-4.9,4.7c-3.5,0-5.1-2.5-5.1-6.6C1341.9,151.6,1343.4,148,1347.3,148z"
                />
                <path
                  className={classes.circle}
                  d="M1347,160.5c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1
			C1344.2,159.4,1345.3,160.5,1347,160.5z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1363.8,169.6c3.2-3.8,5.1-8.7,5.1-14.1c0-7.6-3.9-14.4-9.8-18.3c-3.5-2.3-7.7-3.7-12.2-3.7
			c-7,0-13.3,3.3-17.3,8.5c-2.9,3.7-4.7,8.4-4.7,13.6c0,7.1,3.4,13.5,8.7,17.5c3.7,2.8,8.3,4.5,13.3,4.5
			C1353.7,177.5,1359.8,174.4,1363.8,169.6z M1346.9,135.4c11.1,0,20,9,20,20c0,11.1-9,20-20,20s-20-9-20-20
			C1326.9,144.4,1335.9,135.4,1346.9,135.4z"
                />
              </g>
              <g
                data-name={"L07"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l07"]
                })}
              >
                <polygon
                  className={classes.cls8}
                  points="1428.9,178.1 1428.9,188.8 1434.2,179.6 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1454.5,132.7 1454.1,144.8 1460,134.3 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1442.5,225.7 1413.9,215.1 1413.9,227.8 1441.4,237.4 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1448.9,214.7 1442.5,225.7 1441.4,237.4 1448.9,224.1 1448.9,224.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1484,155.4 1460.7,194.8 1454.5,205.2 1458.7,206.7 1483.2,163.3 1483.2,163.3 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1492.4,147 1494.5,143.3 1497.3,132.9 1489.6,146 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="1448.9,214.7 1454.7,216.6 1460,207.2 1458.7,206.7 1454.5,205.2 1460.7,194.8 1484,155.4
				1489.7,157.3 1495,147.9 1492.4,147 1489.6,146 1489.6,146 1497.3,132.9 1466.3,123.4 1464.8,126.1 1460,124.4 1454.5,132.7
				1460,134.3 1454.1,144.8 1438.9,171.4 1434.4,169.8 1428.9,178.1 1434.2,179.6 1428.9,188.8 1413.9,215.1 1442.5,225.7 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1484,155.4 1484,155.4 1483.2,163.3 1483.2,163.3 1489.1,165 1489.7,157.3 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1448.9,214.7 1448.9,214.7 1448.9,224.1 1448.9,224.1 1453.9,225.7 1454.7,216.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1453.9,225.7 1459.5,215.1 1460,207.2 1454.7,216.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1489.1,165 1493.7,155.4 1495,147.9 1489.7,157.3 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1489.6,146 1497.3,132.9 1489.6,146 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1484,155.4 1460.7,194.8 1484,155.4 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1448.9,214.7 1442.5,225.7 1448.9,214.7 			"
                />
                <path
                  className={classes.circle}
                  d="M1455.6,152.5c-11.1,0-20,9-20,20c0,11.1,9,20,20,20c11.1,0,20-9,20-20
			C1475.6,161.5,1466.7,152.5,1455.6,152.5z M1460.6,167.1c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9h-7.5v-1.8h9.6
			V167.1z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1455.6,150.5c-1.8,0-3.5,0.2-5.2,0.6c-9.1,2.2-16.1,10.1-16.8,19.7c0,0.5-0.1,1.1-0.1,1.6
			c0,12.1,9.9,22,22,22c2,0,3.9-0.3,5.7-0.8c9.4-2.5,16.3-11.1,16.3-21.3c0-1.8-0.2-3.6-0.6-5.3
			C1474.6,157.7,1465.9,150.5,1455.6,150.5z M1475.6,172.5c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-11.1,9-20,20-20
			C1466.7,152.5,1475.6,161.5,1475.6,172.5z"
                />
              </g>
              <g
                data-name={"L08"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l08"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1568.8,201.6 1538.8,191.7 1511.5,238.7 1541.7,250.5 			"
                />

                <polygon
                  className={classes.cls8}
                  points="1541.7,250.5 1511.5,238.7 1511.5,250.5 1541.7,262.9 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1541.7,262.9 1567.7,214.7 1568.8,201.6 1541.7,250.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1541.5,218.7c1.6,0,2.7-0.9,2.7-2.3c0-1.3-1.1-2.2-2.7-2.2c-1.6,0-2.7,0.8-2.7,2.2
			C1538.9,217.8,1540,218.7,1541.5,218.7z"
                />
                <path
                  className={classes.circle}
                  d="M1541.6,200.2c-11.1,0-20,9-20,20c0,11.1,9,20,20,20c11.1,0,20-9,20-20
			C1561.6,209.1,1552.6,200.2,1541.6,200.2z M1541.5,226.9c-2.8,0-5-1.5-5-4.1c0-1.3,0.5-2.7,2.2-3.4c-1.3-0.7-1.8-2-1.8-3.1
			c0-2,1.8-3.5,4.6-3.5s4.6,1.5,4.6,3.5c0,1.2-0.5,2.4-1.8,3.1c1.7,0.8,2.2,2.1,2.2,3.4C1546.6,225.4,1544.4,226.9,1541.5,226.9z"
                />
                <path
                  className={classes.circle}
                  d="M1541.5,220.1c-1.8,0-3,1-3,2.6c0,1.6,1.2,2.6,3,2.6s3-1,3-2.6C1544.5,221.1,1543.4,220.1,1541.5,220.1z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1541.6,198.2c-2.5,0-5,0.4-7.2,1.2c-8.6,3-14.8,11.2-14.8,20.8c0,1.4,0.1,2.7,0.4,4
			c1.9,10.2,10.9,18,21.6,18c1.7,0,3.4-0.2,5.1-0.6c9.7-2.3,17-11,17-21.4c0-2.5-0.4-4.9-1.2-7.1
			C1559.4,204.4,1551.2,198.2,1541.6,198.2z M1561.6,220.2c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-11.1,9-20,20-20
			C1552.6,200.2,1561.6,209.1,1561.6,220.2z"
                />
              </g>
              <g
                data-name={"L09"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l09"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1647.3,193.1 1676.9,142 1648,131.9 1617.6,181.8 			"
                />

                <polygon
                  className={classes.cls8}
                  points="1617.6,181.8 1618.7,191.3 1647.3,201.6 1647.3,193.1 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1647.3,201.6 1676.9,150.7 1676.9,142 1647.3,193.1 			"
                />
                <path
                  className={classes.circle}
                  d="M1647.1,158.1c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1c1.7,0,2.8-1.2,2.8-3.1
			C1649.9,159.3,1648.8,158.1,1647.1,158.1z"
                />
                <path
                  className={classes.circle}
                  d="M1647.3,144c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C1667.3,152.9,1658.3,144,1647.3,144z
			 M1646.8,170.7c-2.7,0-4.1-1.8-4.3-3.5h2.1c0.2,1.3,1.1,2,2.4,2c2,0,3.1-2,3.2-5c-0.6,1-1.8,1.8-3.5,1.8c-2.5,0-4.5-1.9-4.5-4.7
			c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6C1652.2,167.1,1650.7,170.7,1646.8,170.7z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1647.3,142c-2,0-4,0.3-5.9,0.8c-9.3,2.6-16.2,11.1-16.2,21.2c0,1.6,0.2,3.1,0.5,4.6
			c2.1,10,11,17.4,21.5,17.4c1.5,0,2.9-0.2,4.4-0.4c10.1-2,17.7-10.9,17.7-21.6c0-2.4-0.4-4.7-1.1-6.9
			C1665.2,148.3,1657,142,1647.3,142z M1667.3,164c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20S1667.3,152.9,1667.3,164z"
                />
              </g>
              <g
                data-name={"L10"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l10"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="1583.5,231.3 1584.1,241.4 1588.7,233.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1561.5,273.9 1562.9,280.4 1565.7,275.3 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1622.9,253.6 1629.8,241.3 1629.8,231.7 1622.9,245.4 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1602.4,297.2 1609.9,283.8 1609.9,274.1 1603.1,287.8 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1628.6,231.3 1629.8,221.1 1625,230.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1603.1,271.8 1606.8,273 1618.4,250.8 1617.9,243.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1587.9,300.5 1587.9,309.1 1596,293.6 1596,285.2 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1558.2,289.1 1559.3,298.5 1587.9,309.1 1587.9,300.5 			"
                />

                <polygon
                  className={classes.cls8}
                  points="1603.1,287.8 1603.1,287.8 1596,285.2 1596,293.6 1596,294.4 1602.4,297.2 1603.1,287.8 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1617.9,243.6 1617.9,243.6 1618.4,250.8 1618.4,250.8 1622.9,253.6 1622.9,245.4 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="1583.5,231.3 1588.7,233.1 1588.7,233.1 1584.1,241.4 1573,261.9 1568.4,260.2 1561.5,273.9
				1561.5,273.9 1565.7,275.3 1562.9,280.4 1558.2,289.1 1587.9,300.5 1596,285.2 1603.1,287.8 1603.1,287.8 1609.9,274.1
				1606.8,273 1603.1,271.8 1603.1,271.8 1617.9,243.6 1622.9,245.4 1629.8,231.7 1628.6,231.3 1625,230.1 1629.8,221.1 1600,212.2
				1595.9,219.7 1590.4,217.7 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1603.1,287.8 1609.9,274.1 1603.1,287.8 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1588.7,233.1 1583.5,231.3 1588.7,233.1 			"
                />
                <path
                  className={classes.circle}
                  d="M1594,237.8c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C1614,246.8,1605,237.8,1594,237.8z
			 M1589.5,264.2h-2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4V264.2z M1597.4,264.5c-3.6,0-5.4-2.8-5.4-7.1c0-4.3,1.7-7.1,5.4-7.1
			c3.7,0,5.4,2.8,5.4,7.1C1602.7,261.7,1601,264.5,1597.4,264.5z"
                />
                <path
                  className={classes.circle}
                  d="M1597.4,251.9c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5c2.1,0,3.3-1.8,3.3-5.5
			C1600.7,253.7,1599.5,251.9,1597.4,251.9z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1594,235.8c-2.6,0-5.2,0.5-7.5,1.3c-8.5,3.1-14.5,11.2-14.5,20.7c0,1.3,0.1,2.6,0.3,3.8
			c1.8,10.3,10.8,18.2,21.7,18.2c5.8,0,11.2-2.3,15.1-6c4.3-4,6.9-9.7,6.9-16c0-2.8-0.5-5.4-1.4-7.8
			C1611.4,241.7,1603.4,235.8,1594,235.8z M1594,277.8c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20
			C1614,268.9,1605,277.8,1594,277.8z"
                />
              </g>
              <g
                data-name={"L11"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l11"]
                })}
              >
                s{" "}
                <polygon
                  className={classes.cls9}
                  points="1673.7,251.9 1674.8,261.6 1679,253.4 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1633.7,333 1635.4,339.4 1637.9,334.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1714.1,272.4 1720.4,259.8 1720,250.2 1713.7,264.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1682.5,340.7 1682.1,331 1675.8,345 1675.6,354.5 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1675.1,329 1679.5,330.3 1709.4,269.1 1708.7,262.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1661.3,358.4 1661.6,367 1669.1,351.8 1668.7,342.7 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1718.8,249.9 1721.3,244.7 1723.7,232.1 1715.3,248.9 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1631.1,348.3 1632.6,357.7 1661.6,367 1661.3,358.4 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1668.7,342.7 1669.1,351.8 1669.1,351.9 1675.6,354.5 1675.8,345 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1708.7,262.6 1709.4,269.1 1709.5,269.8 1714.1,272.4 1713.7,264.2 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="1679,253.4 1679,253.4 1674.8,261.6 1644.6,320.5 1639.9,319 1633.7,333 1637.9,334.2 1635.4,339.4
				1631.1,348.3 1661.3,358.4 1668.7,342.7 1675.8,345 1682.1,331 1679.5,330.3 1675.1,329 1708.7,262.6 1713.7,264.2 1720,250.2
				1718.8,249.9 1715.3,248.9 1715.2,248.8 1723.7,232.1 1693.6,224.5 1685.7,239.7 1680,237.9 1673.7,251.9 			"
                />
                <polygon
                  className={classes.cls0}
                  points="1679,253.4 1673.7,251.9 1679,253.4 			"
                />
                <polygon
                  className={classes.cls0}
                  points="1715.3,248.9 1723.7,232.1 1715.2,248.8 			"
                />
                <path
                  className={classes.circle}
                  d="M1679.1,311.5c11.1,0,20-9,20-20c0-11.1-9-20-20-20c-11.1,0-20,9-20,20
			C1659.1,302.5,1668,311.5,1679.1,311.5z M1679.4,286c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6h-3.1V286z M1672.2,286
			c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6h-3.1V286z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1679.1,269.5c-3.4,0-6.5,0.8-9.4,2.1c-7.5,3.5-12.6,11.1-12.6,19.9c0,1.4,0.1,2.7,0.4,4
			c1.9,10.2,10.9,18,21.6,18c1.4,0,2.8-0.1,4.1-0.4c10.2-1.9,17.9-10.9,17.9-21.6c0-3.4-0.8-6.7-2.2-9.5
			C1695.3,274.6,1687.8,269.5,1679.1,269.5z M1659.1,291.5c0-11.1,9-20,20-20c11.1,0,20,9,20,20c0,11.1-9,20-20,20
			C1668,311.5,1659.1,302.5,1659.1,291.5z"
                />
              </g>
              <g
                data-name={"L12"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l12"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="1522.6,335.2 1523.3,345.3 1527.8,337 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1500.6,377.8 1502.1,384.3 1504.8,379.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1562,357.6 1568.9,345.2 1568.9,335.7 1562,349.3 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1541.6,401.1 1549.1,387.7 1549.1,378 1542.2,391.7 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1542.2,375.7 1545.9,377 1557.5,354.7 1557.1,347.5 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1568.9,325.1 1564.1,334 1567.7,335.2 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1527,404.5 1527,413 1535.1,397.5 1535.1,389.1 			"
                />

                <polygon
                  className={classes.cls8}
                  points="1497.3,393 1498.4,402.5 1527,413 1527,404.5 			"
                />

                <polygon
                  className={classes.cls8}
                  points="1542.2,391.7 1542.2,391.7 1535.1,389.1 1535.1,397.5 1535.1,398.3 1541.6,401.1 1542.2,391.7
				"
                />

                <polygon
                  className={classes.cls8}
                  points="1557.1,347.5 1557.1,347.5 1557.5,354.7 1557.5,354.7 1562,357.6 1562,349.3 			"
                />

                <polygon
                  className={classes.barnPath}
                  points="1504.8,379.2 1502.1,384.3 1497.3,393 1527,404.5 1535.1,389.1 1542.2,391.7 1542.2,391.7
				1549.1,378 1545.9,377 1542.2,375.7 1542.2,375.7 1557.1,347.5 1562,349.3 1568.9,335.7 1567.7,335.2 1564.1,334 1564.1,334
				1568.9,325.1 1539.1,316.2 1535.1,323.7 1529.5,321.6 1522.6,335.2 1527.8,337 1527.8,337 1523.3,345.3 1512.1,365.8
				1507.5,364.1 1500.6,377.8 1500.6,377.8 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1527.8,337 1522.6,335.2 1527.8,337 			"
                />

                <polygon
                  className={classes.cls0}
                  points="1542.2,391.7 1549.1,378 1542.2,391.7 			"
                />
                <path
                  className={classes.circleOutline}
                  d="M1533.1,338.3c-2.3,0-4.5,0.3-6.5,1c-9,2.8-15.5,11.2-15.5,21c0,1.9,0.2,3.7,0.7,5.4
			c2.4,9.5,11.1,16.6,21.3,16.6c5.3,0,10.1-1.9,13.9-5c4.9-4,8.1-10.2,8.1-17c0-2.4-0.4-4.8-1.1-7
			C1551,344.6,1542.8,338.3,1533.1,338.3z M1553.1,360.3c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-11.1,9-20,20-20
			C1544.1,340.3,1553.1,349.3,1553.1,360.3z"
                />
                <path
                  className={classes.circle}
                  d="M1533.1,340.3c-11.1,0-20,9-20,20c0,11.1,9,20,20,20c11.1,0,20-9,20-20
            	C1553.1,349.3,1544.1,340.3,1533.1,340.3z M1529.2,366.7h-2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4V366.7z"
                />
              </g>

              <g
                data-name={"L31"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l31"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="501.1,760 202.3,713.1 178.5,765.8 481.3,812.9 			"
                />
                <polygon
                  className={classes.cls8}
                  points="483.4,827.4 481.3,812.9 178.5,765.8 183.1,780.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="483.4,827.4 501.1,780.2 501.1,760 481.3,812.9 			"
                />
                <path
                  className={classes.circle}
                  d="M351,745.8c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C371,754.7,362,745.8,351,745.8z M347.3,772.5
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2
			c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1
			c1.8,0.6,2.5,2,2.5,3.4C352.3,771.1,350,772.5,347.3,772.5z M358.4,772.2h-2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4V772.2z"
                />
                <path
                  className={classes.circleOutline}
                  d="M351,743.8c-12.1,0-22,9.9-22,22s9.9,22,22,22c12.1,0,22-9.9,22-22S363.1,743.8,351,743.8z M351,785.8
			c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20C371,776.8,362,785.8,351,785.8z"
                />
              </g>
              <g
                data-name={"L32"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l32"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="469.7,858.2 170.9,811.3 147.1,864 449.9,911.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="452,925.6 449.9,911.1 147.1,864 151.8,878.4 			"
                />
                <polygon
                  className={classes.cls9}
                  points="452,925.6 469.7,878.4 469.7,858.2 449.9,911.1 			"
                />
                <path
                  className={classes.circle}
                  d="M342.7,864c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S342.7,875,342.7,864z M317,870.7
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2
			c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1
			c1.8,0.6,2.5,2,2.5,3.4C322,869.3,319.7,870.7,317,870.7z M333.2,870.4h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4V870.4z"
                />
                <path
                  className={classes.circleOutline}
                  d="M322.7,842c-12.1,0-22,9.9-22,22c0,12.1,9.9,22,22,22c12.1,0,22-9.9,22-22C344.7,851.8,334.9,842,322.7,842z
			 M302.7,864c0-11.1,9-20,20-20s20,9,20,20c0,11.1-9,20-20,20S302.7,875,302.7,864z"
                />
              </g>

              <g
                data-name={"L33"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l33"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="440,955.2 141.2,908.3 117.4,961 420.2,1008.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="420.2,1008.1 117.4,961 122,975.4 422.3,1022.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="422.3,1022.6 440,975.4 440,955.2 420.2,1008.1 			"
                />
                <path
                  className={classes.circle}
                  d="M293.4,941c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C313.4,949.9,304.4,941,293.4,941z M287.5,967.6
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2
			c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1
			c1.8,0.6,2.5,2,2.5,3.4C292.6,966.3,290.2,967.6,287.5,967.6z M298.7,967.6c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8
			c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4C303.8,966.3,301.4,967.6,298.7,967.6
			z"
                />
                <path
                  className={classes.circleOutline}
                  d="M293.4,939c-12.1,0-22,9.9-22,22c0,12.1,9.9,22,22,22c12.1,0,22-9.9,22-22C315.4,948.8,305.5,939,293.4,939z
			 M293.4,981c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20C313.4,972,304.4,981,293.4,981z"
                />
              </g>
              <g
                data-name={"L27"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l27"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="436.4,686.3 452.2,660.7 373.8,637.4 359.3,662.7 			"
                />
                <polygon
                  className={classes.cls9}
                  points="437.3,694.4 452.2,669.4 452.2,660.7 436.4,686.3 			"
                />
                <polygon
                  className={classes.cls8}
                  points="359.3,662.7 362,670.8 437.3,694.4 436.4,686.3 			"
                />
                <path
                  className={classes.circle}
                  d="M425.8,663.8c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S425.8,674.9,425.8,663.8z M406.6,658.4v-1.8
			h9.6v1.8c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9H406.6z M396,668.5c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8H396V668.5z"
                />
                <path
                  className={classes.circleOutline}
                  d="M427.8,663.8c0-4.1-1.1-8-3.1-11.3c-3.8-6.4-10.9-10.7-18.9-10.7c-3.5,0-6.7,0.8-9.7,2.2
			c-7.3,3.6-12.4,11.1-12.4,19.8c0,2.3,0.4,4.6,1,6.7c2.8,8.9,11.2,15.3,21,15.3c5.1,0,9.9-1.8,13.6-4.7
			C424.5,677.1,427.8,670.8,427.8,663.8z M385.7,663.8c0-11.1,9-20,20-20s20,9,20,20c0,11.1-9,20-20,20S385.7,674.9,385.7,663.8z"
                />
              </g>
              <g
                data-name={"L26"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l26"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="541.8,659.3 554.8,638.3 554.8,629.9 541.8,651.3 			"
                />
                <polygon
                  className={classes.cls9}
                  points="441.4,628.2 442.1,635.9 445.4,629.9 444.9,621.8 			"
                />
                <polygon
                  className={classes.cls8}
                  points="429.3,624.7 429,625.4 428.5,625.2 429.1,631.6 442.1,635.9 441.4,628.2 			"
                />
                <polygon
                  className={classes.cls8}
                  points="444.9,621.8 445.4,629.9 541.8,659.3 541.8,651.3 			"
                />
                <polygon
                  className={classes.cls8}
                  points="428.5,625.2 429,625.4 429.3,624.7 428.4,624.4 431.7,618.7 398.3,608.6 399.9,616.1 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="428.4,624.4 429.3,624.7 441.4,628.2 444.9,621.8 541.8,651.3 554.8,629.9 411,586.3 398.3,608.6
				431.7,618.7 			"
                />
                <path
                  className={classes.circle}
                  d="M488.9,626.9c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1
			C486.1,625.7,487.2,626.9,488.9,626.9z"
                />
                <path
                  className={classes.circleOutline}
                  d="M505.4,621.8c0-2.5-0.4-5-1.2-7.2c-3-8.6-11.2-14.8-20.8-14.8c-5,0-9.6,1.7-13.3,4.5
			c-5.3,4-8.7,10.4-8.7,17.5c0,1.8,0.2,3.5,0.6,5.2c2.3,9.6,11,16.8,21.4,16.8c5.7,0,10.9-2.2,14.9-5.8
			C502.6,634,505.4,628.2,505.4,621.8z M463.4,621.8c0-11.1,9-20,20-20c11.1,0,20,9,20,20c0,11.1-9,20-20,20
			C472.3,641.8,463.4,632.8,463.4,621.8z"
                />
                <path
                  className={classes.circle}
                  d="M483.4,641.8c11.1,0,20-9,20-20c0-11.1-9-20-20-20c-11.1,0-20,9-20,20C463.4,632.8,472.3,641.8,483.4,641.8z
             M477.7,615.9c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7
            c4.7-3.6,7.5-6,7.5-8.4C480.1,616.7,479.1,615.9,477.7,615.9z M489.4,619.1c2.5,0,4.5,1.9,4.5,4.7c0,2.6-1.9,4.7-4.9,4.7
            c-3.5,0-5.1-2.5-5.1-6.6c0-3.9,1.4-7.5,5.4-7.5c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2c-2,0-3.1,2-3.2,5
            C486.5,619.9,487.6,619.1,489.4,619.1z"
                />
              </g>
              <g
                data-name={"L25"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l25"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="730.8,717.6 743.8,696.6 743.8,688.2 730.8,709.6 			"
                />
                <polygon
                  className={classes.cls8}
                  points="588.7,674.5 730.8,717.6 730.8,709.6 631.4,680 620.7,677 587.2,666.9 587.3,666.8 587,666.7 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="620.7,677 631.4,680 730.8,709.6 743.8,688.2 600,644.6 587.3,666.8 587.2,666.9 			"
                />
                <path
                  className={classes.circle}
                  d="M645.5,677.5c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S645.5,666.4,645.5,677.5z M670.9,676.3
			c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8H669l-0.5,3.7c0.7-0.6,1.7-0.9,2.9-0.9c2.4,0,4.5,1.6,4.5,4.7c0,3.1-2.3,4.7-5,4.7
			c-3.1,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7c1.6,0,2.9-1.1,2.9-3.1C673.8,677.3,672.4,676.3,670.9,676.3z M659.9,671.5
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7
			c4.7-3.6,7.5-6,7.5-8.4C662.3,672.4,661.4,671.5,659.9,671.5z"
                />
                <path
                  className={classes.circleOutline}
                  d="M687.5,677.5c0-2.3-0.4-4.5-1-6.6c-2.8-8.9-11.2-15.4-21-15.4c-5.2,0-10,1.8-13.8,4.9
			c-5,4-8.2,10.2-8.2,17.2c0,2.2,0.3,4.4,0.9,6.4c2.7,9,11.1,15.6,21.1,15.6c5.4,0,10.3-1.9,14.1-5.1
			C684.5,690.3,687.5,684.2,687.5,677.5z M685.5,677.5c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20S685.5,666.4,685.5,677.5z"
                />
              </g>
              <g
                data-name={"L30"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l30"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="370.1,551.3 337.9,544.9 311.1,585.7 344.1,593.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="344.9,600.2 344.1,593.1 311.1,585.7 313.4,592.7 			"
                />
                <polygon
                  className={classes.cls9}
                  points="344.9,600.2 370.1,559.7 370.1,551.3 344.1,593.1 			"
                />
                <path
                  className={classes.circle}
                  d="M351.6,568.6c0-3.7-1.2-5.5-3.3-5.5c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5
			C350.4,574.1,351.6,572.3,351.6,568.6z"
                />
                <path
                  className={classes.circle}
                  d="M342.7,549c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C362.8,558,353.8,549,342.7,549z M336.3,575.7
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2
			c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1
			c1.8,0.6,2.5,2,2.5,3.4C341.3,574.4,339,575.7,336.3,575.7z M343,568.6c0-4.3,1.7-7.1,5.4-7.1c3.7,0,5.4,2.8,5.4,7.1
			c0,4.3-1.7,7.1-5.4,7.1C344.7,575.7,343,572.9,343,568.6z"
                />
                <path
                  className={classes.circleOutline}
                  d="M342.7,547c-2.4,0-4.8,0.4-6.9,1.1c-8.7,2.9-15.1,11.2-15.1,20.9c0,0.6,0,1.2,0.1,1.9
			c0.9,11.3,10.4,20.2,21.9,20.2c0.9,0,1.9-0.1,2.8-0.2c10.8-1.4,19.2-10.6,19.2-21.8c0-2.5-0.4-4.9-1.2-7.2
			C360.6,553.2,352.4,547,342.7,547z M362.8,569c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20S362.8,558,362.8,569z"
                />
              </g>
              <g
                data-name={"L28"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l28"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="251.8,603.1 273.6,611.6 282.4,598.7 260.4,591.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="274.5,617 283.1,604.6 282.4,598.7 273.6,611.6 			"
                />
                <polygon
                  className={classes.cls8}
                  points="251.8,603.1 253.1,608.6 274.5,617 273.6,611.6 			"
                />
                <path
                  className={classes.circle}
                  d="M244.5,606.4c1.6,0,2.7-0.9,2.7-2.3c0-1.3-1.1-2.2-2.7-2.2c-1.6,0-2.7,0.8-2.7,2.2S242.9,606.4,244.5,606.4z
			"
                />
                <path
                  className={classes.circle}
                  d="M244.5,607.7c-1.8,0-3,1-3,2.6s1.2,2.6,3,2.6s3-1,3-2.6S246.3,607.7,244.5,607.7z"
                />
                <path
                  className={classes.circle}
                  d="M239,587.8c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C259,596.8,250.1,587.8,239,587.8z M238,614.2
			h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6
			c0,3-3,5.7-7,8.5h7.4V614.2z M244.5,614.5c-2.8,0-5-1.5-5-4.1c0-1.3,0.5-2.7,2.2-3.4c-1.3-0.7-1.8-2-1.8-3.1c0-2,1.8-3.5,4.6-3.5
			s4.6,1.5,4.6,3.5c0,1.2-0.5,2.4-1.8,3.1c1.7,0.8,2.2,2.2,2.2,3.4C249.5,613,247.3,614.5,244.5,614.5z"
                />
                <path
                  className={classes.circleOutline}
                  d="M239,585.8c-12.1,0-22,9.9-22,22c0,12.1,9.9,22,22,22s22-9.9,22-22c0-0.4,0-0.8,0-1.2
			c-0.2-4.1-1.6-7.9-3.7-11.1C253.3,589.7,246.6,585.8,239,585.8z M259,607.8c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20
			S259,596.8,259,607.8z"
                />
              </g>
              <g
                data-name={"L29"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l29"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="301.8,548.1 250.5,535.7 232.5,558.5 284,573.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="285.5,582.3 302.7,557 301.8,548.1 284,573.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="285.5,582.3 284,573.1 232.5,558.5 234.6,568.1 			"
                />
                <path
                  className={classes.circle}
                  d="M247.2,554.4c0,11.1,9,20,20,20s20-9,20-20s-9-20-20-20S247.2,543.3,247.2,554.4z M272.1,556.3
			c-2.5,0-4.5-1.9-4.5-4.7c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6c0,3.9-1.4,7.5-5.4,7.5c-2.7,0-4.1-1.8-4.3-3.5h2.1
			c0.2,1.3,1.1,2,2.4,2c2,0,3.1-2,3.2-5C274.9,555.5,273.8,556.3,272.1,556.3z M256.4,559.1c4.7-3.6,7.5-6,7.5-8.4
			c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9
			V559.1z"
                />
                <path
                  className={classes.circle}
                  d="M272.5,548.5c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1s2.8-1.2,2.8-3.1
			C275.4,549.7,274.2,548.5,272.5,548.5z"
                />
                <path
                  className={classes.circleOutline}
                  d="M289.2,554.4c0-3.6-0.9-6.9-2.4-9.9c-3.6-7.2-11.1-12.1-19.6-12.1c-4.8,0-9.3,1.6-12.9,4.2
			c-5.5,4-9.1,10.5-9.1,17.8c0,2.9,0.6,5.6,1.6,8.2c3.3,8.1,11.2,13.8,20.4,13.8c4.9,0,9.4-1.6,13.1-4.3
			C285.7,568,289.2,561.6,289.2,554.4z M287.2,554.4c0,11.1-9,20-20,20s-20-9-20-20s9-20,20-20S287.2,543.3,287.2,554.4z"
                />
              </g>
              <g
                data-name={"L24"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l24"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="854.7,794.8 854.7,789.6 852.1,794 			"
                />
                <polygon
                  className={classes.barnPath}
                  points="852.1,794 854.7,789.6 838.6,784.5 836.4,788.2 759.6,763.8 745.3,794 896.3,843.1 908.9,811.1
				854.7,794.8 			"
                />
                <polygon
                  className={classes.cls9}
                  points="896.8,851 908.9,821.3 908.9,811.1 896.3,843.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="745.3,794 745.3,801.2 896.8,851 896.3,843.1 			"
                />
                <path
                  d="M800.8,790.9c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C799,787.3,800.8,788.6,800.8,790.9z"
                />
                <path d="M812.7,797.9h-2.5v3.3h-2v-3.3h-6.8v-1.7l6.8-8.6h2v8.6h2.5V797.9z M803.6,796.1h4.6v-6L803.6,796.1z" />
                <path
                  className={classes.circle}
                  d="M821.9,794.8c0-11.1-9-20-20-20c-11.1,0-20,9-20,20s9,20,20,20C812.9,814.8,821.9,805.8,821.9,794.8z
			 M812.7,797.9h-2.5v3.3h-2v-3.3h-6.8v-1.7l6.8-8.6h2v8.6h2.5V797.9z M791.3,799.5c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9V799.5z"
                />
                <polygon
                  className={classes.circle}
                  points="808.2,796.1 808.2,790.1 803.6,796.1 		"
                />
                <path
                  className={classes.circleOutline}
                  d="M823.9,794.8c0-4.2-1.2-8.2-3.3-11.6c-3.9-6.3-10.8-10.4-18.7-10.4c-3.1,0-6,0.6-8.6,1.8
			c-7.9,3.4-13.4,11.2-13.4,20.3c0,4.2,1.2,8.1,3.3,11.5c3.9,6.3,10.8,10.5,18.8,10.5c3,0,5.8-0.6,8.4-1.7
			C818.3,811.8,823.9,803.9,823.9,794.8z M781.8,794.8c0-11.1,9-20,20-20c11.1,0,20,9,20,20s-9,20-20,20
			C790.8,814.8,781.8,805.8,781.8,794.8z"
                />
              </g>
              <g
                data-name={"L23"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l23"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="771,739.1 961.7,801.7 971.6,776.8 782.9,715.1 			"
                />
                <polygon
                  className={classes.cls8}
                  points="771,739.1 771,747.1 961.7,809.2 961.7,801.7 			"
                />
                <polygon
                  className={classes.cls9}
                  points="961.7,809.2 971.6,784.5 971.6,776.8 961.7,801.7 			"
                />
                <path
                  className={classes.circle}
                  d="M840.2,769.2c11.1,0,20-9,20-20c0-11.1-9-20-20-20c-11.1,0-20,9-20,20C820.2,760.2,829.1,769.2,840.2,769.2z
			 M844.7,749.3h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2c0.2-2.5,2-4.2,4.9-4.2
			c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1c-3.2,0-4.8-2-4.9-4.4h2
			c0.2,1.6,1.2,2.8,3,2.8c1.7,0,2.9-0.9,2.9-2.5C848.4,749.9,846.8,749.3,844.7,749.3z M829.6,753.9c4.7-3.6,7.5-6,7.5-8.4
			c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9
			V753.9z"
                />
                <path
                  className={classes.circleOutline}
                  d="M862.2,749.2c0-3.1-0.7-6.1-1.8-8.7c-3.4-7.8-11.2-13.3-20.2-13.3c-4.1,0-7.9,1.1-11.1,3
			c-6.5,3.8-10.9,10.9-10.9,19c0,2,0.3,3.8,0.7,5.6c2.5,9.4,11.1,16.4,21.3,16.4c5.2,0,10-1.8,13.8-4.9
			C859,762.3,862.2,756.1,862.2,749.2z M820.2,749.2c0-11.1,9-20,20-20c11.1,0,20,9,20,20c0,11.1-9,20-20,20
			C829.1,769.2,820.2,760.2,820.2,749.2z"
                />
              </g>
              <g
                data-name={"L22"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l22"]
                })}
              >
                <polygon
                  className={classes.cls9}
                  points="1025.1,770 1034.6,746.6 1035.9,736.7 1025.1,763.8 			"
                />

                <polygon
                  className={classes.cls9}
                  points="836.9,708.3 837.1,715.1 840.2,712 840.2,702.9 			"
                />

                <polygon
                  className={classes.cls9}
                  points="859.1,680.3 859.1,674.6 855.7,679.2 			"
                />

                <polygon
                  className={classes.cls9}
                  points="1006.1,726.6 1006.1,719.9 1002.9,725.5 			"
                />
                <polygon
                  className={classes.cls9}
                  points="985.6,757 985.6,763.8 988.5,758.6 988.8,752.3 			"
                />

                <polygon
                  className={classes.cls8}
                  points="988.8,752.3 988.5,758.6 1025.1,770 1025.1,763.8 			"
                />

                <polygon
                  className={classes.cls8}
                  points="976.1,753.6 976.2,755.4 972.3,754.2 972.3,759.1 985.6,763.8 985.6,757 			"
                />

                <polygon
                  className={classes.cls8}
                  points="976.1,753.6 972.3,752.2 975.6,746.8 840.2,702.9 840.2,712 972.3,754.2 976.2,755.4 			"
                />

                <polygon
                  className={classes.cls8}
                  points="826,704.7 825.6,707.2 823.7,706.5 823.7,710.5 837.1,715.1 836.9,708.3 			"
                />

                <polygon
                  className={classes.cls8}
                  points="826,704.7 823.7,703.9 826.7,698.6 791.8,687.2 791.8,695.8 823.7,706.5 825.6,707.2 			"
                />

                <polygon
                  className={classes.barnPath}
                  points="791.8,687.2 826.7,698.6 823.7,703.9 826,704.7 836.9,708.3 840.2,702.9 975.6,746.8 972.3,752.2
				976.1,753.6 985.6,757 988.8,752.3 1025.1,763.8 1035.9,736.7 1006.1,726.6 1002.9,725.5 1006.1,719.9 991.5,715.5 988.1,720.9
				859.1,680.3 855.7,679.2 859.1,674.6 845.7,670.9 842.4,675.3 806.3,663.8 			"
                />
                <path
                  className={classes.circle}
                  d="M902.6,703.9c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S902.6,715,902.6,703.9z M888.2,698
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7
			c4.7-3.6,7.5-6,7.5-8.4C890.6,698.8,889.7,698,888.2,698z M872.1,708.6c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2
			c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9V708.6z"
                />
                <path
                  className={classes.circleOutline}
                  d="M904.6,703.9c0-3.6-0.9-7.1-2.4-10.1c-3.7-7.1-11.1-11.9-19.6-11.9c-3.7,0-7.2,0.9-10.3,2.6
			c-7,3.7-11.7,11-11.7,19.5c0,2,0.3,4,0.8,5.9c2.6,9.3,11.1,16.1,21.2,16.1c5.2,0,9.9-1.8,13.7-4.8
			C901.3,717.1,904.6,710.9,904.6,703.9z M862.6,703.9c0-11.1,9-20,20-20s20,9,20,20c0,11.1-9,20-20,20S862.6,715,862.6,703.9z"
                />
              </g>
              <g
                data-name={"L21"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l21"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="866.4,640.5 1100.9,710.7 1109.5,684.7 879.6,614.7 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1100.9,718.9 1108.1,697.2 1109.5,684.7 1100.9,710.7 			"
                />
                <polygon
                  className={classes.cls8}
                  points="866.4,640.5 866.4,648.9 1100.9,718.9 1100.9,710.7 			"
                />
                <path
                  className={classes.circle}
                  d="M911.2,646.9c0,11.1,9,20,20,20s20-9,20-20c0-11.1-9-20-20-20S911.2,635.8,911.2,646.9z M933.4,642.7v-1.3
			c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6H933.4z M922.8,651.6c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3
			h-2c-0.1-2.7,1.9-4.6,4.8-4.6c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9V651.6z"
                />
                <path
                  className={classes.circleOutline}
                  d="M953.2,646.9c0-3.8-1-7.4-2.7-10.5c-3.7-6.8-11-11.5-19.3-11.5c-3.7,0-7.1,0.9-10.2,2.5
			c-7,3.7-11.8,11-11.8,19.5c0,2.4,0.4,4.6,1.1,6.8c2.9,8.8,11.2,15.2,20.9,15.2c5.2,0,10-1.8,13.8-4.8
			C950,660,953.2,653.8,953.2,646.9z M951.2,646.9c0,11.1-9,20-20,20s-20-9-20-20c0-11.1,9-20,20-20S951.2,635.8,951.2,646.9z"
                />
              </g>
              <g
                data-name={"L20"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l20"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1078.5,507.7 1011.3,488.4 973.3,570.5 1041.9,591.6 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1040.7,600.7 1041.9,591.6 973.3,570.5 974.4,580.4 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1040.7,600.7 1077.7,514.8 1078.5,507.7 1041.9,591.6 			"
                />
                <path
                  className={classes.circle}
                  d="M1030.6,538c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5c2.1,0,3.3-1.8,3.3-5.5
			C1033.9,539.9,1032.7,538,1030.6,538z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1025.1,522c-12.1,0-22,9.9-22,22c0,12.1,9.9,22,22,22s22-9.9,22-22C1047.1,531.8,1037.3,522,1025.1,522z
			 M1025.1,564c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20C1045.1,555,1036.2,564,1025.1,564z"
                />
                <path
                  className={classes.circle}
                  d="M1025.1,524c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C1045.1,532.9,1036.2,524,1025.1,524z
             M1023.8,550.4h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2c-0.1-2.7,1.9-4.6,4.8-4.6
            c2.5,0,4.4,1.3,4.4,3.6c0,3-3,5.7-7,8.5h7.4V550.4z M1030.6,550.6c-3.6,0-5.4-2.8-5.4-7.1c0-4.3,1.7-7.1,5.4-7.1
            c3.7,0,5.4,2.8,5.4,7.1C1036,547.8,1034.3,550.6,1030.6,550.6z"
                />
              </g>
              <g
                data-name={"L19"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l19"]
                })}
              >
                <polygon
                  className={classes.cls0}
                  points="1183.2,660.8 1103.2,636.3 1103.2,636.3 			"
                />
                <polygon
                  className={classes.cls0}
                  points="1087.8,631.6 1080.2,629.3 1087.8,631.6 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1183.2,667.9 1192.1,646.6 1193,637.8 1183.2,660.8 			"
                />
                <path
                  className={classes.cls8}
                  d="M1087.5,635.8c-0.1-0.5-0.2-0.9-0.2-1.4l0,0h0c0-0.5,0-1,0.1-1.6c0.1-0.5,0.2-0.9,0.4-1.3l-7.7-2.3v7.1
				l7.8,2.4L1087.5,635.8z"
                />
                <polygon
                  className={classes.cls8}
                  points="1103.2,636.3 1103.4,643.5 1183.2,667.9 1183.2,660.8 			"
                />
                <path
                  className={classes.cls8}
                  d="M1097.2,641.6c-1,0.2-2.1,0.2-3.2-0.1c-3.3-0.6-5.7-2.9-6.4-5.7l0.5,2.9l0.3,2c0,0,2.9,6.8,8.9,6
				L1097.2,641.6L1097.2,641.6z"
                />
                <polygon
                  className={classes.cls8}
                  points="1087.3,634.5 1087.3,634.5 1087.3,634.5 			"
                />
                <path
                  className={classes.cls9}
                  d="M1103.2,636.3c-0.7,2.8-3.1,4.7-6.1,5.2l0,0v5.2v0.1c0,0,3.9-0.7,6.3-3.4l0,0L1103.2,636.3L1103.2,636.3z"
                />
                <path
                  className={classes.barnPath}
                  d="M1087.8,631.6c-0.2,0.4-0.3,0.8-0.4,1.3c-0.1,0.5-0.1,1.1-0.1,1.6c0,0,0,0,0,0c0,0.5,0.1,0.9,0.2,1.4
				c0.7,2.7,3.2,5,6.4,5.7c1.1,0.2,2.2,0.2,3.2,0.1c3-0.5,5.4-2.5,6.1-5.2l80,24.5l9.7-23l-63-18.3c0.2-0.6,0.3-1.2,0.3-1.8
				c0-4-3.6-7.2-8.1-7.2c-3.4,0-6.4,1.9-7.5,4.6l-24-7l-10.4,21.1L1087.8,631.6L1087.8,631.6z"
                />
                <path
                  className={classes.circle}
                  d="M1146.7,629.4c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1c1.7,0,2.8-1.2,2.8-3.1
			C1149.5,630.6,1148.4,629.4,1146.7,629.4z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1165.4,635.4c0-2-0.3-3.9-0.8-5.7c-2.5-9.4-11.1-16.3-21.2-16.3c-5,0-9.5,1.6-13.2,4.4
			c-5.3,4-8.8,10.4-8.8,17.6c0,2.4,0.4,4.7,1.1,6.8c2.9,8.8,11.2,15.2,20.9,15.2c5.1,0,9.8-1.7,13.5-4.6
			C1162.1,648.7,1165.4,642.4,1165.4,635.4z M1123.4,635.4c0-11.1,9-20,20-20c11.1,0,20,9,20,20c0,11.1-9,20-20,20
			C1132.4,655.4,1123.4,646.4,1123.4,635.4z"
                />
                <path
                  className={classes.circle}
                  d="M1163.4,635.4c0-11.1-9-20-20-20c-11.1,0-20,9-20,20c0,11.1,9,20,20,20
            C1154.5,655.4,1163.4,646.4,1163.4,635.4z M1134.4,631.2v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6H1134.4z M1146.3,637.2
            c-2.5,0-4.5-1.9-4.5-4.7c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6c0,3.9-1.4,7.5-5.4,7.5c-2.7,0-4.1-1.8-4.3-3.5h2.1
            c0.2,1.3,1.1,2,2.4,2c2,0,3.1-2,3.2-5C1149.1,636.5,1147.9,637.2,1146.3,637.2z"
                />
              </g>
              <g
                data-name={"L18"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l18"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1132.4,539.1 1257.6,576.6 1263.5,561.6 1140.8,525.5 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1257.6,583.2 1263.5,568.9 1263.5,561.6 1257.6,576.6 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1132.4,539.1 1133.6,545.4 1257.6,583.2 1257.6,576.6 			"
                />
                <path
                  className={classes.circle}
                  d="M1168.5,539.7c1.6,0,2.7-0.9,2.7-2.3c0-1.3-1.1-2.2-2.7-2.2c-1.6,0-2.7,0.8-2.7,2.2
			C1165.8,538.7,1166.9,539.7,1168.5,539.7z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1187,539.1c-1-11.2-10.5-19.9-21.9-19.9c-7,0-13.3,3.3-17.3,8.4c-2.9,3.7-4.7,8.5-4.7,13.6
			c0,0.4,0,0.8,0,1.2c0.6,11.6,10.2,20.9,22,20.9c7.3,0,13.7-3.5,17.7-9c2.7-3.7,4.3-8.2,4.3-13
			C1187.1,540.5,1187.1,539.8,1187,539.1z M1165.1,561.2c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20
			C1185.1,552.2,1176.2,561.2,1165.1,561.2z"
                />
                <path
                  className={classes.circle}
                  d="M1185.1,541.2c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S1185.1,552.2,1185.1,541.2z M1173.1,537.2
            c0,1.2-0.5,2.4-1.8,3.2c1.7,0.8,2.2,2.1,2.2,3.4c0,2.6-2.2,4.1-5,4.1c-2.8,0-5-1.5-5-4.1c0-1.3,0.5-2.7,2.2-3.4
            c-1.3-0.7-1.8-2-1.8-3.2c0-2,1.8-3.5,4.6-3.5S1173.1,535.1,1173.1,537.2z M1159,537h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2
            V537z"
                />
              </g>
              <g
                data-name={"L17"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l19"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1116.9,506.7 1327.4,566.5 1337.3,542.5 1131,485.1 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1327.4,573.1 1336.3,552.3 1337.3,542.5 1327.4,566.5 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1116.9,506.7 1119,513.8 1327.4,573.1 1327.4,566.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1286.5,536.8c0-11.1-9-20-20-20s-20,9-20,20s9,20,20,20S1286.5,547.8,1286.5,536.8z M1258.4,532.6v-1.3
			c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6H1258.4z M1265.2,531.3v-1.8h9.6v1.8c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9
			H1265.2z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1288.5,536.8c0-2.9-0.6-5.7-1.6-8.3c-3.3-8-11.2-13.7-20.4-13.7c-4.9,0-9.5,1.6-13.1,4.4
			c-5.4,4-8.9,10.4-8.9,17.6c0,2.2,0.3,4.4,1,6.4c2.8,9,11.2,15.6,21,15.6c5.6,0,10.6-2.1,14.5-5.5
			C1285.5,549.3,1288.5,543.4,1288.5,536.8z M1246.4,536.8c0-11.1,9-20,20-20s20,9,20,20s-9,20-20,20S1246.4,547.8,1246.4,536.8z"
                />
              </g>
              <g
                data-name={"L16"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l16"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1161.2,449.1 1389.4,522.5 1400.1,498.9 1175.9,427.9 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1389.2,529.1 1398.8,508.6 1400.1,498.9 1389.4,522.5 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1161.2,449.1 1163,456.3 1389.2,529.1 1389.4,522.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1287.2,496.9c11.1,0,20-9,20-20c0-11.1-9-20-20-20s-20,9-20,20C1267.2,488,1276.2,496.9,1287.2,496.9z
			 M1278.1,472.8v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6H1278.1z M1291.1,474.2c2.5,0,4.5,1.9,4.5,4.7c0,2.6-1.9,4.7-4.9,4.7
			c-3.5,0-5.1-2.5-5.1-6.6c0-3.9,1.4-7.5,5.4-7.5c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2c-2,0-3.1,2-3.2,5
			C1288.3,475,1289.4,474.2,1291.1,474.2z"
                />
                <path
                  className={classes.circle}
                  d="M1290.7,482c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1
			C1287.9,480.8,1289,482,1290.7,482z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1309.2,476.9c0-2.5-0.4-5-1.2-7.2c-3-8.6-11.2-14.8-20.8-14.8c-4.8,0-9.2,1.5-12.8,4.1
			c-5.6,4-9.2,10.5-9.2,17.9c0,2,0.3,4,0.8,5.9c2.6,9.3,11.1,16.1,21.2,16.1c5.2,0,10-1.8,13.8-4.9
			C1306,490,1309.2,483.8,1309.2,476.9z M1267.2,476.9c0-11.1,9-20,20-20s20,9,20,20c0,11.1-9,20-20,20S1267.2,488,1267.2,476.9z"
                />
              </g>
              <g
                data-name={"L15"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l15"]
                })}
              >
                <path
                  className={classes.barnPath}
                  d="M1180.1,391l38.7,12.5c1.6-4.3,7.4-6.2,13-4.2c5.2,1.8,8.5,6.3,7.8,10.5l0,0l0,0.1c0,0,0,0.1,0,0.1l0,0.2
				l108.5,34.9c0.1-0.2,0.1-0.4,0.2-0.6c1.5-4.4,7.4-6.3,13.1-4.3c5.7,2,9,7.1,7.5,11.5c0,0,0,0,0,0.1l39.5,12.7l10.7-23.6
				l-224.2-71L1180.1,391z"
                />
                <polygon
                  className={classes.cls9}
                  points="1408.2,471 1417.8,450.5 1419.1,440.7 1408.4,464.4 			"
                />
                <path
                  className={classes.cls8}
                  d="M1368.9,451.7c-0.1,0.2-0.2,0.4-0.2,0.6l-0.9,5.4c0,0,0,0.1-0.1,0.3l40.6,13.1l0.2-6.6L1368.9,451.7z"
                />
                <path
                  className={classes.cls8}
                  d="M1218.5,406.2c-0.1-0.9,0-1.8,0.3-2.7c0,0,0,0,0,0l-38.7-12.5l1.8,7.1l36.1,11.6l-0.6-3.8L1218.5,406.2z"
                />
                <path
                  className={classes.cls8}
                  d="M1346.9,447.3l1.1,0.2c-0.1-0.8-0.1-1.6,0.1-2.4l-108.5-34.9l-1,6.3l109,35.1c0,0,0-0.1,0-0.1L1346.9,447.3z
				"
                />
                <path
                  className={classes.cls8}
                  d="M1239.6,409.9c-0.1,0.3-0.1,0.5-0.2,0.8c-1.5,4.4-7.4,6.3-13.1,4.3c-4.5-1.6-7.6-5.2-7.9-8.8l-1-0.2l0.6,3.8
				l0.1,0.3c-0.6,8.1,10,10.2,10,10.2c7.7,1.8,10.5-3.9,10.5-3.9l0,0l1-6.3L1239.6,409.9z"
                />
                <path
                  className={classes.cls8}
                  d="M1239.7,409.7L1239.7,409.7c0,0,0,0.1,0,0.1L1239.7,409.7z"
                />
                <path
                  className={classes.cls8}
                  d="M1368.6,452.3c-1.9,3.9-7.4,5.5-12.8,3.7c-4.4-1.5-7.4-5-7.8-8.5l-1.1-0.2l0.6,4.1c0,0,0,0.1,0,0.1
				c-0.5,8,9.8,10.1,9.8,10.1c6.6,1.5,9.6-2.6,10.2-3.7c0.1-0.2,0.1-0.3,0.1-0.3L1368.6,452.3z"
                />
                <path
                  className={classes.barnPath}
                  d="M1218.5,406.2c0.3,3.6,3.3,7.2,7.9,8.8c5.7,2,11.5,0.1,13.1-4.3c0.1-0.3,0.2-0.5,0.2-0.8c0,0,0-0.1,0-0.1
				c0,0,0-0.1,0-0.1c0.7-4.1-2.5-8.6-7.8-10.5c-5.7-2-11.5-0.1-13,4.2c0,0,0,0,0,0C1218.5,404.4,1218.4,405.3,1218.5,406.2z"
                />
                <path
                  className={classes.barnPath}
                  d="M1348,447.5c0.4,3.5,3.4,6.9,7.8,8.5c5.4,1.9,10.9,0.3,12.8-3.7c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0,0,0-0.1
				c1.5-4.4-1.8-9.5-7.5-11.5c-5.7-2-11.5-0.1-13.1,4.3c-0.1,0.2-0.1,0.4-0.2,0.6C1347.9,445.8,1347.9,446.6,1348,447.5z"
                />
                <path
                  className={classes.circle}
                  d="M1323.9,417.1c0-11.1-9-20-20-20s-20,9-20,20c0,11.1,9,20,20,20S1323.9,428.1,1323.9,417.1z M1294.9,412.9
			v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6H1294.9z M1307.2,415.9c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8h-6.4l-0.5,3.7
			c0.7-0.6,1.7-0.9,2.9-0.9c2.4,0,4.5,1.6,4.5,4.7c0,3.1-2.3,4.7-5,4.7c-3.2,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7
			c1.6,0,2.9-1.1,2.9-3.1C1310.1,416.9,1308.6,415.9,1307.2,415.9z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1325.9,417.1c0-2.1-0.3-4.2-0.9-6.1c-2.7-9.2-11.1-15.9-21.1-15.9c-5.2,0-10,1.8-13.8,4.9
			c-5,4-8.2,10.2-8.2,17.2c0,2.5,0.4,4.8,1.2,7c2.9,8.7,11.2,15,20.9,15c4.8,0,9.2-1.5,12.9-4.2
			C1322.3,430.9,1325.9,424.4,1325.9,417.1z M1283.9,417.1c0-11.1,9-20,20-20s20,9,20,20c0,11.1-9,20-20,20
			S1283.9,428.1,1283.9,417.1z"
                />
              </g>

              <g
                data-name={"L14"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l14"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1094,315.5 1129.2,315.5 1124.9,226.5 1090.7,226.5 			"
                />
                <rect
                  x="1094"
                  y="315.5"
                  className={classes.cls9}
                  width="35.1"
                  height="7.2"
                />
                <polygon
                  className={classes.cls8}
                  points="1090.7,226.5 1090.1,236.3 1094,322.7 1094,315.5 			"
                />
                <path
                  className={classes.circle}
                  d="M1089.4,271c0,11.1,9,20,20,20c11.1,0,20-9,20-20c0-11.1-9-20-20-20C1098.4,251,1089.4,260,1089.4,271z
			 M1107.2,272.4l6.8-8.6h2v8.6h2.5v1.8h-2.5v3.3h-2v-3.3h-6.8V272.4z M1100.3,265.6c2-0.1,3-0.3,3.7-1.8h1.4v13.7h-2v-10.6h-3.1
			V265.6z"
                />
                <polygon
                  className={classes.circle}
                  points="1114,266.4 1109.4,272.4 1114,272.4 		"
                />
                <path
                  className={classes.circleOutline}
                  d="M1109.5,293c7.5,0,14.2-3.8,18.2-9.6c2.4-3.5,3.9-7.8,3.9-12.4c0-5.4-1.9-10.3-5.1-14.1
			c-4-4.8-10.1-7.9-16.9-7.9c-7.2,0-13.5,3.4-17.6,8.8c-2.8,3.7-4.5,8.3-4.5,13.3c0,5.6,2.1,10.6,5.5,14.5
			C1097,290.1,1102.9,293,1109.5,293z M1129.5,271c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-11.1,9-20,20-20
			C1120.5,251,1129.5,260,1129.5,271z"
                />
              </g>

              <g
                data-name={"L13"}
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["l13"]
                })}
              >
                <polygon
                  className={classes.barnPath}
                  points="1245.4,313.1 1234.9,224.9 1154.4,223.7 1160.1,312.2 			"
                />
                <polygon
                  className={classes.cls8}
                  points="1154.4,223.7 1153.5,237.2 1159,322.7 1160.1,312.2 			"
                />
                <polygon
                  className={classes.cls9}
                  points="1245.4,313.1 1160.1,312.2 1159,322.7 1243.9,324.1 			"
                />
                <path
                  className={classes.circle}
                  d="M1199.9,245.9c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20C1219.9,254.9,1210.9,245.9,1199.9,245.9z
			 M1196.1,272.4h-2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4V272.4z M1203.1,272.6c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8
			c1.7,0,2.9-0.9,2.9-2.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4
			C1208.1,271.3,1205.7,272.6,1203.1,272.6z"
                />
                <path
                  className={classes.circleOutline}
                  d="M1199.9,243.9c-12.1,0-22,9.9-22,22c0,12.1,9.9,22,22,22c12.1,0,22-9.9,22-22
			C1221.9,253.8,1212,243.9,1199.9,243.9z M1199.9,285.9c-11.1,0-20-9-20-20c0-11.1,9-20,20-20s20,9,20,20
			C1219.9,277,1210.9,285.9,1199.9,285.9z"
                />
              </g>

              <g data-name={"L31text"}>
                <path
                  d="M350.3,768.4c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C349.1,770.9,350.3,770,350.3,768.4z"
                />
                <path d="M356.4,772.2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H356.4z" />
              </g>
              <g data-name={"L26text"}>
                <path
                  d="M482.1,617.9c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C480.2,614.3,482.1,615.6,482.1,617.9z"
                />
                <path
                  d="M485.9,620.9c0.6-1,1.7-1.8,3.5-1.8c2.5,0,4.5,1.9,4.5,4.7c0,2.6-1.9,4.7-4.9,4.7c-3.5,0-5.1-2.5-5.1-6.6
			c0-3.9,1.4-7.5,5.4-7.5c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2C487.1,615.9,486,617.9,485.9,620.9z M488.9,626.9
			c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1C486.1,625.7,487.2,626.9,488.9,626.9z"
                />
              </g>
              <g data-name={"L25text"}>
                <path
                  d="M664.3,673.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C662.5,670,664.3,671.3,664.3,673.6z"
                />
                <path
                  d="M673.8,679.4c0-2.1-1.5-3.1-2.9-3.1c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8H669l-0.5,3.7c0.7-0.6,1.7-0.9,2.9-0.9
			c2.4,0,4.5,1.6,4.5,4.7c0,3.1-2.3,4.7-5,4.7c-3.1,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7C672.5,682.6,673.8,681.4,673.8,679.4
			z"
                />
              </g>
              <g data-name={"L23text"}>
                <path
                  d="M839.1,745.3c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C837.3,741.7,839.1,743,839.1,745.3z"
                />
                <path
                  d="M848.4,751.8c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C847.2,754.3,848.4,753.4,848.4,751.8z"
                />
              </g>
              <g data-name={"L22text"}>
                <path
                  d="M881.6,700c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C879.8,696.4,881.6,697.7,881.6,700z"
                />
                <path
                  d="M892.6,700c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C890.8,696.4,892.6,697.7,892.6,700z"
                />
              </g>
              <g data-name={"L21text"}>
                <path
                  d="M932.3,643c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C930.5,639.4,932.3,640.7,932.3,643z"
                />
                <path d="M936.5,653.3v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H936.5z" />
              </g>
              <g data-name={"L20text"}>
                <path
                  d="M1023.5,540.1c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C1021.6,536.5,1023.5,537.8,1023.5,540.1z"
                />
                <path
                  d="M1025.2,543.6c0-4.3,1.7-7.1,5.4-7.1c3.7,0,5.4,2.8,5.4,7.1c0,4.3-1.7,7.1-5.4,7.1C1027,550.6,1025.2,547.8,1025.2,543.6z
			 M1033.9,543.6c0-3.7-1.2-5.5-3.3-5.5c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5C1032.7,549.1,1033.9,547.2,1033.9,543.6z"
                />
              </g>
              <g data-name={"L19text"}>
                <path d="M1137.5,641.8v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1137.5z" />
                <path
                  d="M1149.7,635.5c-0.6,1-1.8,1.8-3.5,1.8c-2.5,0-4.5-1.9-4.5-4.7c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6
			c0,3.9-1.4,7.5-5.4,7.5c-2.7,0-4.1-1.8-4.3-3.5h2.1c0.2,1.3,1.1,2,2.4,2C1148.5,640.5,1149.6,638.5,1149.7,635.5z M1146.7,629.4
			c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1c1.7,0,2.8-1.2,2.8-3.1C1149.5,630.6,1148.4,629.4,1146.7,629.4z"
                />
              </g>
              <g data-name={"L18text"}>
                <path d="M1159,547.6V537h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1159z" />
                <path
                  d="M1173.1,537.2c0,1.2-0.5,2.4-1.8,3.2c1.7,0.8,2.2,2.1,2.2,3.4c0,2.6-2.2,4.1-5,4.1c-2.8,0-5-1.5-5-4.1
			c0-1.3,0.5-2.7,2.2-3.4c-1.3-0.7-1.8-2-1.8-3.2c0-2,1.8-3.5,4.6-3.5S1173.1,535.1,1173.1,537.2z M1165.5,543.7
			c0,1.6,1.2,2.6,3,2.6s3-1,3-2.6c0-1.6-1.2-2.6-3-2.6S1165.5,542.1,1165.5,543.7z M1168.5,535.2c-1.6,0-2.7,0.8-2.7,2.2
			c0,1.3,1.1,2.3,2.7,2.3c1.6,0,2.7-0.9,2.7-2.3C1171.2,536.1,1170.1,535.2,1168.5,535.2z"
                />
              </g>
              <g data-name={"L15text"}>
                <path d="M1298,423.5v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1298z" />
                <path
                  d="M1310.1,419c0-2.1-1.5-3.1-2.9-3.1c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8h-6.4l-0.5,3.7c0.7-0.6,1.7-0.9,2.9-0.9
			c2.4,0,4.5,1.6,4.5,4.7c0,3.1-2.3,4.7-5,4.7c-3.2,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7C1308.8,422.2,1310.1,421,1310.1,419z
			"
                />
              </g>
              <g data-name={"L2text"}>
                <path
                  d="M1109.7,151.6c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C1107.8,148,1109.7,149.2,1109.7,151.6z"
                />
              </g>
              <g data-name={"L3text"}>
                <path
                  d="M1163.9,158c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2
			c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C1162.7,160.5,1163.9,159.6,1163.9,158z"
                />
              </g>
              <g data-name={"L4text"}>
                <path d="M1228.9,158.6h-2.5v3.3h-2v-3.3h-6.8v-1.7l6.8-8.6h2v8.6h2.5V158.6z M1219.9,156.8h4.6v-6L1219.9,156.8z" />
              </g>
              <g data-name={"L5text"}>
                <path
                  d="M1286.7,157.4c0-2.1-1.5-3.1-2.9-3.1c-1.4,0-2.3,0.7-2.6,1.5l-1.9-0.1l0.9-7.5h8v1.8h-6.4l-0.5,3.7
			c0.7-0.6,1.7-0.9,2.9-0.9c2.4,0,4.5,1.6,4.5,4.7c0,3.1-2.3,4.7-5,4.7c-3.2,0-4.7-2.1-4.9-4.3h2c0.2,1.7,1.1,2.7,3,2.7
			C1285.4,160.5,1286.7,159.4,1286.7,157.4z"
                />
              </g>
              <g data-name={"L6text"}>
                <path
                  d="M1344,154.5c0.6-1,1.7-1.8,3.5-1.8c2.5,0,4.5,1.9,4.5,4.7c0,2.6-1.9,4.7-4.9,4.7c-3.5,0-5.1-2.5-5.1-6.6
			c0-3.9,1.4-7.5,5.4-7.5c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2C1345.2,149.5,1344,151.5,1344,154.5z M1347,160.5
			c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1C1344.2,159.4,1345.3,160.5,1347,160.5z"
                />
              </g>
              <g data-name={"L7text"}>
                <path d="M1450.9,165.3h9.6v1.8c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9h-7.5V165.3z" />
              </g>
              <g data-name={"L8text"}>
                <path
                  d="M1546.2,216.2c0,1.2-0.5,2.4-1.8,3.1c1.7,0.8,2.2,2.1,2.2,3.4c0,2.6-2.2,4.1-5,4.1c-2.8,0-5-1.5-5-4.1
			c0-1.3,0.5-2.7,2.2-3.4c-1.3-0.7-1.8-2-1.8-3.1c0-2,1.8-3.5,4.6-3.5S1546.2,214.2,1546.2,216.2z M1538.6,222.7
			c0,1.6,1.2,2.6,3,2.6s3-1,3-2.6c0-1.6-1.2-2.6-3-2.6S1538.6,221.1,1538.6,222.7z M1541.5,214.3c-1.6,0-2.7,0.8-2.7,2.2
			c0,1.3,1.1,2.3,2.7,2.3c1.6,0,2.7-0.9,2.7-2.3C1544.2,215.1,1543.1,214.3,1541.5,214.3z"
                />
              </g>
              <g data-name={"L9text"}>
                <path
                  d="M1650.1,164.1c-0.6,1-1.8,1.8-3.5,1.8c-2.5,0-4.5-1.9-4.5-4.7c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6
			c0,3.9-1.4,7.5-5.4,7.5c-2.7,0-4.1-1.8-4.3-3.5h2.1c0.2,1.3,1.1,2,2.4,2C1648.9,169.1,1650,167.1,1650.1,164.1z M1647.1,158.1
			c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1c1.7,0,2.8-1.2,2.8-3.1C1649.9,159.3,1648.8,158.1,1647.1,158.1z"
                />
              </g>
              <g data-name={"L13text"}>
                <path d="M1194.1,272.4v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1194.1z" />
                <path
                  d="M1206.1,268.5c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C1204.8,271,1206.1,270.1,1206.1,268.5z"
                />
              </g>
              <g data-name={"L14text"}>
                <path d="M1103.4,277.5v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1103.4z" />
                <path d="M1118.5,274.2h-2.5v3.3h-2v-3.3h-6.8v-1.7l6.8-8.6h2v8.6h2.5V274.2z M1109.4,272.4h4.6v-6L1109.4,272.4z" />
              </g>
              <g data-name={"L11text"}>
                <path d="M1675.3,297.9v-10.6h-3.1V286c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1675.3z" />
                <path d="M1682.5,297.9v-10.6h-3.1V286c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1682.5z" />
              </g>
              <g data-name={"L10text"}>
                <path d="M1587.6,264.2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1587.6z" />
                <path
                  d="M1592,257.4c0-4.3,1.7-7.1,5.4-7.1c3.7,0,5.4,2.8,5.4,7.1c0,4.3-1.7,7.1-5.4,7.1C1593.7,264.5,1592,261.7,1592,257.4z
			 M1600.7,257.4c0-3.7-1.2-5.5-3.3-5.5c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5C1599.5,262.9,1600.7,261.1,1600.7,257.4z"
                />
              </g>
              <g data-name={"L12text"}>
                <path d="M1527.4,366.7v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1527.4z" />
                <path
                  d="M1541.1,356.4c0,3-3,5.7-7,8.5h7.4v1.8h-9.9V365c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C1539.2,352.8,1541.1,354.1,1541.1,356.4z"
                />
              </g>
              <g data-name={"L16text"}>
                <path d="M1281.2,483.4v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1281.2z" />
                <path
                  d="M1287.7,476c0.6-1,1.7-1.8,3.5-1.8c2.5,0,4.5,1.9,4.5,4.7c0,2.6-1.9,4.7-4.9,4.7c-3.5,0-5.1-2.5-5.1-6.6
			c0-3.9,1.4-7.5,5.4-7.5c2.8,0,4.1,1.8,4.3,3.5h-2.1c-0.2-1.3-1.1-2-2.4-2C1288.9,471,1287.7,473,1287.7,476z M1290.7,482
			c1.7,0,2.8-1.2,2.8-3c0-1.8-1.2-3.1-2.8-3.1c-1.7,0-2.8,1.2-2.8,3.1C1287.9,480.8,1289,482,1290.7,482z"
                />
              </g>
              <g data-name={"L17text"}>
                <path d="M1261.5,543.2v-10.6h-3.1v-1.3c2-0.1,3-0.3,3.7-1.8h1.4v13.7H1261.5z" />
                <path d="M1265.2,529.5h9.6v1.8c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9h-7.5V529.5z" />
              </g>
              <g data-name={"L27text"}>
                <path
                  d="M405.5,659.9c0,3-3,5.7-7,8.5h7.4v1.8H396v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C403.7,656.3,405.5,657.6,405.5,659.9z"
                />
                <path d="M406.6,656.6h9.6v1.8c-3.4,3-5.4,6.8-5.7,11.9h-2.3c0.2-4.8,2.5-9,5.8-11.9h-7.5V656.6z" />
              </g>
              <g data-name={"L30text"}>
                <path
                  d="M339.3,571.6c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C338.1,574.1,339.3,573.2,339.3,571.6z"
                />
                <path
                  d="M343,568.6c0-4.3,1.7-7.1,5.4-7.1c3.7,0,5.4,2.8,5.4,7.1c0,4.3-1.7,7.1-5.4,7.1C344.7,575.7,343,572.9,343,568.6z
			 M351.6,568.6c0-3.7-1.2-5.5-3.3-5.5c-2.1,0-3.3,1.8-3.3,5.5c0,3.7,1.2,5.5,3.3,5.5C350.4,574.1,351.6,572.3,351.6,568.6z"
                />
              </g>
              <g data-name={"L28text"}>
                <path
                  d="M237.6,603.9c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C235.7,600.3,237.6,601.6,237.6,603.9z"
                />
                <path
                  d="M249.1,603.8c0,1.2-0.5,2.4-1.8,3.1c1.7,0.8,2.2,2.2,2.2,3.4c0,2.6-2.2,4.1-5,4.1c-2.8,0-5-1.5-5-4.1
			c0-1.3,0.5-2.7,2.2-3.4c-1.3-0.7-1.8-2-1.8-3.1c0-2,1.8-3.5,4.6-3.5S249.1,601.8,249.1,603.8z M241.5,610.3c0,1.6,1.2,2.6,3,2.6
			s3-1,3-2.6s-1.2-2.6-3-2.6S241.5,608.8,241.5,610.3z M244.5,601.9c-1.6,0-2.7,0.8-2.7,2.2s1.1,2.3,2.7,2.3c1.6,0,2.7-0.9,2.7-2.3
			C247.1,602.7,246.1,601.9,244.5,601.9z"
                />
              </g>
              <g data-name={"L29text"}>
                <path
                  d="M266,550.5c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C264.1,546.9,266,548.2,266,550.5z"
                />
                <path
                  d="M275.6,554.5c-0.6,1-1.8,1.8-3.5,1.8c-2.5,0-4.5-1.9-4.5-4.7c0-2.6,1.9-4.7,4.9-4.7c3.5,0,5.1,2.5,5.1,6.6
			c0,3.9-1.4,7.5-5.4,7.5c-2.7,0-4.1-1.8-4.3-3.5h2.1c0.2,1.3,1.1,2,2.4,2C274.4,559.5,275.5,557.5,275.6,554.5z M272.5,548.5
			c-1.7,0-2.8,1.2-2.8,3.1c0,1.8,1.2,3.1,2.8,3.1s2.8-1.2,2.8-3.1C275.4,549.7,274.2,548.5,272.5,548.5z"
                />
              </g>
              <g data-name={"L32text"}>
                <path
                  d="M320,866.6c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6h-2
			c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C318.8,869.1,320,868.2,320,866.6z"
                />
                <path
                  d="M332.9,860.1c0,3-3,5.7-7,8.5h7.4v1.8h-9.9v-1.7c4.7-3.6,7.5-6,7.5-8.4c0-1.4-0.9-2.2-2.4-2.2c-1.4,0-2.8,0.8-2.8,3h-2
			c-0.1-2.7,1.9-4.6,4.8-4.6C331,856.5,332.9,857.8,332.9,860.1z"
                />
              </g>
              <g data-name={"L33text"}>
                <path
                  d="M290.5,963.6c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C289.3,966.1,290.5,965.2,290.5,963.6z"
                />
                <path
                  d="M301.7,963.6c0-1.9-1.6-2.5-3.7-2.5h-0.5v-1.7h0.4c2.3,0,3.4-0.7,3.4-2.2c0-1.4-1.2-2.1-2.5-2.1c-1.7,0-2.7,1.1-2.9,2.6
			h-2c0.2-2.5,2-4.2,4.9-4.2c2.3,0,4.5,1,4.5,3.5c0,1.4-0.8,2.5-2.1,3.1c1.8,0.6,2.5,2,2.5,3.4c0,2.8-2.4,4.1-5,4.1
			c-3.2,0-4.8-2-4.9-4.4h2c0.2,1.6,1.2,2.8,3,2.8C300.5,966.1,301.7,965.2,301.7,963.6z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default React.memo(LaurelParkMap, mapPropsAreEqual);
